import React from 'react';

export default (
  <>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="132.97"
        y1="311.09"
        x2="132.17"
        y2="312.7"
        gradientTransform="translate(38.17 -300.89) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".02" stopColor="#231f20" />
        <stop offset=".08" stopColor="#231f20" stopOpacity=".86" />
        <stop offset=".35" stopColor="#231f20" stopOpacity=".38" />
        <stop offset=".64" stopColor="#231f20" stopOpacity=".09" />
        <stop offset="1" stopColor="#231f20" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clippath">
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.65,1.13.12.98.12.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01-.36.17-.36.17-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.91.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="none"
          strokeWidth="0"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient-2"
        x1="124.16"
        y1="306.72"
        x2="126.28"
        y2="309.83"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="124.16"
        y1="306.72"
        x2="126.28"
        y2="309.83"
        href="#linear-gradient"
      />
      <linearGradient
        id="Fade_to_Black"
        data-name="Fade to Black"
        x1="137.54"
        y1="306.41"
        x2="137.15"
        y2="305.16"
        gradientTransform="translate(38.17 -300.89) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#231f20" />
        <stop offset=".06" stopColor="#231f20" stopOpacity=".86" />
        <stop offset=".33" stopColor="#231f20" stopOpacity=".38" />
        <stop offset=".63" stopColor="#231f20" stopOpacity=".09" />
        <stop offset="1" stopColor="#231f20" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clippath-1">
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.66,1.13.11.98.11.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02.05,1.24.02,1.22,0,1.02-.06,2.01-.15,2.94,0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.18,0,0,0,0,0,0-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01,0,.02,0,.02l-2.17,1.31s0-.02,0-.03c-1.48.85-2.89,1.55-4.11,2.11,0,.01,0,.02,0,.02l-.36.15c-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.91.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="none"
          strokeWidth="0"
        />
      </clipPath>
      <linearGradient
        id="Fade_to_Black-2"
        data-name="Fade to Black"
        x1="139.24"
        y1="307.11"
        x2="138.56"
        y2="304.96"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-3"
        data-name="Fade to Black"
        x1="140.74"
        y1="307.2"
        x2="140.23"
        y2="305.59"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-4"
        data-name="Fade to Black"
        x1="142.46"
        y1="308.19"
        x2="141.67"
        y2="305.68"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-5"
        data-name="Fade to Black"
        x1="144.4"
        y1="309.06"
        x2="143.5"
        y2="306.19"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-6"
        data-name="Fade to Black"
        x1="145.76"
        y1="310.42"
        x2="144.92"
        y2="307.77"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-7"
        data-name="Fade to Black"
        x1="146.75"
        y1="312.29"
        x2="145.8"
        y2="309.29"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-8"
        data-name="Fade to Black"
        x1="146.88"
        y1="313.49"
        x2="146.28"
        y2="311.58"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-9"
        data-name="Fade to Black"
        x1="147.36"
        y1="315.02"
        x2="146.63"
        y2="312.7"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-10"
        data-name="Fade to Black"
        x1="147.86"
        y1="315.67"
        x2="147.46"
        y2="314.4"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-11"
        data-name="Fade to Black"
        x1="134.04"
        y1="309.01"
        x2="133.72"
        y2="308"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-12"
        data-name="Fade to Black"
        x1="135.63"
        y1="309.37"
        x2="135.22"
        y2="308.07"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-13"
        data-name="Fade to Black"
        x1="137.25"
        y1="310.07"
        x2="136.71"
        y2="308.36"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-14"
        data-name="Fade to Black"
        x1="139.21"
        y1="311.09"
        x2="138.49"
        y2="308.82"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-15"
        data-name="Fade to Black"
        x1="141.37"
        y1="312.36"
        x2="140.47"
        y2="309.52"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-16"
        data-name="Fade to Black"
        x1="142.32"
        y1="313.85"
        x2="141.5"
        y2="311.26"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-17"
        data-name="Fade to Black"
        x1="143.14"
        y1="315.53"
        x2="142.27"
        y2="312.76"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-18"
        data-name="Fade to Black"
        x1="143.28"
        y1="316.94"
        x2="142.62"
        y2="314.83"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-19"
        data-name="Fade to Black"
        x1="143.64"
        y1="318.21"
        x2="143.04"
        y2="316.28"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-20"
        data-name="Fade to Black"
        x1="144.09"
        y1="319.53"
        x2="143.48"
        y2="317.62"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="linear-gradient-4"
        x1="152.6"
        y1="320.21"
        x2="154.54"
        y2="320.21"
        gradientTransform="translate(38.17 -300.89) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#95c93d" />
        <stop offset="1" stopColor="#559d46" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-5"
        x1="156.1"
        y1="320.11"
        x2="158"
        y2="320.11"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-6"
        x1="160.12"
        y1="319.61"
        x2="162.67"
        y2="319.61"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-7"
        x1="165.35"
        y1="318.43"
        x2="168.45"
        y2="318.43"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-8"
        x1="169.89"
        y1="317.21"
        x2="172.75"
        y2="317.21"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-9"
        x1="174.42"
        y1="315.36"
        x2="177.45"
        y2="315.36"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-10"
        x1="179.19"
        y1="313.53"
        x2="182.08"
        y2="313.53"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-11"
        x1="183.6"
        y1="311.72"
        x2="186.2"
        y2="311.72"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-12"
        x1="187.85"
        y1="309.06"
        x2="190.18"
        y2="309.06"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-13"
        x1="191.95"
        y1="305.67"
        x2="194.28"
        y2="305.67"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-14"
        x1="195.52"
        y1="302.41"
        x2="197.42"
        y2="302.41"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-15"
        x1="198.5"
        y1="298.56"
        x2="200.01"
        y2="298.56"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-16"
        x1="201.11"
        y1="294.53"
        x2="202.32"
        y2="294.53"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-17"
        x1="203.04"
        y1="290.7"
        x2="203.86"
        y2="290.7"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-18"
        x1="204.14"
        y1="286.81"
        x2="204.74"
        y2="286.81"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-19"
        x1="204.57"
        y1="283.33"
        x2="205.03"
        y2="283.33"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-20"
        x1="204.21"
        y1="279.82"
        x2="204.69"
        y2="279.82"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-21"
        x1="172.19"
        y1="263.73"
        x2="173.35"
        y2="263.73"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-22"
        x1="174.71"
        y1="263.25"
        x2="175.79"
        y2="263.25"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-23"
        x1="177.38"
        y1="262.71"
        x2="178.52"
        y2="262.71"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-24"
        x1="180.51"
        y1="262.23"
        x2="182"
        y2="262.23"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-25"
        x1="183.56"
        y1="261.94"
        x2="184.95"
        y2="261.94"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-26"
        x1="186.69"
        y1="262.03"
        x2="188.27"
        y2="262.03"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-27"
        x1="189.59"
        y1="262.34"
        x2="191.48"
        y2="262.34"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-28"
        x1="193.37"
        y1="263.59"
        x2="195.13"
        y2="263.59"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-29"
        x1="196.57"
        y1="265.62"
        x2="198.3"
        y2="265.62"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-30"
        x1="199.93"
        y1="268.92"
        x2="201.27"
        y2="268.92"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-31"
        x1="201.93"
        y1="272.38"
        x2="202.89"
        y2="272.38"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="linear-gradient-32"
        x1="203.6"
        y1="276.36"
        x2="204.09"
        y2="276.36"
        href="#linear-gradient-4"
      />
      <linearGradient
        id="Fade_to_Black-21"
        data-name="Fade to Black"
        x1="153.55"
        y1="320.54"
        x2="153.63"
        y2="319.63"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-22"
        data-name="Fade to Black"
        x1="157.14"
        y1="320.65"
        x2="156.77"
        y2="319.47"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-23"
        data-name="Fade to Black"
        x1="161.52"
        y1="320.28"
        x2="161.07"
        y2="318.86"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-24"
        data-name="Fade to Black"
        x1="166.97"
        y1="318.88"
        x2="166.55"
        y2="317.53"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-25"
        data-name="Fade to Black"
        x1="171.39"
        y1="317.6"
        x2="170.99"
        y2="316.35"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-26"
        data-name="Fade to Black"
        x1="176.04"
        y1="315.89"
        x2="175.53"
        y2="314.28"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-27"
        data-name="Fade to Black"
        x1="180.72"
        y1="313.97"
        x2="180.23"
        y2="312.44"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-28"
        data-name="Fade to Black"
        x1="185.03"
        y1="312.22"
        x2="184.54"
        y2="310.69"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-29"
        data-name="Fade to Black"
        x1="189.22"
        y1="309.7"
        x2="188.65"
        y2="307.9"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-30"
        data-name="Fade to Black"
        x1="193.38"
        y1="306.5"
        x2="192.71"
        y2="304.37"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-31"
        data-name="Fade to Black"
        x1="196.82"
        y1="303.43"
        x2="196.04"
        y2="300.99"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-32"
        data-name="Fade to Black"
        x1="199.69"
        y1="299.7"
        x2="198.84"
        y2="297.03"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-33"
        data-name="Fade to Black"
        x1="202.09"
        y1="295.56"
        x2="201.32"
        y2="293.13"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-34"
        data-name="Fade to Black"
        x1="203.8"
        y1="291.63"
        x2="203.1"
        y2="289.42"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-35"
        data-name="Fade to Black"
        x1="204.9"
        y1="287.97"
        x2="204.05"
        y2="285.26"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-36"
        data-name="Fade to Black"
        x1="205.26"
        y1="284.66"
        x2="204.28"
        y2="281.55"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-37"
        data-name="Fade to Black"
        x1="204.82"
        y1="280.96"
        x2="203.97"
        y2="278.28"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-38"
        data-name="Fade to Black"
        x1="172.19"
        y1="263.72"
        x2="173.35"
        y2="263.72"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-39"
        data-name="Fade to Black"
        x1="174.71"
        y1="263.24"
        x2="175.8"
        y2="263.24"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-40"
        data-name="Fade to Black"
        x1="177.38"
        y1="262.7"
        x2="178.52"
        y2="262.7"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-41"
        data-name="Fade to Black"
        x1="180.51"
        y1="262.22"
        x2="182"
        y2="262.22"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-42"
        data-name="Fade to Black"
        x1="183.56"
        y1="261.93"
        x2="184.95"
        y2="261.93"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-43"
        data-name="Fade to Black"
        x1="186.69"
        y1="262.02"
        x2="188.27"
        y2="262.02"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-44"
        data-name="Fade to Black"
        x1="189.6"
        y1="262.32"
        x2="191.48"
        y2="262.32"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-45"
        data-name="Fade to Black"
        x1="193.37"
        y1="263.58"
        x2="195.13"
        y2="263.58"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-46"
        data-name="Fade to Black"
        x1="196.57"
        y1="265.6"
        x2="198.31"
        y2="265.6"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-47"
        data-name="Fade to Black"
        x1="199.93"
        y1="268.91"
        x2="201.27"
        y2="268.91"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-48"
        data-name="Fade to Black"
        x1="201.93"
        y1="272.37"
        x2="202.89"
        y2="272.37"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-49"
        data-name="Fade to Black"
        x1="203.6"
        y1="276.35"
        x2="204.09"
        y2="276.35"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="linear-gradient-33"
        x1="154.21"
        y1="319.95"
        x2="153.5"
        y2="320.36"
        gradientTransform="translate(38.17 -300.89) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d7df23" />
        <stop offset=".02" stopColor="#d7df23" stopOpacity=".97" />
        <stop offset=".23" stopColor="#d7df23" stopOpacity=".68" />
        <stop offset=".42" stopColor="#d7df23" stopOpacity=".44" />
        <stop offset=".6" stopColor="#d7df23" stopOpacity=".25" />
        <stop offset=".76" stopColor="#d7df23" stopOpacity=".11" />
        <stop offset=".9" stopColor="#d7df23" stopOpacity=".03" />
        <stop offset="1" stopColor="#d7df23" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-34"
        x1="157.43"
        y1="319.75"
        x2="157.1"
        y2="320.25"
        gradientTransform="translate(38.17 -300.89) rotate(20.91)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#d7df23" />
        <stop offset="0" stopColor="#d7df23" stopOpacity=".98" />
        <stop offset=".11" stopColor="#d7df23" stopOpacity=".75" />
        <stop offset=".22" stopColor="#d7df23" stopOpacity=".55" />
        <stop offset=".33" stopColor="#d7df23" stopOpacity=".38" />
        <stop offset=".44" stopColor="#d7df23" stopOpacity=".24" />
        <stop offset=".56" stopColor="#d7df23" stopOpacity=".14" />
        <stop offset=".69" stopColor="#d7df23" stopOpacity=".06" />
        <stop offset=".83" stopColor="#d7df23" stopOpacity=".01" />
        <stop offset="1" stopColor="#d7df23" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-35"
        x1="161.95"
        y1="319.15"
        x2="161.39"
        y2="319.89"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-36"
        x1="167.79"
        y1="317.67"
        x2="167.04"
        y2="318.35"
        href="#linear-gradient-33"
      />
      <linearGradient
        id="linear-gradient-37"
        x1="172.05"
        y1="316.41"
        x2="171.43"
        y2="317.2"
        href="#linear-gradient-33"
      />
      <linearGradient
        id="linear-gradient-38"
        x1="176.87"
        y1="314.41"
        x2="176.15"
        y2="315.05"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-39"
        x1="181.29"
        y1="312.66"
        x2="180.14"
        y2="313.99"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-40"
        x1="185.55"
        y1="310.67"
        x2="184.76"
        y2="311.82"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-41"
        x1="189.36"
        y1="307.96"
        x2="189.03"
        y2="308.93"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-42"
        x1="193.27"
        y1="304.62"
        x2="193.09"
        y2="305.64"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-43"
        x1="196.21"
        y1="301.56"
        x2="196.44"
        y2="302.26"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-44"
        x1="199.06"
        y1="297.66"
        x2="199.29"
        y2="298.45"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-45"
        x1="201.36"
        y1="293.96"
        x2="201.78"
        y2="294.54"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-46"
        x1="203.25"
        y1="289.99"
        x2="203.53"
        y2="290.76"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-47"
        x1="204.26"
        y1="286.38"
        x2="204.54"
        y2="286.77"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-48"
        x1="204.54"
        y1="282.78"
        x2="204.9"
        y2="283.39"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-49"
        x1="204.28"
        y1="279.23"
        x2="204.56"
        y2="280.18"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-50"
        x1="172.48"
        y1="263.53"
        x2="172.84"
        y2="263.8"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-51"
        x1="174.94"
        y1="263.05"
        x2="175.25"
        y2="263.25"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-52"
        x1="177.9"
        y1="262.62"
        x2="177.98"
        y2="262.85"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-53"
        x1="181.16"
        y1="261.99"
        x2="181.36"
        y2="262.63"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-54"
        x1="184.18"
        y1="261.76"
        x2="184.36"
        y2="262.33"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-55"
        x1="187.21"
        y1="261.71"
        x2="187.51"
        y2="262.12"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-56"
        x1="189.6"
        y1="262.32"
        x2="191.48"
        y2="262.32"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-57"
        x1="194.02"
        y1="263.16"
        x2="194.3"
        y2="263.78"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-58"
        x1="196.87"
        y1="265.1"
        x2="197.81"
        y2="265.89"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-59"
        x1="200.09"
        y1="268.42"
        x2="200.96"
        y2="269.37"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-60"
        x1="202.12"
        y1="271.73"
        x2="202.48"
        y2="272.57"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-61"
        x1="203.67"
        y1="275.53"
        x2="203.85"
        y2="276.35"
        href="#linear-gradient-34"
      />
      <linearGradient
        id="linear-gradient-62"
        x1="64.82"
        y1="47.95"
        x2="72.02"
        y2="45.64"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-63"
        x1="79.52"
        y1="47.69"
        x2="71.88"
        y2="45.91"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-64"
        x1="83.22"
        y1="48.47"
        x2="86.49"
        y2="49.5"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-65"
        x1="56.12"
        y1="55.23"
        x2="55.51"
        y2="60"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-66"
        x1="72.43"
        y1="61.44"
        x2="71.79"
        y2="66.37"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-67"
        x1="51.24"
        y1="46.78"
        x2="49.88"
        y2="51.25"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-68"
        x1="77.45"
        y1="65.8"
        x2="81.17"
        y2="64.61"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-69"
        x1="79.99"
        y1="70.22"
        x2="74.01"
        y2="71.6"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-70"
        x1="65.99"
        y1="43.45"
        x2="64.53"
        y2="43.11"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-71"
        x1="44.1"
        y1="48.83"
        x2="47.22"
        y2="37.31"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#231f20" />
        <stop offset=".76" stopColor="#231f20" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="Fade_to_Black-50"
        data-name="Fade to Black"
        x1="40.38"
        y1="41.03"
        x2="41.77"
        y2="37.52"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-51"
        data-name="Fade to Black"
        x1="41.64"
        y1="43.31"
        x2="43.2"
        y2="39.37"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-52"
        data-name="Fade to Black"
        x1="42.99"
        y1="45.67"
        x2="44.57"
        y2="41.66"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="Fade_to_Black-53"
        data-name="Fade to Black"
        x1="44.53"
        y1="47.75"
        x2="45.98"
        y2="44.09"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        href="#Fade_to_Black"
      />
      <linearGradient
        id="linear-gradient-72"
        x1="46.2"
        y1="49.5"
        x2="47.45"
        y2="46.35"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#231f20" />
        <stop offset=".01" stopColor="#231f20" stopOpacity=".99" />
        <stop offset="1" stopColor="#231f20" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-73"
        x1="48.68"
        y1="49.7"
        x2="50.39"
        y2="45.39"
        gradientTransform="translate(6.5 3.96) rotate(-.66)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#231f20" />
        <stop offset=".12" stopColor="#231f20" stopOpacity=".77" />
        <stop offset=".47" stopColor="#231f20" stopOpacity=".2" />
        <stop offset=".72" stopColor="#231f20" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clippath-2">
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.66,1.13.11.98.11.98,1.51-1.51,4.91-3.55,4.91-3.55,1.1-.42,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.09-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01,0,.02,0,.02l-.36.15c-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.32,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.91.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="none"
          strokeWidth="0"
        />
      </clipPath>
      <clipPath id="clippath-3">
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.65,1.13.12.98.12.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01-.36.17-.36.17-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.91.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="none"
          strokeWidth="0"
        />
      </clipPath>
      <image
        id="image"
        width="330"
        height="319"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUgAAAE9CAYAAABp+/tBAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEF0lEQVR4nO3dUW8aRxiG0RdwjMF1ovz/X9iLtmrtksRxoBffftpNW7UXWTCbnCONIATZRFo9mmEGkgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwQ1m99gvgu7HKeD2dhgGLtnntF8B3YZ3kzTBuJo+LJIsmkHyrjuNPw9gOjx1jJsnCCSTfYpWK4S7J+yTvktxlvK5EkkW7+f+nwH/qSN4meUjFcZeaVa6T/JnkU8ZYwmKYQTKHTZJ9agb5NjWLvE0F8pTkyzBgUQSSOaxSM8aHVCTvU5F8k7rGTrHcZoEEkrmsUm/Z3Kc2azqS2+Hx9fCcaSzhqgkkc+lldG/avE2FcpcKZc8oVxFIFkIgmcspyUuSz6kI7lJL7v1wv0dv3kwPlcNVEkjmdMwYyVPq+tqkZo+7jLHc5+uldyKUXCGBZG7HVCA/pI74fBwe653uh9T7k/epWG7zz1nlOnAFBJJz6EgekvyR5DHJc+roT2/g7DOGcjqj7J3vjqXvC+DVCCTn0svtT6mZ5GH48yYVwl52dyD3k/u74Tk3GWM5HYlwcgECyTn1kZ4O5SHJ03Dby+7tMO7ydSR79Myyx3QpDmclkFxCf5rmOTWb/D219D6kluIvqWDeZgxljz4i1MeFbjOGcv233wGzEkgu6ZQK4seMofwtyS+pYB5T0esZ5TSMfbtNRbJD2bPU4wX/HfwgBJJL648bdiifUqHsWeWHjEeEbjPGchrGHpvJz/oSs0hmJpC8lun7k8+pWB5SO96PGUPZ3xTUO9w9+tp9Hp77OWaRzEwguQb/tpnToezd7/4o4yYVzZfUMv1puBVIZmc3kGu0zrjD3YfLe4f73fB3j0l+TvLrcF8gmZ1Acs16p7r/r5u7VCQ3qZlmL8V7FxxmJZAsQR8QX6dC2d8I1GG0OcNZCCRLM71mhREAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK7MX4SPlACHmi9IAAAAAElFTkSuQmCC"
      />
      <image
        id="image-2"
        width="322"
        height="309"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUMAAAE2CAYAAAD73PB1AAAACXBIWXMAAC4jAAAuIwF4pT92AAADXUlEQVR4nO3cS24bRxSG0Y+ULFlWHCdGJtn/crKFDDILgiAP2IYfMi1mUF0gzTEpKvI5QKHYTQ5aQOHHvV0FFQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/1ercz8AT85qb2yX0d4Mj9LFuR+AJ2VVratn1VV1uVxPApFHSxhyTKvGmnpe3S7zs0Ygbg9+B4+KMOSYZmV4Vd1UL5b5ul2FuN9Gd/AZzkYYcmwzEK8bleEcV+3a51ktrhtrcN3XgXgYmHByFhvHtmqE3W31qnrZCMPZKm+rz9WHZb4/uN5vp+/3fmMzhpO6PPcD8ORsq00j3PYrvu/aVYjrRsDN7+6qd9XH5Xq21J+qN8v9TfVlubdJIHJkwpBTuG8E3LYRYHfLvG2sudlCXy+jve9nK72u3ld/VW/bBePv1b8JRI5MGHIq+y3uXSPMPizzy2XMozdXy5i70LfLde2qwvfVb9Uvy+fNw/wZfCuEIac03/V9aYTXx0Y7fFN9X71e5ptGEL5qhOB873hd/bBcv6n+zKYfJyIMObX9TZNNozJ81wi3fxqBN4Pvx+rn6qfGsZz5jrHq7+rXZf78cI/Pt8JuMg9trrl5rOai3WHtF43q8LYRkJfL/W2jNf6jEYafGlUnHI0w5JwOzxZetAvAw7OHcyNmkyDkBIQhj83hmpz/8GGygwwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHzlPy4PZBNCwUoyAAAAAElFTkSuQmCC"
      />
      <image
        id="image-3"
        width="329"
        height="307"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAAE0CAYAAAC///EEAAAACXBIWXMAAC4jAAAuIwF4pT92AAADl0lEQVR4nO3b22obVxiG4VeyY0e4mzSm27PQO+j9X0zpUSFt403T2rEd92DNINkHbU3GMYHngWHNSELoYPj4/jWoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+daun/gHwAKuddVXd7hywKOHIp2BVrau9ad2f1qvqXfU+AcnC9p/6B8C/mEPxWXVYbaqD6Xpd/VmdVhcJRxYmHFnK6t56e2996HftNe7P59Vn1RfTcdi2NT6rLhvt0XjNooQjS1i1bXd702vXjdC66b/H3t1gnZvipvq8+rJ60QjI59Nn3jVao20hHo1w5EPNwfhV9UMjyGqE12/VWdt2d9PdhjeH4X7b/cTDRii+qI6n88303k31d/W2OmmM1JfZc+QRCEeWcFB9U/1U/dgIuN+rn6tfqz+m67eNRjkH2brt2HzYuB831cvGCL1pBOhNY1/xvHozfd9pI4AvE4w8AuHIUuZ9wqPq2+q7RpM8qV5XvzQC8rJtg1xPnz9uG4Q1muheY1/xvBGqZ41gPGkbitdpjTwSezZ8qN2x+lWjOb5qjMWH03HVCMZ5xL5u2yDn/cV1Y2TeHcPPGy3xrPprOi4SinwEwpElzAF51AjFrxsPUo6r76fX5wc0V23DcW6QTdenjZZ5Nn32orst8f883IFFCEeWsvtw5aDRGI8ajXIemd/vHLf3zq8bYXg2rXMQzi2xhCIfkXBkafM9Nf+jZd4/nP/uV3dDbj6fg/L+yCwQeRLCkcf20HtMGAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPC0/gETSY1i/JppuAAAAABJRU5ErkJggg=="
      />
      <image
        id="image-4"
        width="382"
        height="346"
        href="data:image/png;base64,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"
      />
      <image
        id="image-5"
        width="399"
        height="341"
        href="data:image/png;base64,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"
      />
      <image
        id="image-6"
        width="446"
        height="488"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAb0AAAHoCAYAAADdbTEAAAAACXBIWXMAAC4jAAAuIwF4pT92AAATHElEQVR4nO3d4VLcOBaA0UvIJLP7/g87sxDYH6BC3L6SDW27m+acqq4GQjJsVXa+ubIsRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAr3F36B+CmzP4+PR/2UwAM/Lz0D8DNuIt1/xElfsDFmPTYwl16Rff+nF4RwgdciEmPc/Wx+/H66v9j6jkintI7wEXcX/oH4EvLwbtPrxZBgKtg0mMLffB+xtu016a7u4h4fP28fR3gcKLHufop7694+Tt1H29xe3z9vqfXF8DFiB6fla/jtSmvhe8u3iL3HBF/Yv0OT4BdiB7nyNfzqui1Jc5+g4slTuAiRI9z9JPez3iL3l+vv/4nXoL3GKe3NAAcTvQ412jSa7/2J+pbGUx7wOFEj8+q7s9rm1j6v1dV8AAuQvQ4V7WZpf29eo634FnaBC5O9PiMfkNKe7Wb0dv9ehEv1/Pa1/PxZACHEz0+q49YP+nl6PXLm4IHXJTocY488fVLnBEv0WvX+XL8bGIBDid6nKu6Sb0/keUhTs/iNPEBFyF6bCVPeu2g6XbfXj/x9UudJj7gMKLHlvLTFtp9ev+LiH9f39vk5zFDwOFEj8+qHg4b8RK6dttCi9tDvI9eO6klQvyAA4ken9EeEdQ+7sPXpr2/uu9/jLfg9dHzNHXgUKLHOfrgtUcHtSD2S5zt/M32yo8Zeop6agTYlOjxWTl4bXprMeuPJYvXX/8Tb9Hr45Z/b4T4ATsQPc7VR+8x3uL2HG+TXv8U9T5sbSn0If2+auoTQeBs98vfAqV84HR7cvqv7tVuV8i3KuTTXO4WXpHene4CfIro8Vk5XP1h0zl6bZmzv0E9v/Kv5ZveRyGsYiiIQEn0OFd1GsvPwes+fc998Ws/0/tSLPs4CiIwJXqco1qqHIVtFMS/Bq9ZNHMQqyjeFe+CCN+cjSycI+/efIiIf+I0VC06v7qvtet/f0fEf15/37/x/ib2h3h/q8OfON0p+jx5n71i8D46DNtGGrgBose5WkRa9PK0l6esX69f/x0vf/9+x0v4+qPK+uhV4WuvFr7+4/z6aAxHURRDuAGix7n6ae8xTjef9N/XotOC1099v+Nl4utDV0WvD99Teq++NorhZ6fEiOUYCiFcKdFjCy0WES8R+Dfq4PU3qP8db7cztFeLX3/P32P6OE96OXpLn1cxXDspPhefR/GxEMKVEj220P6F3gLSfz3fvN4vW/6Ot+t8bTLsp79qasuBeh58TxW/2ddHoVw7KfYf9//bR7ETQbgA0WMr7V/if4qv9xNbu3b333hZzmzh66e+9iy+FsGn169Xy4zV+Z/VFLcUwjxF5s9H8a0iPFsqbT93ngZFEA4gemypD18OUQtJi94/8bLE+Xe8D18fv+pWgnbNMIpfq2LYB2gUwhy7vJy6JohrJsTZtUIRhAOIHlvrlzrb523aazs8W/R+p1e7jaE6waXfIJNPcak2z8xiOAphFbbqPYdxdt0x7zRdG0IRhB24GZe9VGdztmt17fUr6rM68waX+zi9FWL0Gt2gXt18PloerYI1i1+1w3QphktLo6OdoxECCJ8meuwtn6HZP3KonchSvc+Cl48wGx1p1v/e0fFl0b33E+Fss0yOXvV6iHkQ14Zwdl2wfwdWED2O0AemWqKcHS1WvVfRGx1bVoVwaSrsVUuj1USYY1bda7gUwsf0540CWN0y0b8DA6LHkXL8qimwuk5XRTJPfmtDmL93FMLZ0mh/3XLtJPhQfJzDOIriaBoUQPgg0eMSRoc9V6/q8OgcyGpaHE18eQl1KYR5ebQ6oHq0LLpmOfQhvfIRbH0M80QpgPBBoselVQ+Jbe+jOC5Ngp8J4UcmwvbnV8/7661dEm3x+1/3Xp1BWk2D7c+ZBVD84JXocU3y38d8f157n02Fa0JYPfboI9cH11wjrEI4upG+j18fuj58+eP+fXQu6ZqNMPCtiB5fwSiGW4fwsxNhdV1xNBVWIcw38I+WPWevtU+kED++NdHjq9ojhLN7AT+yJFo9BLeK4ehJFH0A2w39o/j9m97zBNgvg+b45QME4OaJHrfk3BDONsqsuVcwR696GnwO4iiAEe93hva3QvQB7KOXAziaAqtbISLEj29A9Lh1W4dwtjSaw9eHLp848yvGAWzLoe1VnRjTIpanvv6VY5gDWF3/ixA/bpjo8R2tDWH7ON9TOArhUgD72P1KX8sTYvsz+gg2LYD5GmAVv3+ijmHeBCN+fAuiBy8+GsIqhrOl0Gq5s4pgngj7abBfCm3yNcAqfv/EW/xyBKvpT/y4WfeX/gHgSo2e2VctNfbv+Sby0S7MvPz4ketw7Wdrse3jOgpqdaB3Duno5vvGfyTz5YkerFeFsP986VFFs9sQ1m5EaX9e/8/Pk2a/VDoL32xDzeiGe/jSRA/OM5oI8zP7RmdzLt2KkD+eTX/V7tPRbtK8k3R0CHeE8HFDRA+2N1sarc7kHC2HView5KPJcvyaNqVVG2vy7tLqpJl+4oObIXqwv6Unty9NgUvnclZHkI2WPme3VvSvauKr/jfBlyJ6cKw1y6HV9cDqYOocxBy//tSViHkA+/jl80Srg7T7d/gyRA8ua2kKHD2eaOnpC6MdnxHLS59LJ8U4u5MvS/TgelTPwVsz/S09iLZfQm2TX3V/YfUEiaWnRfQ/L1w90YPrNFsG7R9JtPSA2vaer/eNrvn1S5+jQ7Hzz9V/Ha6a6MHXUMVm7RJoftpC+/4+VC1ua58LmH+W/utwtUQPvo614cs7QKspMC93tvv8qscvVffrCR9fkujB19THpV+yHE19VfSWNrrkCFY/Q45f/tngqogefG2z+I2WPvub4vN1vv5aXz/xjc7j7H8G4ePqiR7chqX45d2ffQj7a3w5fBGn1/VGOzmr3adwVUQPbstH4veYPq92dlYP1f1o/OBqiB7cpip+T8UrPxopX9+LOH14brXUmW+u7+MHV0P04LY9p49H1/v68I2mvY+GTwC5OqIH38PotJd+x2cfwxyqWfjyn1dNfXAVRA++pypMs+XN9l6Fr/ozczyFj6sgevD9zM74rCa2iPmmlj58eWnTtMdVET2gusl8FKrZbs72+6sNM6Y+roLoAbMjxdqrX+KcbWipljirCRIuQvSAZhS/9rUcvup8zryRpXrBxYge0JudqtLCl6e9apkz3xtYHXdm4uNwogdko/DlzSz5MUR5mTMHz7U9Lk70gMrsKLFqeXO0zFmdANO+DocTPWCkCl/1zL38lPUqfPnkF8ucXIToATOz2xb64OXwtd9bHXbdL3mO/hmwC9EDPmL0dPXZtb3nmJ/xadrjMKIHLMkPjh0tb1bLnNUS5+xxRrAr0QPWuksfj6a9fC5ntcSZH2UkfBxC9ICPqMKX43effm027Y2e6gC7ED1gjdES5yh61aaWPnr9U9tNexxG9IBzrL2FYTTptfiZ9jiE6AEflae+iNPreqY9rpLoAeeoHjBbXd9r+tsXqvA5qYVdiR7wUbNbGPqb1mc3rFfRyye1wOZEDzjHaNKbndTS377wGPUyZ4TwsQPRA7ZQbWj5Ge8nvmpTS570bGhhV6IHfNZsmfO+eLXwVTs5+12cwsduRA/Ywuip6vfxNvFV095jeuXwwaZED9hKXuLsp7w+fBGnS5yja3vCx6ZEDzhX3syyFL0f8f5ostG0J3psTvSALVXh+xnvN7X0S5xtsnsIS5wcQPSALSxNe3348u0LLXRV+Ex7bEr0gK314asmvf6UljbRPcZL9Fr4RI9diB6wldmN6j/jdNqLmF/X609ogU2IHrCHpei1aW+0i9O0xy5+LH8LwIdUIXuI0+XL5zjd8FLdzA6bMekBW1vazJI3tLRdnH0g8y7OCNMeGzDpAVvr78HrJ77R7syI0zjmE1wiTH1sQPSAPfThq6a4x3iLXrXE2R9l1ocPziJ6wNb6Z+L1B0u34D3E+92ZEacbX/KkJ3psQvSAveQlzv5pCo/x/nrd6Mnr7dW+B84iesBeqmlv9tDYKnZ50hM+ziJ6wB7yEucofPl8zdGUB5vwFwrYUzXtVU9Kjzi91eGueMFZfl76BwBuXjXt9dF76r53FDzYhEkP2NNsmbN6fFDe0CJ8bEr0gL08d+999Pr4zcIneGxO9IA9VeGrJr3qul611AlnET1gb9USZ37lSW92y4L48WmiBxxhFr3ZpCd2bEr0gL09F69R+EbX9mATogccZe20F/E+dKOP4cNED9jTbAdnfjL67Hl5Jj42IXrA3nL41k57sDknsgBHWBO8/H2wOZMecJSlDS1ix+5EDzhSjl0VQtMeuxE94GhLoRM7diN6wKWMYld9LIZsQvSAo6yZ8J7T98OmRA+4JEucHEr0gEtYGzXxY1OiB1zK2qVO4WMzogccYXat7iNLmwLIWUQPuJRqmhudzCJ2bEL0gCNVERuFDzYnesAlzSY78WNzogcc4S6996prfLPP4dNED7iEHD87NzmE6AFHmz0M1oks7Er0gKP0Tz+/i9Onobuex+5EDzjaXfFqPH2BXYkecJRR6Jq1oRM/Pk30gCNUy5pV/GYPmY0QPM7089I/AHDzRtfxRtfz+tg9heCxIZMesKe74uPZlPeUXq7nsSnRA46Qp7v83k91osduRA84yppdm0+D9wjhYwOu6QF7y4HL0cvX80x67MakBxxl6XaFUeyc0sJmTHrAEZaWNiNOp7xZ/OBTTHrAnmZLm6OTWCxtshvRA/Yyu47Xq67l9eGLED42InrA3qrbFPpNLHnCM+mxG9EDjlAFrxkFrw9fhPixARtZgD0tnbmZp7w/cTrpRQgeGzHpAXtbc8j0bOcmbEb0gD1Uofvx+sqTXjXluabHLkQP2FMVvzXLm/manvCxCdED9tJfz/sR7ye9plra7MMHm7KRBdhTC17/ns/crGJnwmMXJj1ga/k6XjXptfDl4FW7N4WPzYgesIdqA0te3sxLmzl4sDnLm8CWqtjdv776Ka9f2vwTJjwOYtIDtrZmyosYn7cpfOxG9ICtjO7LW3N/XnsJHbsSPWBLffDu4/3SZnU9rw+ek1jYnegBW+inuGrKm21g8dBYDiN6wFaq2H10yrNzk12JHnCu6lre0rJmvp5nWZNDiB6whdHmlf5WhYh11/LEj92IHnCO2X15o+DNljZhV6IHfNZoWXPpNoXRlNe+x5THbkQPOFde1szX8yLWTXlix+5ED/iM2TW8HLyIesrLjxAy5bE70QM+arZbc+0tCqY8LkL0gM+qljWrm9FHtyg4Z5PDecoC8BHVsmY/4bX3iNMnKTzGeAMLHEL0gLWWljWrxweNdmz2h0ub8jiM5U1gjaVzNfMtCi1k+TpefpqC4HEo0QPWWjvlRbhFgSslesCSLXdrmvK4KNf0gJnZQ2FHjw3K0es3sAgdF2XSA9aYPUFhdhP6Y/e5WxS4OJMeMDK6PaGa8CLeglZtXPEUBa6C6AGVNYdJ5xvQl05eETwuTvSAbM11vHwNL+/WbNfxcvDgokQP6PX3483CV0VvtKxpyuNqiB6QrY1de2/BW/NEdLgo0QOafB2vD1//tYjTJc1+h6bgcbVED4iYL2fm2LX3fB3vKb0Ej6sjekB1Ha/Fr5rw+qBVR4sJHldL9OB7WxO8iPcBy8uao9gJHldH9OD7mu3UvEvfm2NWLWM+pe+FqyN68L1Vm1f64OUJrw/eaClT8Lhaogff01LsmrykOVrGNN3xJYgefD85bn3wRrs0+ymvCp3g8SWIHnxPebqb3ZZQRS9/H3wJogffy2zKi3gfsNESptjxZYkefD+jDSuRPp+FTvD4kkQPvq8+XHdRh810x02pdmsBt6vatDLatWm64+aIHnwva4NXvcOXJ3rw/cyCF3G6mQVuhujB97T0/32xA+DmjE5iAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgOv0fHAHa97ee/BEAAAAASUVORK5CYII="
      />
      <image
        id="image-7"
        width="360"
        height="440"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWkAAAG2CAYAAAC9E3e0AAAACXBIWXMAAC4jAAAuIwF4pT92AAAMP0lEQVR4nO3d3XITRxMG4LYNJCT3f6VfCOEv/g6sLvW2ZldyvJIl7fNUTRmwoXwAbzU9PTMRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANv1sFtwFv5ywest/bt5vth3wSYIaXidh/axem4f4c2ENJyuB3T/9/McgpqVfXjvbwBuRA3mY33o593nBTVvJqThdA9xGNJzYSygWYWQhtdbCmrhzKqENBzXK+iHiHgsn6sBrc3Bqh6Pfwmwk+Fcg/qx/VoMPsJ/ppKG0/QqOoN59HkVNasR0rCsV8ijkO7tDgHNaoQ0nGauxRGxn4/W3mB1QhqOG20a5npu6993+h65U0Ia5s1NdTxGxFPsK+d/d+uUgy7wKkIaTtMr6L5x+Bj7oM6v15fmzYQ0LBu1OGol/dy+LkIlzYqENBxXg/ppt2pPOuJwVhpWIaRhbGmzMIM6K+nn0I/mTIQ0LOtB/RTTkP43XkK69qgFNasR0jBvqYp+Kp8fTXYIalYhpOHQ0thdD+mI6bSHlgerEtIwb67NkSti2uro4WwMjzcT0jC2VEV/iP0NknXTsBPQvJmQhkNzm4UfditH8PqGIaxOSMNU3fib2zCs43dzFbQqmlW49B8O1Up61IvuG4f9NjxYjUoa9vpUR7Y1aqsj2x0R+9G7Gs6CmlUJaZgabRj2gM7/gfb/iQpnViek4dBcQOeqd3akfq+0wGYVetLwYtTqqCH9MfaVdD1tGCGUOSOVNOzNtToyoHNFTF9gUUFzNkIapo61Op5iOno3anPUTUR4E+0OGB9eqW2OXNmPHrU6ehUtoFmFShpejI6AZzDXfnQtbOaqaAHNalTScLyS7uN3vYrOh2gFNKtTSbN19dRgnej4GIetjqf2ezOgVdKcjUoa5ic6Pu1WDemsuHsVnQtWpZJmy5ZG7kZV9FI4q6Y5C5U0W9f70BnMtYr+GNNNw2NBDasR0mzVUhU9Cuh6610G9K8Q0JyZdgdbNpro+NRWtjvqU1i1ihbUnJWQZovmRu56q+NTHF5NWqvouYAW1KxGSLNVo4AeVdEfY3/rXQ/oHtIRApqV6UmzRXNV9KeI+C2mIV1fBo84bHP8ChMdnJFKmq2Z2zCsFfRvMT7AUgO6V9K1mobVqKTZkt6L7m2O32JaSff56Azon3EY1NodnIWQZmuWetE1pGtAR7yEbwZ0XSY7OCshzVYc60P/HvuArvPRWUWPArpX0bA6Ic1WzPWhs3r+PaaVdD1hWNscP3arh7Sg5ixsHLIF/aa7ulGYAZ2rz0ZnL7oG9FxIC2pWp5JmC3oV3dscvYruIZ3tjRrQvR8NZ6GS5t4t9aIzoD/HvorO0bs0qqJ/hFYHF6KS5p4tjdzVFkevomsvOqvm77ul1cFFqaS5d7WKHgV0r6L74ZUe0KOQhrNRSXOvepsjx+rqNMdcFf0Q0zbH95gGtZvvuBghzT3qR7+zzdEDulbR/XRhjtx9b8voHRclpLlXoz50BvTn3crQzs3C3ovOYP4W8/1oOCshzb2Zm+boAV3nokenC7PN8S0OQ9qGIRcjpLknpwZ0hvRcFV0D+p8Ytzq8DM5FCGnuyWizsPegl6roulmYAV0r6RrSEapoLkBIcy/m3is8VkX3q0h/xj6Y/4l9UNdWh340FyOkuQf10MpcQP8R05CuN91F7I9/1zZHhnXfMMyvh7MT0ty6Y1eQfm6rXkda74vuAZ2r9qNV0VyckOYe9JDuLY6souud0XWzsM5EZzh/jX1Iq6J5N0KaW7Z0R3QP6BrS9Za7OhOd4ZwBXTcMVdG8CyHNrTq1D12r6KWZ6BrQtYqux8AjhDQXJqS5Rcfmof+IaUDXXnSvouu43deI+Hv3Mavo0WOzcDFCmls1Nw9dNwkzpEd96DrN0QO6j915CZx3I6S5NUuvrNQWR98s7CcLs83xLfYBXUN6dNsdXJyQ5paMThSONgpzHQvouSp67p4OuDghza1Yuh+6h3MN6Lmj399jXEH3zULhzLsS0tyCUy5O+iMi/oxxm2NpmuPviPiy+5i96JyLdtMd705Ic+3mLvDPZ7B6BT0K6KU+dA9obQ6uipDmmh17SLb3oeu43agPnZcn9YDupwttFnI1hDTXanRYpQf0XItj7tBKzkNnQI+qaE9jcVWENNfotQHdTxX29wrrPHQN6C8xHrkTzlwNIc216QFdR+1OCehsc8xtFH6JiL9i2uoYTXQIaq6CkOaavCag59oco6ewRgH9JeZH7gQ0V0NIcy1OCeg/YxrQ9dh3n+So93LUgM6QHm0WCmeujpDmGhwL6DpqVwO6V9D9+tG5gM7NwtE0h6Dmqnx472+AzTu1xTEK6L5RGPEStjnJ0QO6VtGmObgJQpr31OegR/dCz/Wgj01y5Cx0hvP/YhrQ/cUVAc1V0u7gvYwOqvSXVUanCUd3Q49G7b7ESzDnmmtzCGeumpDmPSwFdG9xLAX03NWj2eLIgK5tDtMc3BQhzaUdq6DnThP2l75zFjpiGtB5WGXUhxbQ3BwhzSWd0uIY3cXRAzpbHBGHd3IsbRT2NoeA5uoJaS7lNRX06IXvGtB1FvrUgPbSCjfJdAeXcGpA13cJR09f1U3CHLXLSY5jAW2Sg5skpDm3fh/0aMzuWAVdAzpiX0H/iOmoXd0krJMcLk/iZglpzmkU0PXZq7nXvecCOkO2XprUA/qvMGrHHRHSnMND+Zjh3AN6tFGYh1T6XRw9oL/HdJJjKaBNcnDThDRry4B+LKv3oHubo58i7D3oDNl6WCX70LUXnVePOvLN3RDSrGl0zLvexVEvTPrc1u/la/p1o/WF7x7QXljhrglp1jJqcYymODKg68fsP9eArpf29/s4+vNX9drR+pCsXjQ3T0izht7i6E9e1R50Defe4ugz0PVO6NHbhLW90ac4BDR3QUizlmO32fUqeu6QSrYn5gI6e8+9vZGbhL9Ci4M7IqR5q6XrRufaHKMRu1MCuvefa3tDD5q7JKRZSw/pOgtdV78kqfafa4tj9Lp3raDn+s8CmrsipFnDqJKuEx3Zk66bg6MZ6FFAZ0gvbRA+h4DmTglp1tLv5siDK5/KmruDI+/hqAFdJzm+xmFA1w3CCAHNnRLSrKEf/a7VdAZzr54jDgM6e9BfB6s/eWWDkE0Q0rxFVs+pB3Wdla4BnacH6012tYL+Wn482iAU0GyGkGYND3E45ZFhnT+u1XO2OfKQyrfY3wmdwZzjdVk9m+Bgk4Q0a6knDjOoa6WdpwczaGtA/9NWhvaPGB9QEdBshpBmTbWaThnO+eu1xdEDOsN5af5ZQLMpQpq3ehj8Wj2Ukndv5BRGXtafgVzDuVfPv8qfk38ubIqQ5q16cNaAzkDOrxm1ObJyHlXP2htsnpBmLaOZ56fd537sPtZJjh7OtXrW3oAdIc0aaqBme+NHvLRCsh9dK+s8tNInN7Q3oBHSvMVzTKc3ahWdwVyPfteQ/hnTgM7fr3qGQkjzVr2Kfox9H/pnTOejs8qulfOv9mcIaCiENGvIKvghXgI4f/5YPt/npHv1HCGg4YCQZg11oiN/Xmej6+f71IbqGRaMZlzhtfqx8H6opQeycIYTCWnW0o+Fj9RgFtBwAiHNmk75+yScAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgA34P8qxxAHgB6+TAAAAAElFTkSuQmCC"
      />
      <image
        id="image-8"
        width="443"
        height="372"
        href="data:image/png;base64,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"
      />
    </defs>
    <g>
      <g id="Layer_1" data-name="Layer 1">
        <g>
          <image
            width="307"
            height="323"
            transform="translate(53.21 38.39) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATMAAAFECAYAAABLf9knAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD1UlEQVR4nO3dyW7bMBRA0echQ9P+/7c28aAuqAezjAIDEtm06TkAYTvRwgvjgpQlOgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPhn7D77DfAltZ+r6VPeBf+V42e/Ab6MXfP4EWFjCDGjh93CqE3ViBA0BhAztsp47ZuRpoi4VqP+O3QjZmxRh+wQ5fN0mMcubiG7NCNCzOhMzNiiDtlDNY5xm52d5/E2v56iBC1jB12IGWvlebF9lM/RY0Q8RcRzlKAdosTqFBGv87H1ubNLQEdixhZ5fixj9hIR36IE7RBlifk2H5MBy1mZmRldiRlrZZByifkUJWQ/5sdjlHD9jBKtXGqe4vfLOASNLsSMNZZO/GfMvkeZoR2jBGwfJWA/43YuzcXadCdmbJFBy2Xmc5SgvUSJ3DnKUvMx3ofMrIyuxIy1lmZnD1HC9Ri3yzPycg0zMoba3z8EPvTRBbP1EDD+CDGjl6l53l75fw3LSgayzGSLNlrnatSvL/E+aMJGV2LGWnXILlGilRfI5jmy0zwybu0N59CNmLFFHbNTlOvIXuN2viyvLatnZ0LGEGLGWvXMrJ6VPcz/30cJ2Ov8PzFjKDFjjSne74pRLzGn+fESyzMzQaM7MWOtj2ZmeR9mRi1vYbqEiDGQmLFFOzPLE/8Zs4jbFwAZM0FjCDFji6XZWRuz/Kaz3WkWujrcPwTuWtr3P+OV2/6cq+e+CKA7MWOL9heZ8rHegLEdvgRgCMtMerhGCdl5fl1vjR1xC5mIMYyZGaPUszP3aDKcmLHV0o//Ts24Ns/zGOhGzOhhaZufNmhLIRM0uhEzRspYucmc4cSM3tp9zdrngsYQdgGlt6VzaDVLTIYQM0a497kSMgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgL/bL+3N3ffKzS1ZAAAAAElFTkSuQmCC"
          />
        </g>
        <g>
          <image
            width="311"
            height="324"
            transform="translate(50.03 38.55) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATcAAAFFCAYAAACJyKr4AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEEElEQVR4nO3dS4scZRTH4V93bibkgiYaxQu4E0TxA/j9dSeoiIgSMd5jEo25J5NxcTIYsxG0egqS54GmmmEWtSj+nPOe960uAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdmiz9g3w3Ng8dd1/6gqLEm4chm11rDpeHX38t4fVvepBAo4dEG7s2rY6WZ2vXqvONWF2vbr8+CrgWNzRf/8X+M+21QtNqL1XfVC9Wt2vvmyqt1tNuMGihBu7smmer/PVu9WHTcCdqX6tfqiOrHZ3PPO2a98Az6xNdap6o3q/eqd6sbpTXaq+qq6kamNHVG7swqYZIJyr3qrebILut+qL6uPqs+pq1tvYEeHGLmyatbaL1dtNxXajqdY+qj6tfmqquEcr3SPPOG0pu3C0Olu93gTcpvq++qT6PMHGIRBuLO1gQvpy05Keayail6pvmmHC3QQbOybcWNqR6nSz/eOV5hn7ufq6+rG6nWDjEAg3lrStTlQXminp2aZqu1x9V/3R7G0zQGDnhBtLOqjaLjYBt62uVd+mHeWQCTeWsmmqtpealvRstdccr7pS3WyqNjgUwo2lHGn2sl1oTiUca1rSK007ej/tKIdIuLGEg6NWZ5op6emmarvWbPv4PZt1OWTCjaVsm1canWqquHtNqF1tJqR7690azyMnFFjK5onPw2aT7tXqz7SkrEC4sYSDUNs209C7zXGrX7L9g5VoS1nCpmlJTzbP1INmmHAj2z9YiXDj/9r096T0TBNye00rev/xd1Ubh064sYRtE3DHmrDba1rRRwk2VmLNjSU8alrRO81k9HgzLbXWxmq85pmlHLyg8kT/PJlwK2turEC4saRt0w3cb966ez0DBVYi3FjK/hOfh80G3pv5jQRWItxY0pPhdrtZd1O1sQrhxpL2m/W2B01raqDAavziPEvbNs/Vfqo2AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAdf0F0jaWToXgX0EAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="314"
            height="317"
            transform="translate(47.54 38.44) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAAE+CAYAAADyEbd0AAAACXBIWXMAAC4jAAAuIwF4pT92AAADwklEQVR4nO3c24tVZRyA4XfvMc2iouyAdCJCCTGK6Kr//yYIIio6WZYUKWU1ZpSmTRc/N3PZzd570fg8MGzm7rtYvHyntQoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4L+slh4AJ5eHiyVtnr91dfDg9351rzpaalCcTGLHUtbVqepM9Wj12IP/D6tb1d8JHlt0aukB8FBaN4F7tjr/4PepZkb3WXWniR1sjdixb5vQna8uV29XLzbP4rXqx2ZJu8rMji0SO/ZpE7oXqjer95rgPVndrL5pZnX3Ezq2bL30AHhobEL3fHWperd6o1m+3q6uVJ9W16u7C42RE8zMjn1YNwcRzzWBe6e60BxK/Fx9Xr1ffdzM8BxOsHVix66tq9PNIcSF6q3q9Y5D92X1Qcezuj+rfxYZKSea2LFLqyZ055rAXa5eq842obtSfdicwN6o/kro2BGxY1c2oXu6Cdyl6tVm3+5mdbX6qPqi+imhY8fEjl05qJ6oXq4uVi81+3a/VN9Wn1RfNTO8OwkdOyZ27MKqCdsz1SvNnbrTTei+b5atXzehu5vQsQdixy4cNPty55rgPVL9Vv3QHEhcbcIndOyN2LFtqyZ2jzehO9vco7veLFu/a8IndOyV2LELm+smZ5r3XQ+btyOuVb82oXOPjr3yBgXbtur4k01H1R/NtZIbTfRcGGYRYse2rZo9utPNMvWwCZ2lK4sSO7Zps1+3+T7dUbNfd5g3I1iYPTt2YdXxXt3vTfB8fZhFHSw9AE6UzX7dZsVwq7licrvZqzOzYzE+y862rTvesztqInevCZ2ZHYsRO3Zh3fGXhjd/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADw//YvNfJ6wb6O1X4AAAAASUVORK5CYII="
          />
        </g>
        <g>
          <path
            d="m24.72,18.68c1.54-1.37,2.5-3.08,2.5-5.02,0-4.19-4.39-7.58-9.79-7.58H0v27.54s16.82,0,16.82,0c6.24,0,11.29-3.92,11.28-8.72,0-2.43-1.31-4.63-3.38-6.21Zm-15.55-7.58h5.05c1.8,0,3.3,1.14,3.3,2.56s-1.49,2.51-3.3,2.51h-5.05v-5.06Zm4.75,17.49h-4.74s0-7.4,0-7.4h4.74c2.64,0,4.79,1.67,4.79,3.7,0,2.02-2.15,3.7-4.78,3.7Z"
            fill="#f58025"
            strokeWidth="0"
          />
          <path
            d="m78.6,33.61h21.2s0-5.02,0-5.02h-7.81l8.69-12.42h-20.33s-6.41,0-6.41,0V7.53s-9.18,0-9.18,0v8.63h-2.99s0,5.02,0,5.02h2.99s0,6.34,0,6.34c0,3.35,2.72,6.07,6.06,6.08h5.58s0-4.32,0-4.32h-1.27c-.66,0-1.19-.52-1.19-1.19v-6.91s7.39,0,7.39,0h0s5.96,0,5.96,0l-8.69,12.42Z"
            fill="#f58025"
            strokeWidth="0"
          />
          <rect
            x="51.33"
            y="16.17"
            width="9.18"
            height="17.44"
            fill="#f58025"
            strokeWidth="0"
          />
          <path
            d="m44.96,15.28c-4.79,0-5.97,2.16-11.02,2.16-1.84,0-3.56-.84-4.56-2.16v18.33h9.18s0-13.43,0-13.39c.31-.4.79-.61,1.32-.61.35,0,.7.09.96.3,0,2.47,2.07,4.54,4.57,4.53,2.5,0,4.61-2.07,4.61-4.58,0-2.51-2.54-4.59-5.05-4.58Z"
            fill="#f58025"
            strokeWidth="0"
          />
        </g>
        <g opacity=".5">
          <image
            width="651"
            height="467"
            transform="translate(4.41 -.9) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <path
          d="m83.03,50.26c-3.45-2.25-3.25-4.12-3.25-4.12-.51-1.93,5.18-2.73,5.18-2.73,1.2-.34,1.17-1.42,1.17-1.42.93-3.96,2.39-5.32,2.39-5.32.59-.71.78-.28.78-.28.04,1.17-.67,1.3-.67,1.3-.95,1.33-.97,3.01-.97,3.01.31,1.5.85.33.85.33.92-2.41,3.27-4.36,3.27-4.36.77-.73.97-.21.97-.21-.21,1.25-1.14,1.48-1.14,1.48-.75.91-2.13,3.01-2.13,3.01-.66,1.13.11.98.11.98,1.51-1.51,4.92-3.55,4.92-3.55,1.1-.43,1.09.06,1.09.06-.36,1.29-1.49,1.21-1.49,1.21-1.63.67-3.14,2.98-3.14,2.98-.56.63.4.69.4.69,1.37.03,5.42-2.42,5.42-2.42.99-1.76,1.8-1.45,1.8-1.45.49.36-.3,1.13-.3,1.13-2.37,2.83-6.68,3.85-6.68,3.85,1,1.1,4.24.33,4.24.33.68-.5,1.59-.55,1.59-.55.35.13-.07.64-.07.64-3.12,2.23-8.72.45-8.72.45-2.53.91-.84,2.09-.84,2.09,6.21,2.11,5.26,5.07,5.23,5.19l.08.03c4.91,2.28,8.26.98,8.26.98,3.91-.68,13.56-5.1,13.56-5.1,3.42-1.74,6.02-4.27,7.77-6.37,0,0,1.17-1.54,1.19-1.54.98-1.35,1.48-2.29,1.48-2.29.83-1.91,1.38-3.73,1.7-5.44,0,0,.15-.96.16-.96.75-5.17-.53-9.31-2.02-12.17l-.28-.53h0c-.31-.56-.62-1.06-.92-1.5,0,0-.11-.16-.18-.26-.02-.03-.04-.06-.06-.08-.36-.5-.94-1.2-.93-1.21-.52-.62-.87-.94-.87-.94-.46-.51-1.03-1-1.69-1.46-.27-.18-.48-.31-.48-.31h0c-6.68-4.2-21.03-5.85-21.03-5.85-7.44-1.6-4.41-7.2-4.41-7.2.61-.79.6-.04.6-.04-1.28,4.98,6.07,5.31,6.07,5.31,7.61.86,12.96,2.15,16.16,3.1.02,0,.53.16.53.16,2.07.64,3.09,1.09,3.09,1.09,6.31,3.1,9.57,7.54,11.1,12.06.02.02.13.4.13.4.56,1.78.87,3.56,1,5.27,0,0,.05.86.05.86,0,.02,0,.04,0,.05l.06,1.21s-.09,1.97-.18,2.9c0,0,0,0,0,0,0,.02-.01.12-.04.28-.1.9-.22,1.74-.37,2.51-.02.12-.03.18-.03.17-.25,1.33-.55,2.43-.79,3.23-.02.08-.05.17-.08.27-.23.72-.39,1.12-.39,1.12-.6,1.59-1.39,3.07-2.32,4.45,0,.01-.2.29-.2.29-1.3,1.89-2.84,3.58-4.49,5.09,0,.01-.39.35-.39.35-1.76,1.56-3.62,2.92-5.44,4.07,0,.01-2.17,1.31-2.17,1.3-1.48.85-2.89,1.55-4.11,2.11,0,.01,0,.02,0,.02l-.36.15c-2.39,1.09-3.99,1.61-3.99,1.61-3.05.9-8.13,2.62-11.35,3.73l-1.18.42s0,0,0-.01c-1.11.38-1.81.62-1.81.62-1.67.37-2.34,1.31-2.34,1.31-2.45,2.74-4.15,3.16-4.15,3.16,2.63,1.47,4.04.97,4.04.97,3.53-1.29,6.16.29,6.16.29.95.66.33.79.33.79-1.62-.12-1.77-.51-1.77-.51-2.77-.79-4.25,1.25-4.25,1.25-.49,5.82,3.7,7.09,3.7,7.09,1.66.63,1.39,1.27,1.39,1.27-.17.34-.58.21-.58.21-4.76-1.35-5.98-5.49-5.98-5.49-.12-.55-.37-.17-.37-.17-.78,2.83,1.04,5.06,1.04,5.06,1.04.77.7,1.23.7,1.23-.16.17-.51-.16-.51-.16-2.4-2.09-2.37-6.11-2.37-6.11-.54.03-2.69,3.45-2.21,4.83.47,1.38-.14,1.36-.14,1.36-.26.07-.45-.95-.45-.95-.55-2.85,1.03-4.98,1.03-4.98.35-.47,0-.36,0-.36-1.03.34-2.66,2.59-2.66,2.59-.21.64-.39.93-.52,1.05-.16.1-.28.05-.34,0-.26-.21.06-.82.06-.82.78-1.58,2.67-3.55,2.67-3.55h0c-.58.2-3.25.77-3.25.77-1.42.26-2.98.45-2.98.45-1.94.1-2.18-1.27-2.18-1.27-.5-1.58.16-3.65.97-5.37-11.77-1.15-15.98-6.8-15.98-6.8-.24,1-.2,2.1-.2,2.1-.12,3.63-1.96,3.49-1.96,3.49-.63.1-1.92-.41-3.3-1.11-.23-.11-.45-.22-.61-.32-2.18-1.16-4.37-2.6-4.37-2.6-2.39-1.35-3.17-.71-3.17-.71-4.79,2.77-7.24.77-7.24.77-.07-.53,1.46-.24,1.46-.24,1.8.52,3.07-.26,3.07-.26.29-.16-.15-.22-.15-.22-3.83-.29-4.54-1.74-4.54-1.74,0,0-.37-.84.62-.22,2.17,1.08,4.43.79,4.43.79.47-.02.34-.44.34-.44-.14-.42-1.87-.78-1.87-.78-3.16-.91-4.15-2.75-4.15-2.75-.17-.77.7-.17.7-.17,2.42,2.22,4.94,2.32,5.74,2.28,0,0,.31,0,.29-.2-.03-.63-1.29-1.14-1.29-1.14-.72-.26-1.66-.8-2-1.02-.77-.43-1.14-1.02-1.14-1.02,0,0-.01-.02-.02-.02-.3-.59.34-.46.34-.46.92.21,1.73.82,1.73.82.68.66,3.02,1.98,3.02,1.98.63.44.57-.18.57-.18-.45-1.78-1.57-2.97-2.43-3.66-1.06-.37-1.1-.76-1.1-.76.03-.39,1.06-.03,1.06-.03,1.92.98,3.02,2.63,3.46,3.42,0,0,1.12,1.79,4.33,2.71,1.51.45,2.73.56,2.73.56,1.12.23.66-1.65.66-1.65-.3-1.58.16-3.48.3-4.19.14-.71-.54-2.13-.54-2.13h0c-.41.65-.95.52-.95.52-.65-.12-.95-.75-1.06-1.42h0c-.61,1.77-1.64,1.42-1.64,1.42-.79-.19-.88-1.04-.9-1.32-.01-.14.08-.58.08-.58-2.01.79-1.61-1.5-1.56-1.73l.11-.53c-.28.48-.69.39-.69.39-.94-.16-.8-1.84-.8-1.84l.02-.29c-1.43-.09-1.39-1.2-1.39-1.2v-1.08c-1.18-.05-1.18-.98-1.18-.98.15-.74-.08-2.67-.08-2.67-2.11-2.61-3.75-7.38-3.75-7.38-.94-3.3-.05-4.66-.05-4.66h0c.08-.29.18-.46.18-.46,1.14-1.84,2.78-.81,2.78-.81,0,0,4.42,2.82,8.15,3.05,3.48.21,3.9,2.75,3.95,3.08.33-.03.68,0,.89.26,0,0,.36.47-.01,1.11,0,0,.91-.5,1.27-.21,0,0,.28.42-.47,1.02,0,0,1.67-.61,2.16-.09,0,0,.11.61-.58,1.37,0,0,1.71-.67,2.26-.12,0,0,.07,1.04-1.32,1.67.25-.04,1.24-.15,1.87.46,0,0,.26.72-1.6,1.33,0,0,1.71.5,1.82,1.22,0,0,.11.49-1.32.8-.11.02-.23.04-.36.05.13.05.72.3.97.64,0,0,.21.24-.21.49-.11.06-.5.16-.67.21.36.15.89.46.87.75,0,0-.1.51-.91.78.21.03.69.12.85.45,0,0,.08.22-.25.43.79,1.64,2.25,1.59,2.25,1.59,1.07-1.06,2.6-1.1,2.6-1.1,1.88.1,2.98-.15,3.54-.36l-.02-.21c-.07-2.25-1.92-2.92-1.92-2.92-2.35-.49-3.96-2.09-3.96-2.09-1.59-1.54-.88-1.76-.88-1.76,1.04-.27,1.68,1.18,1.68,1.18.73.64,1.95.96,1.95.96.33.17.24-.4.24-.4-1.41-2.14-1.65-5.22-1.65-5.22,0-.48.4-.47.4-.47.69.62.5,1.62.5,1.62.25,1.34,1.79,3.22,1.79,3.22.66.48.62-.12.62-.12.18-2.11-.88-5.27-.88-5.27-1.03-1.24-.42-1.45-.42-1.45.41-.15,1.1.96,1.1.96.64,1,1.22,5.54,1.22,5.54.18.33.39.02.39.02.35-1.6-.15-4.37-.15-4.37-.63-.55-.4-1.4-.4-1.4.1-.27.43.03.43.03,1.47,1.27,1.01,5.73,1.01,5.73.05.68.7.13.7.13.52-.65.85-3.15.85-3.15-.38-.77-.11-1.33-.11-1.33.12-.44.37-.17.37-.17.93,1.64-.45,5.12-.45,5.12-.6,1.23.46,3.11.46,3.11,1.97,2.53,2.43,4.13,2.43,4.13.39,1.29-1.38,2.04-1.55,2.11l-.76.26s5.8-.57,7.86-.3Z"
          fill="#559d46"
          strokeWidth="0"
        />
        <path
          d="m96.29,63.46c3.22-1.11,8.48-2.81,11.53-3.71,0,0,1.6-.52,3.99-1.61l.36-.15s0,0,0-.02c1.22-.56,2.62-1.27,4.11-2.11,0,.01,0,.02,0,.03l2.17-1.31s0,0,0-.02c1.82-1.15,3.68-2.51,5.44-4.07,0,0,.39-.34.39-.35,1.65-1.51,3.19-3.2,4.49-5.09,0,0,.2-.28.2-.29.92-1.38,1.71-2.86,2.32-4.45,0,0,.16-.4.39-1.12.03-.09.06-.18.08-.27.24-.8.79-3.23.8-3.22,0,0,0-.07.03-.18.15-.77.27-1.62.37-2.51.02-.16.04-.26.04-.28,0,0,0,0,0,0,.09-.93.18-2.9.18-2.9l-.06-1.21s0-.04,0-.05c0,0-.05-.86-.05-.86-.13-1.72-.43-3.5-1-5.27,0,0-.11-.38-.13-.4-1.54-4.53-4.79-8.96-11.1-12.06,0,0-1.02-.45-3.09-1.09,0,0-.52-.17-.53-.16-3.2-.95-8.54-2.24-16.16-3.1,0,0-7.35-.32-6.07-5.31,0,0,.02-.75-.6.04,0,0-3.03,5.6,4.41,7.2,0,0,14.35,1.65,21.04,5.85h0s.21.13.48.31c.66.45,1.24.94,1.69,1.46,0,0,.35.33.87.94,0,.01,1.16,1.56,1.17,1.56.3.44.61.95.92,1.5h0l.28.53c1.49,2.87,2.77,7.01,2.02,12.17,0,0-.16.96-.16.96-.33,1.71-.87,3.52-1.7,5.44,0,0-.5.94-1.48,2.29-.02,0-1.19,1.54-1.19,1.54-1.75,2.1-4.35,4.63-7.77,6.37,0,0-9.65,4.41-13.56,5.1,0,0-2.46.96-6.27-.21,0,0,3.32,2.25,1.2,10.08Z"
          fill="#294d82"
          strokeWidth="0"
        />
        <image
          width="335"
          height="349"
          transform="translate(17.51 -2.69) scale(.24)"
          href="data:image/png;base64,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"
        />
        <image
          width="340"
          height="354"
          transform="translate(11.67 -3.36) scale(.24)"
          href="data:image/png;base64,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"
        />
        <g opacity=".7">
          <image
            width="337"
            height="341"
            transform="translate(43.04 27.59) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <image
          width="365"
          height="340"
          transform="translate(12.72 17.88) scale(.24)"
          href="data:image/png;base64,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"
        />
        <g opacity=".7">
          <image
            width="329"
            height="327"
            transform="translate(32.54 7.33) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <image
          width="322"
          height="324"
          transform="translate(45.13 8.19) scale(.24)"
          href="data:image/png;base64,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"
        />
        <g opacity=".7">
          <image
            width="440"
            height="331"
            transform="translate(27.58 14.68) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <image
          width="447"
          height="517"
          transform="translate(59.68 -31.34) scale(.24)"
          href="data:image/png;base64,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"
        />
        <g opacity=".8">
          <image
            width="326"
            height="360"
            transform="translate(16.62 -.95) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g opacity=".3">
          <path
            d="m46.5,30.21c-.03.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m47.05,30.9c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.09.08.03.13.13.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m47.82,30.49s-.07.07-.11.05c-.04-.01-.06-.07-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m45.59,33.51c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m46.16,35.02c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m45.79,34.37s-.07.06-.11.05c-.04-.02-.06-.06-.04-.11.01-.04.06-.06.1-.04.04.01.06.06.05.1Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m47.47,36.15c-.04.09-.14.14-.24.11-.09-.04-.14-.14-.11-.24.03-.1.14-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m46.6,36.12c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m46.92,37.35c-.02.06-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.1,39.35c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.65,30.92c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19s.11-.11.19-.08c.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.19,31.78c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.06.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m47.57,31.28c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.08.11-.11.18-.08.08.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.44,33.35c-.04.09-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.77,34.44c-.02.06-.09.1-.16.07-.06-.02-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.37,33.97c-.02.07-.1.1-.16.08-.07-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.07.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.14,32.77c-.02.05-.08.08-.13.06-.06-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.23,31.94c-.02.06-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.95,32.08c-.02.06-.08.08-.14.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.34,32.1c-.04.12-.17.18-.29.13-.12-.05-.17-.18-.13-.29.05-.12.17-.17.29-.13.12.05.18.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.82,32.35s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.39,31.71c-.03.08-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.09.09.03.13.13.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.12,31.83c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.7,32.78c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.14-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.75,32.16s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.07-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.45,32.29c-.04.1-.14.15-.24.11-.09-.04-.14-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.83,32.59c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.08.11-.11.19-.08.08.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m57.33,33.11c-.03.08-.13.13-.21.1-.08-.03-.13-.13-.1-.21.04-.09.13-.13.21-.09.09.03.13.13.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.96,30.77c-.03.07-.11.11-.19.09-.08-.03-.11-.12-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.18,37.22c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.12.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.43,38.07c-.03.08-.13.13-.21.1-.08-.04-.13-.13-.09-.21.03-.08.12-.13.21-.09.08.03.13.13.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.75,39.3c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.13,40.22c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.63,39.06c-.04.1-.16.15-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.62,41.26c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.18Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.7,42.55s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.19,43.07c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.34,44.58c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.81,41.93c-.04.12-.18.18-.29.13-.12-.05-.18-.18-.13-.3.04-.12.18-.17.29-.13.12.04.17.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.23,44.02c-.03.07-.11.11-.19.08-.08-.03-.11-.12-.08-.19.03-.07.11-.11.19-.08.08.03.11.12.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.77,43.67c-.04.12-.17.17-.29.13-.12-.04-.18-.18-.13-.29.04-.12.17-.18.29-.13.12.05.18.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.87,42.81c-.04.12-.18.18-.29.13-.12-.04-.17-.18-.13-.29.04-.12.18-.17.29-.13.12.04.17.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.73,41.24c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.98,41.91c-.03.08-.13.13-.21.1-.09-.03-.13-.13-.09-.21.03-.09.13-.13.21-.1.09.03.13.13.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.95,42.58c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.11.12.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.9,42.29c-.03.08-.13.12-.21.1-.09-.04-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.04.13.13.09.22Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.61,43.41c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.17.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.45,40.44c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.33,39.6c-.04.09-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.95,39.98c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.03,38.78c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.13,38.95c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.26Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.51,38.19c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.26.04-.11.16-.16.27-.12.1.04.16.16.12.26Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.38,37.95c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.24,43c-.03.08-.13.13-.21.1-.09-.03-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.03.13.13.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.12,43.59c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.4,43.38c-.04.12-.17.17-.29.13-.12-.04-.17-.17-.13-.29.04-.12.17-.18.29-.13.12.04.18.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.86,44.29c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.18.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.21,46c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.26Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.35,46.78c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.18.03-.08.11-.11.19-.09.08.03.11.11.09.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.58,45.33c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m57.07,44.56c-.05.12-.18.18-.29.13-.12-.04-.18-.18-.13-.29.05-.12.18-.18.29-.13.12.04.18.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m57.36,45.4c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m49.34,42.82c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.26.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.83,42.61c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.04,41.64s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.01.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.18,43.56c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.02.09.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.7,44.34c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.56,45.06c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.06.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.15,45.42c-.05.13-.19.19-.32.14-.12-.05-.19-.2-.14-.32.05-.12.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.68,45.88c-.02.07-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.09.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.63,46.58c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.88,46.16c-.03.08-.11.11-.19.09-.08-.03-.11-.11-.08-.19.03-.08.11-.11.19-.08.08.03.11.11.09.18Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.77,46.26c-.05.12-.18.18-.29.13-.12-.05-.18-.18-.13-.29.04-.12.18-.18.3-.13.12.04.17.18.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.23,46.55c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.08.11-.11.18-.08.08.03.11.11.09.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.83,47.45s-.06.06-.11.05c-.04-.01-.07-.06-.05-.1.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.83,47.76c-.03.07-.1.09-.16.07-.07-.02-.09-.1-.07-.16.02-.07.09-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.51,48.9c-.03.08-.11.11-.19.09-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.18Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m57.77,48.32s-.03.03-.05.02c-.02,0-.03-.03-.03-.05,0-.02.03-.03.05-.02.02,0,.03.03.02.05Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.2,48.61c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.31,49.14c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.08.13-.13.21-.1.08.03.13.13.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.93,49c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.16,47.86c-.03.07-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.08.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.65,48.67c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.03-.07.09-.09.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.42,49.55c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.14-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.14,49.86c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.09.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.45,50.38c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.73,50.19c-.04.11-.16.16-.26.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.26-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.03,49.55c-.02.06-.1.09-.16.07-.06-.02-.09-.09-.07-.16.02-.06.09-.09.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.67,49.23s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.07.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.58,48.43c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.18,48.7c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.46,49.01s-.03.03-.05.02c-.02,0-.03-.03-.02-.05,0-.02.03-.03.05-.02.02,0,.03.04.02.05Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.34,49.14c-.04.1-.14.14-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.03.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66,49.5c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.06.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.12,49.57c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.79,49.74c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.71,49.29s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08.01-.03.05-.05.08-.04.03,0,.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.76,48.71c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.09.14-.14.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.03,48.77c-.03.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11s.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.07,50.14c-.03.07-.11.11-.19.08-.08-.03-.11-.11-.08-.18.03-.07.12-.11.19-.09.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.52,48.95c-.03.08-.13.13-.22.1-.08-.03-.12-.13-.09-.21.03-.09.13-.13.21-.1.08.03.13.12.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.49,51.74c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.53,50.97c-.02.05-.08.08-.13.06-.06-.02-.08-.08-.06-.13s.08-.08.13-.06c.06.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.64,50.54c-.03.09-.13.13-.21.1-.09-.04-.13-.13-.09-.21.03-.08.12-.13.21-.09.08.03.13.12.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.88,51.15c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.89,51.26c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.82,50.33c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.3,50.08c-.03.08-.13.13-.21.09-.09-.03-.13-.13-.1-.21.04-.08.13-.13.21-.1.08.03.13.13.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.2,50.93c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.5,51.08c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.14,51.56c-.03.09-.13.13-.22.1-.08-.03-.13-.13-.09-.21.03-.08.13-.13.21-.09.09.03.13.13.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.98,52.43s-.03.03-.05.02c-.02,0-.03-.03-.03-.05.01-.02.04-.03.05-.02.02,0,.03.03.02.05Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.09,53.29s-.06.06-.11.04c-.04-.02-.06-.06-.05-.11.02-.05.07-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.78,53.59c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.24,52.97c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.07.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.54,52.44c-.06.15-.22.22-.37.17-.15-.06-.22-.22-.17-.37.06-.15.23-.22.37-.17.15.06.22.22.16.37Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.31,53.14c-.03.07-.11.11-.18.08-.08-.03-.11-.11-.09-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m57.91,51.2s-.06.06-.11.05c-.04-.02-.06-.07-.05-.11.02-.04.06-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.28,50.04c-.02.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.8,54.41c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.58,55.52c-.03.09-.13.13-.21.09-.09-.03-.13-.13-.1-.21.03-.09.13-.13.21-.1.08.03.13.13.1.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.89,56.15c-.04.11-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.1.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.31,56.63c-.04.1-.14.14-.24.11-.09-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.89,56.79s-.06.06-.11.04c-.04-.01-.06-.06-.05-.11.02-.04.06-.06.11-.05.04.02.06.07.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.17,55.64c-.04.1-.16.16-.27.12-.11-.04-.16-.16-.12-.27.04-.11.16-.16.27-.12.11.04.16.16.12.27Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.52,54.76c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.5,55.01c-.02.05-.06.09-.08.08-.03-.01-.03-.06-.01-.12.02-.05.06-.09.08-.08.03,0,.03.06.01.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.44,54.43c-.02.07-.1.1-.16.07-.06-.02-.1-.09-.07-.16.03-.06.1-.09.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.37,53.97c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.42,54.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.12.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.99,55.06c-.03.08-.11.11-.19.08-.07-.03-.11-.11-.08-.19.03-.07.11-.11.18-.08.08.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.49,54.95c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.15,55.9s-.06.06-.11.05c-.04-.02-.06-.06-.05-.11.01-.04.06-.06.11-.05.04.02.06.06.05.11Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.94,56.28c-.05.12-.18.18-.29.13-.12-.04-.18-.17-.13-.29.04-.12.17-.17.29-.13.12.04.18.17.13.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.26,56.61c-.02.05-.08.08-.14.06-.05-.02-.08-.08-.06-.13.02-.06.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.39,57.82c-.02.07-.09.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.15,58.04c-.06.17-.25.26-.42.19-.17-.06-.26-.25-.19-.42.06-.17.26-.26.43-.19.17.07.26.26.19.43Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.81,47.65c-.03.08-.11.11-.19.08-.08-.03-.11-.11-.08-.19.03-.07.11-.11.19-.08.07.03.11.11.08.19Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.57,46.14c-.02.05-.08.08-.13.06-.05-.02-.08-.08-.06-.13.02-.05.08-.08.13-.06.05.02.08.08.06.13Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.75,45.43c-.04.09-.14.14-.24.11-.09-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.39,46.69c-.06.15-.23.22-.37.17-.15-.06-.22-.22-.17-.38.06-.15.23-.22.37-.17.15.06.23.22.17.37Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.17,58.68c-.05.14-.22.22-.36.16-.14-.06-.21-.22-.16-.37.06-.14.22-.21.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.24,59.28c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.5,60.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.58,60.93c-.04.1-.14.14-.24.11s-.15-.14-.11-.24c.04-.1.14-.15.24-.11.1.03.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.44,60.32c-.04.12-.17.17-.28.13-.11-.05-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.67,60.87c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.65,60.21c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.15.24-.11.09.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.28,59.89c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.6,59.13c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07s.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.67,59.83c-.07.18-.26.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.06.26.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.77,60.71c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.38,61.38c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.81,60.86c-.03.07-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.09-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.68,61.88c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m62.16,62.63c-.06.18-.26.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.26-.26.44-.2.17.07.26.26.19.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.07,62.98c-.03.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.03.1.1.08.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.89,63.86c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.09,63.95c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.03,63.32c-.02.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60,64.44c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.25,64.49c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m58.74,64.79c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.34,65.32c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.39,65.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.04.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.12,64.83c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.52,64.85s-.05.05-.08.04c-.03-.01-.05-.04-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m61.39,65.8c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m60.86,65.97c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.94,66.35c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m59.28,66.17c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.59,62.9c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.28,63.37c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.03-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.4,62.53c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.73,61.49c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.69,61.05s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.59,61.94c-.05.13-.19.19-.32.15-.13-.05-.2-.2-.14-.33.05-.13.19-.19.32-.14.13.05.2.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m50.93,61.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.2,61.91c-.05.14-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.05.21.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m51.69,61.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m52.44,62.05c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.12.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.16,62.89c-.05.14-.22.21-.36.16-.15-.05-.22-.22-.16-.36s.22-.22.36-.16c.14.05.21.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.73,63.14c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m53.55,62.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m54.76,63.94c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m55.88,64.33c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.21.2.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m56.35,64.21c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m49.81,59.94c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m49.93,61.56c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.15-.32.05-.13.2-.2.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.82,61.4c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m48.45,61.93c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m49.1,61.88s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.03.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m47.62,62.54c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.05-.11.17-.17.29-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m63.95,61.88c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.4,61.15c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.87,60.71c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.66,60.38c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.76,58.46c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.04,59.49c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.61,57.12s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.07,56.18c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.12.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.93,56.47c-.04.09-.15.15-.24.11-.09-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.79,57.71c-.05.13-.2.19-.32.14-.13-.05-.2-.2-.15-.32.05-.13.2-.19.32-.14.13.05.2.19.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.25,57.62s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.77,57.66c-.02.07-.07.11-.1.1-.03-.01-.04-.08-.01-.14.03-.06.07-.11.1-.09.04.01.04.07.01.14Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.2,59.16c-.02.05-.08.09-.14.06-.06-.02-.09-.08-.06-.14.02-.06.09-.09.14-.06.06.02.09.08.06.14Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.67,61.69c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.69,61.02c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.53,60.91c-.04.1-.07.18-.07.18,0,0,.03-.08.07-.18.04-.1.07-.17.07-.17,0,0-.03.08-.07.17Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.69,60.92c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.19,61.26c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.37,61.15c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.82,61.37c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.24,61.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.75,62.33c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.35,62.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.11,62.8c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.07,63.4c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.98,62.7s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.24,62.02c-.06.16-.24.24-.4.18-.16-.07-.24-.25-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.81,62.69s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.03.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.05,62.93c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m64.59,62.05c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.13,63.51c-.07.18-.26.26-.44.2-.17-.07-.26-.26-.2-.44.07-.18.27-.27.44-.2.18.07.26.27.2.45Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.37,62.9c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m66.83,64.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.74,64.03c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m67.6,64.84s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.8,63.7c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.22,63.29c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.8,62.55c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.51,60.96c-.02.07-.09.1-.16.07-.07-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.06,63.73c-.09.22-.34.34-.56.25-.22-.09-.34-.34-.25-.56.08-.22.34-.34.56-.25.22.08.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.99,64.08s-.08.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.58,64.26c-.04.1-.15.14-.24.11-.09-.04-.14-.15-.11-.24.03-.1.14-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.23,64.76c-.06.14-.22.22-.36.16-.14-.05-.22-.21-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.09,65.48c-.06.16-.24.24-.4.18-.16-.06-.25-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.41Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.88,65.41c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.72,65.23c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.96,65.82c-.04.1-.15.14-.24.11-.09-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.26,65.11c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.27,65.96c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.13-.29.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.94,64.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.35,66.27c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.24,66.05c-.03.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.1.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.08,66.8c-.02.05-.08.08-.14.06-.05-.02-.08-.08-.06-.14.02-.05.08-.08.14-.06.06.02.08.08.06.14Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.83,66.51c-.07.19-.29.29-.48.22-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.37,65.61c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.02,64.45c-.07.18-.27.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.07.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.32,63.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.03,65.9c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.41Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.41,66.56c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.3,65.03c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.03,65.47c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.68,65.09c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.98,59.58c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.55,58.95c-.11.29-.43.44-.72.33-.29-.12-.43-.44-.32-.73.11-.29.43-.43.72-.33.29.11.43.44.32.73Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.25,57.99c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.73,57.17c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.42,58.96c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.21,60.72c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.36,61.48c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.12,62.35c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.27,61.44c-.05.14-.21.22-.36.16-.15-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.69,62.78c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.27,63.63c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.09.08.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.72,64.79c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.44,63.7c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78,64.34c-.08.21-.31.31-.52.23-.21-.08-.31-.31-.24-.52.08-.21.31-.31.52-.23.21.08.31.31.23.52Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.94,64.84c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.24,63.53s-.08.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.82,65.68c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.09-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.83,66.18c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.47,66.16c-.07.18-.26.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.07.27.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.37,66.34s-.07.07-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75,66.33c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.22,67.15c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.28,67.08c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.18.03-.07.11-.11.18-.08.07.03.11.11.08.18Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.33,67.21c-.07.19-.29.29-.49.21-.19-.07-.29-.29-.22-.48.08-.19.29-.29.48-.22.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.89,67.06c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.16,67.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.79,67.16c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.6,67.64c-.09.24-.37.36-.61.27-.24-.09-.36-.36-.27-.61.1-.24.36-.36.61-.27.24.09.36.36.27.6Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79,66.7c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.15.13.05.19.2.14.33Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.28,66.55s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.95,65.87c-.03.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.43,65.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.44,58.83s-.07.07-.12.05c-.05-.02-.08-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.42,58.87c-.04.1-.15.15-.24.11-.09-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.31,59.35c-.02.07-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.47,59.7c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.61,60.38c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.1,60.77c-.04.11-.17.17-.28.13-.12-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.79,60.7c-.07.18-.27.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.27.44-.2.18.06.27.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.03,60.16c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.92,59.66c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.2-.2.33-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.64,58.65c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.62,57.65c-.05.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.69,58.79c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.04,59.87c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.12,60.97c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.21-.48.07-.2.29-.29.48-.22.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.33,61.92c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.58,60.23c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.61,67.28c-.09.23-.34.34-.56.25s-.34-.34-.25-.56c.08-.22.33-.34.56-.25.23.09.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.39,64.63c-.05.13-.19.19-.32.15-.13-.05-.2-.2-.15-.32.05-.13.2-.2.32-.15.13.05.2.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.24,62.59c-.09.23-.34.34-.56.25-.23-.09-.34-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.06,62.87c-.02.07-.09.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.2,61.99c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.44,66c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.36,65.76c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.45,64.29c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.82,64.29s-.08.07-.12.05c-.05-.02-.08-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.22,65.24c-.05.15-.22.22-.36.16-.15-.05-.22-.21-.16-.36.05-.15.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.46,65.93c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.79,65.84c-.05.13-.19.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.89,66.55c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.44,66.94c-.09.23-.34.34-.56.25-.23-.08-.34-.34-.25-.56.09-.22.34-.34.57-.25.23.09.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.6,67.49c-.02.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.17-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.95,62.56c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.19-.2.32-.15.13.05.19.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.05,58.3c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.09,59.32s-.06.06-.1.04c-.04-.01-.06-.06-.04-.1.01-.04.06-.06.1-.05.04.02.06.06.04.1Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.46,60.9c-.07.19-.29.29-.48.21-.19-.07-.29-.29-.21-.48.07-.19.29-.29.48-.21.19.07.29.29.22.49Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.07,60.1c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.85,59.63c-.02.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.79,60.82c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.86,62.38c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m95.39,62.91c-.05.15-.22.22-.36.16-.14-.05-.21-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m95.33,61.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.37,62.61c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.9,63.34c-.05.13-.19.19-.32.15-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.89,63.98c-.03.08-.12.12-.21.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.13,62.03c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.53,63.42s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.08.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.3,64.72c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.45,64.23c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.81,63.39c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.62,64.41c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.57,65.14c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.21.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.53,65.34c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.08,66.07c-.03.07-.11.11-.18.08-.07-.03-.11-.11-.08-.18.03-.08.11-.11.18-.08.07.03.11.11.08.18Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.52,66.41c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.09,66.65c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.38,66.59c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.09,67.09c-.05.14-.22.21-.36.16s-.22-.22-.16-.36c.06-.14.22-.22.36-.16.14.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.09,67.78c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.2,68.56c-.02.06-.09.08-.14.06-.05-.02-.08-.08-.06-.14.02-.05.09-.08.14-.06.06.02.08.08.06.14Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.82,68.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.83,69.51c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.03.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.02,69.46c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.22,69.45c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.58,69.9c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.79,70.32c-.08.21-.32.31-.52.23-.21-.08-.31-.31-.23-.52.08-.21.31-.32.52-.23.21.08.32.31.23.52Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.37,69.68c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.48,69.81c-.04.1-.14.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.15.25-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.83,70.21s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.73,63.86c-.07.19-.29.29-.49.21-.19-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.08.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.17,64.1c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.16,64.38c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.09.08.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.71,63.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.89,66.04c-.06.16-.24.24-.41.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.63,65.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.12,67.36c-.07.18-.27.26-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.64,66.89c-.03.06-.1.1-.16.08-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.08.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.89,67.19c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.18,67.73c-.02.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.85,68.24c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.95,69.56c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.41,70.36s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.24,68.18c-.03.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.05,67.89c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.1,67.04c-.02.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.01,66.32c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.86,72.22c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.96,71.02c-.06.15-.22.22-.36.16-.15-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.72,70.61c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.3,70.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.04.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.3,73.45c-.08.2-.29.29-.49.22-.2-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.9,70.76s-.05.05-.08.04c-.03,0-.05-.04-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.43,70.76c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.1,71.44c-.07.18-.27.27-.45.2-.18-.07-.27-.27-.2-.44.07-.18.27-.26.44-.2.18.07.27.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.16,70.61c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.76,70.33c-.03.08-.12.12-.21.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.77,72.06c-.02.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.69,73.45c-.09.23-.34.34-.57.25-.22-.08-.34-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.97,74.67c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.14.12.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.93,73.29c-.03.07-.09.1-.16.07-.06-.02-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.71,70.3c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.26,71.25c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.1,72.36c-.05.12-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.44,73.39c-.07.18-.26.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.47,73.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.2,74.01c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.18,74.61c-.05.14-.22.21-.36.16-.14-.05-.22-.21-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.81,74.45c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.17,73.68c-.04.12-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.26,74.32c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.94,74.11c-.06.14-.22.22-.36.16-.15-.05-.22-.21-.17-.36.06-.15.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.71,74.69c-.02.06-.1.09-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.93,73.77c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.43,73.09c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.85,73.82c-.06.15-.22.22-.36.16s-.22-.22-.16-.36c.06-.15.22-.22.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.38,73.22c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.58,73.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.38,73.32c-.03.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.32,73.74c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.54,75.79c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.76,76.44c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.19,76.87s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.19,73.3c-.05.15-.21.22-.36.16-.14-.05-.21-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.04,71.93c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.95,71.23c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.88,70.98c-.04.1-.15.15-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.09,69.99c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.2,78c-.02.06-.1.09-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.78,77.6c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.15.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.74,75c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.26,75.72c-.03.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.88,76.38c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.34,74.47s-.07.07-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.49,74.97c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.09-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.34,75.61c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.09.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.32,76.28c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.67,70.53c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.22,71.2c-.03.07-.1.1-.16.07-.07-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m98.38,61.48c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.05.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m98.83,62.13c-.05.14-.22.21-.36.16s-.22-.22-.16-.36c.05-.14.22-.21.36-.16.14.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m99.28,60.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m99.07,59.85c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m100.36,60.74c-.06.14-.22.22-.36.16-.15-.05-.22-.22-.16-.36.05-.14.21-.21.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m100.15,61.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.2-.2.32-.14.13.05.2.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m99.62,61.99c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m101.5,61.34c-.06.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.06-.14.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m101.12,60.33s-.05.05-.08.04c-.03,0-.05-.05-.04-.08.01-.04.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m98.8,54.7c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m99.25,54.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.88,55.25c-.11.29-.44.44-.72.32-.29-.11-.43-.43-.33-.72.11-.29.44-.44.73-.32.29.11.43.44.32.72Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.67,54.08c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.71,53.42s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.05,54.61c-.04.1-.15.14-.25.11-.09-.04-.14-.14-.1-.24.04-.1.14-.14.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.47,54.75c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.76,53.97c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.41,53.34c-.07.18-.27.26-.44.2-.18-.07-.27-.26-.2-.44.07-.18.27-.26.44-.2.18.07.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.14,52.64c-.07.18-.27.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.06.26.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.13,52.75c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.91,53.96c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.66,54.88c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.16,52.15c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.25.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.13,51.19c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.11,50.8c-.03.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.73,50.22c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.27,50.2c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.04,50.36c-.04.1-.15.15-.24.11-.1-.04-.15-.14-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.47,49.61c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.54,49.92c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.16.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.11,50.19c-.05.12-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.43,50.23c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.91,50.1c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.2.19.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.29,49.79c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.25-.24.41-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.52,49.97c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.42,49.2c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.75,48.7c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.1-.09.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.26,49.36c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.26-.27.44-.2s.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.98,49.66c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.74,48.97c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.62,50.25c-.05.14-.22.21-.36.16-.14-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.22.16.37Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.54,49.51c-.04.09-.14.14-.24.11-.09-.04-.14-.14-.1-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.33,50.51c-.07.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.78,51.16c-.03.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.06,51.01s-.07.08-.12.05c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.26,51.74c-.05.15-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.67,47.75c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81,46.97c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.76,45.68c-.04.09-.15.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.59,46.03c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.83,45.41c-.04.1-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.09.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.04,46c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.09-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.74,47.3c-.06.14-.22.22-.36.16-.14-.05-.22-.21-.16-.36.05-.14.22-.22.36-.16.14.06.21.22.16.37Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.75,48.08c-.05.13-.19.19-.32.14-.13-.05-.2-.2-.15-.32.05-.13.19-.2.32-.14.13.05.2.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.59,46.82s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.7,47.68c-.04.1-.14.14-.25.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.18,47.55c-.05.12-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.49,46.93s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.46,48.14c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.23,48.4c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.81,48.7c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.27,48.81c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.31,49.57c-.02.07-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.04,50.45c-.02.06-.09.1-.16.07-.07-.02-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.87,51.42c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.25.4-.18.16.06.24.24.18.41Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.94,51.06c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.31,50.88c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m84.73,51.1c-.05.14-.22.21-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.21.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.75,50.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m83.88,51.31c-.06.16-.24.24-.4.18-.17-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.7,51.43c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.99,50.76c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.36,51.09c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m82.85,51.28c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.14.24-.1.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.45,50.68c-.04.1-.15.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11s.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.61,51.14c-.02.06-.09.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.9,50.97s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.66,50.74c-.04.1-.15.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.16,50.99c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.62,51.53c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.76,52.05c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m81.6,52.37c-.06.16-.24.24-.4.18-.16-.07-.24-.24-.18-.4.06-.16.24-.24.41-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m80.16,52.75c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.39,53.63c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m78.48,53.11c-.05.14-.22.21-.36.16-.15-.06-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.53,54.22c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.92,53.52c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.09.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.86,52.45c-.04.1-.14.14-.24.11-.1-.03-.15-.14-.11-.24.04-.1.15-.14.24-.11.09.04.14.14.1.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.36,52.27c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.09.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.13,51.41s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.79,51.24c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.56,51.6c-.05.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.06.21.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m79.49,51.79c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.81,50.85c-.06.14-.22.21-.36.16-.15-.05-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.43,50.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.26,51.31c-.04.09-.14.14-.24.11-.1-.03-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.62,51.58c-.02.06-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.7,52.01s-.05.05-.08.04c-.03,0-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.04,50.08c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.61,50.23c-.06.14-.22.22-.37.16-.14-.06-.21-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.02,50.12c-.02.06-.1.09-.16.07-.06-.03-.09-.1-.07-.16.02-.06.09-.1.16-.07.07.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.37,49.65c-.02.05-.07.07-.12.06-.05-.02-.07-.08-.05-.12.02-.05.07-.07.12-.06.05.02.07.08.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.1,49.74c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.84,49.02c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.09-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.84,48.67c-.05.15-.22.22-.36.16-.15-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.47,49.21c-.05.13-.2.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.19.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.97,48.77c-.03.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.54,48.33c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.07,48.34c-.06.15-.22.22-.36.16-.14-.06-.22-.22-.16-.36.06-.15.22-.22.36-.16.14.06.22.22.16.37Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m77.08,49.18c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.08.12-.06.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.6,48.85c-.04.1-.14.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.64,47.78c-.03.1-.14.14-.24.11-.09-.04-.14-.14-.11-.24.04-.09.15-.14.25-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.86,47.75c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.19,47.31c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.8,46.5c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.71,45.77c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.27,46.15c-.06.15-.22.22-.36.16-.14-.05-.22-.22-.16-.36.06-.15.22-.22.36-.16.15.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.53,44.69s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.04.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.09,45.04c-.05.14-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.14.22-.21.36-.16.15.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.46,45.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.06,45.56c-.02.07-.1.1-.16.07-.07-.03-.1-.1-.08-.16.03-.07.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.84,45.97c-.04.11-.17.16-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m75.75,47.43c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m76.2,47.82s-.06.06-.1.04c-.04-.01-.06-.06-.05-.1.01-.04.06-.06.1-.05.04.02.06.06.05.1Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.84,48.15c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.21.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.33,42.94c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.71,43.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.58,43.58c-.05.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.94,43c-.02.07-.1.1-.16.07-.06-.02-.1-.09-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74.33,42.58c-.04.12-.17.17-.28.13-.11-.04-.17-.17-.12-.29.04-.11.17-.17.28-.12.11.05.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.63,42.51s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.67,42.48c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.61,41.93c-.02.07-.1.1-.16.07-.06-.03-.09-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.21,42.99c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.12.17-.17.28-.13.11.04.17.17.12.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.05,41.83s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.03,43.18c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.72,43.3c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.12,43.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m71.66,43.73c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13s.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72.37,43.78s-.04.04-.07.03c-.03-.02-.05-.04-.04-.07,0-.03.04-.04.07-.02.03.01.05.04.04.06Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m68.83,42.75c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.35,42.78c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.12.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m70.23,42.22c-.03.06-.1.1-.16.07-.06-.02-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m74,41.45c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m73.79,41.98s-.07.07-.12.06c-.05-.02-.07-.08-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.94,41.07c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.19-.19.32-.14.13.05.2.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.92,41.63c-.02.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.07.09-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m72,41.09s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.06.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.96,43.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.21Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.34,42.42c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.29.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.56,42.9s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.78,43.45c-.06.14-.22.22-.36.16-.15-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.96,43.33c-.04.1-.14.15-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.93,43.93c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m88.51,44.17c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.17,44.72c-.03.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.78,44.25c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.92,44.94c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.12.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.24,44.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.5,45.16c-.02.06-.09.1-.16.07-.06-.02-.09-.1-.07-.16.02-.06.1-.09.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.05,45.11c-.05.14-.21.22-.36.16-.14-.06-.22-.22-.16-.36.06-.14.22-.21.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.58,45.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m91.48,44.87s-.07.07-.12.05c-.05-.02-.08-.07-.06-.12.02-.05.08-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.77,43.76c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.7,42.79s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m89.16,42.48c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m92.36,45.44c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m93.3,45.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m94.07,45.69c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.56,42.38c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.05,42.32c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.05.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m90.23,43.07s-.06.06-.1.05c-.04-.02-.06-.06-.04-.1.01-.04.06-.06.1-.04s.06.06.05.1Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.79,45.71c-.06.14-.22.22-.36.16-.14-.05-.22-.22-.16-.36.05-.14.22-.22.36-.16.15.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.37,45.57c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m87.31,44.78c-.03.06-.1.1-.16.07-.06-.02-.09-.09-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.69,45.96c-.04.1-.15.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.41,46.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m86.87,46.88c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.26-.27.44-.2.18.07.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.2,46.64c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m85.45,47.37c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m69.73,49.91c-.04.09-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.09.14-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m65.95,51.86c-.05.12-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.29-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m104.72,57.97s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.01-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.52,57.97c-.05.13-.19.2-.32.15-.13-.05-.2-.2-.15-.32.05-.13.19-.19.32-.15.13.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.91,58.46c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.75,58.08s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.73,58.22c-.07.18-.26.27-.44.2-.18-.07-.27-.27-.2-.44.07-.18.27-.27.45-.2.17.07.26.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m108.42,57.55c-.02.07-.1.1-.16.07-.07-.02-.1-.1-.08-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m109.34,57.86c-.05.13-.2.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.19.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m108.48,58.44c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m109.37,58.58c-.08.19-.29.29-.48.21-.19-.08-.29-.29-.22-.48.07-.19.29-.29.48-.21.2.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m108.48,58.97c-.03.06-.1.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.8,59.08c-.05.14-.22.22-.36.16-.15-.06-.22-.22-.16-.36.05-.14.22-.22.36-.16.14.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.59,58.75c-.03.09-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.09.14-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.9,59.43c-.05.15-.22.22-.36.17-.14-.05-.22-.22-.16-.36.05-.15.22-.22.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.54,59.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.07,60.3c-.08.21-.31.31-.52.23s-.31-.31-.23-.52c.08-.21.31-.31.52-.23.21.08.32.32.23.52Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.78,60.01c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.17,58.91c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.5,55.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.69,53.08c-.04.11-.17.17-.28.12-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.73,52.48c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107,52.2s-.02.06-.02.06c0,0,.01-.03.02-.06.01-.03.02-.06.02-.06,0,0,0,.03-.02.06Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.03,52.73c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.03-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.11,53.13s-.04.04-.06.03c-.03,0-.04-.04-.03-.06,0-.03.04-.04.06-.03.02.01.04.04.03.06Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m104.1,53.33c-.03.06-.1.09-.16.07-.07-.03-.1-.1-.08-.16.03-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m111.31,50.94c-.04.13-.19.2-.32.15-.13-.05-.19-.2-.14-.32.05-.13.19-.2.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m112.11,50.51c-.05.15-.22.22-.36.16-.14-.05-.21-.22-.16-.36.06-.14.22-.22.36-.16.15.05.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m112.89,54.05c-.02.06-.1.09-.16.07-.07-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.02.1.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m113.67,54.98c-.04.1-.14.14-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.09,53.46c-.04.1-.15.14-.25.11-.09-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.31,54.01c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.2.32-.15.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m114.91,55.59c-.07.18-.27.27-.44.2-.18-.07-.26-.27-.2-.44.07-.18.27-.27.44-.2.18.06.27.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.68,55.25c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.46,55.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m114.52,56.17c-.04.1-.15.15-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.15.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m113.8,56.13c-.07.2-.29.29-.48.22-.19-.07-.29-.29-.22-.49.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m113.63,56.77c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m112.96,56.58c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m112.91,57.16c-.06.14-.22.22-.36.16-.15-.05-.22-.21-.16-.36.05-.14.21-.22.36-.16.15.06.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m109.5,56.73c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m116.44,48.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m117.08,48.17c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m117.67,47.84s-.07.08-.12.06c-.05-.02-.07-.08-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m117.99,47.19c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.14-.32.05-.13.19-.19.32-.15.13.05.2.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.81,46.96c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.09-.09.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.49,47.18c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m120,49.43c-.05.13-.19.19-.32.14-.13-.05-.2-.19-.15-.32.05-.13.2-.19.32-.14.13.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m120.64,50.91c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121.8,50.65c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.12.29Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.81,51.42c-.09.24-.36.37-.61.27-.24-.09-.36-.36-.27-.61.09-.24.36-.36.6-.27.24.09.36.36.27.6Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m120.14,52.04c-.04.1-.15.15-.24.11-.1-.04-.14-.14-.11-.24.04-.09.14-.14.24-.11.09.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.59,52.78c-.04.09-.14.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m120.76,52.52c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121,51.61c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121.55,51.92c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.23,51.28c-.08.22-.34.34-.56.25-.23-.08-.33-.34-.25-.56.09-.22.34-.34.56-.25.23.09.34.34.25.56Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.22,49.91s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.57,53.36c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.97,52.9c-.07.18-.27.27-.44.2-.17-.07-.27-.27-.2-.44.07-.18.27-.27.44-.2.18.07.27.27.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.97,47.52c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.46,46.57c-.04.11-.17.17-.28.12-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.54,46.28c-.08.21-.31.32-.52.24-.21-.08-.32-.31-.23-.52.08-.21.31-.32.52-.23.21.08.32.31.23.52Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.31,47.23c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.15.24-.11.1.03.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.7,47.53c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.68,48.36c-.06.16-.24.24-.4.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.6,48.75c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.15-.32.05-.13.2-.19.32-.14.13.04.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.54,47.96c-.04.09-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.92,49.13c-.04.1-.14.15-.24.11-.1-.04-.15-.15-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.82,46.86c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.6,42.98c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.46,43.53c-.05.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121.77,44.03s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121.42,44.59c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.12.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.22,40.24s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.04.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.49,39.25s-.07.07-.12.05c-.05-.02-.07-.07-.06-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126,38.54c-.02.06-.1.1-.16.07-.06-.02-.1-.1-.07-.16.02-.06.09-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.12,40.95c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.05.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.33,40.81c-.04.09-.15.14-.24.11-.1-.04-.14-.14-.11-.24.04-.09.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.43,41.78c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.15.1.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.25,42.52c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.98,41.13c-.02.06-.09.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.03.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.52,41.83c-.08.2-.29.29-.48.22-.2-.07-.29-.29-.22-.48.07-.19.29-.29.48-.22.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.9,42.66c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.26,43.28c-.07.18-.26.27-.44.2-.18-.07-.27-.26-.2-.44.07-.18.26-.27.44-.2.17.07.27.26.2.44Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m129.07,43.95c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.39,40.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.46,42.48c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.03-.1.14-.15.24-.11.09.03.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.58,35.63c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.33-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.61,36.44c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.1,36.03c-.04.1-.15.15-.24.11s-.14-.15-.11-.24c.04-.1.14-.14.24-.11s.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.86,36.91c-.03.06-.1.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.56,35.94c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.87,36.7c-.02.07-.1.1-.16.07-.06-.02-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.71,37.38c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.15-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.45,31.62c-.06.15-.22.22-.36.16-.15-.05-.22-.21-.16-.36.06-.14.22-.21.36-.16.14.06.22.21.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.46,30.88c-.02.06-.09.1-.16.07-.06-.03-.1-.09-.07-.16.03-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.74,30.49c-.02.06-.1.1-.16.07-.07-.03-.09-.09-.07-.16.02-.07.09-.1.16-.07.07.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.14,30.51c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.28,29.96s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.98,29.28c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.64,29.8c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.75,30.57c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.12.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.38,30.93s-.04.05-.08.03c-.03-.01-.05-.05-.04-.08.02-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.65,32.04s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.74,31.46c-.04.1-.15.14-.24.11-.09-.04-.14-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.44,25.27c-.04.1-.14.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.15.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.08,24.91c-.04.11-.17.17-.28.13-.11-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.14,25.6c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.77,26.06c-.02.05-.07.08-.12.06-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.08.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m132.36,26.45c-.05.13-.19.19-.32.15-.13-.05-.2-.19-.15-.32.05-.13.19-.2.32-.15.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.8,24.24c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.05,25.4c-.03.07-.1.1-.17.07-.06-.02-.09-.1-.07-.16.02-.06.1-.09.16-.07.07.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.72,25.48s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.86,26.33c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.23,26.41s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.08,29.42c-.02.05-.07.08-.12.06-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.79,29.84c-.02.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.96,30.71c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.9,31.29c-.05.13-.19.19-.32.15-.13-.05-.19-.2-.15-.32.05-.13.2-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.57,20.8s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.08.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.46,21.26c-.04.1-.15.14-.24.1-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.1.04.14.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.99,21.46c-.05.13-.2.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.2.15.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.93,22.14c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.42,20.76s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m126.52,20.42c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.55,21.91s-.07.08-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.66,20.13c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.07.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.53,20.58c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.05,20.78c-.05.13-.19.2-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.19.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.99,21.29c-.02.07-.1.1-.16.07-.07-.02-.09-.1-.07-.16.02-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m131.4,21.51c-.04.1-.15.14-.24.11-.1-.04-.15-.14-.11-.24.04-.1.15-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m130.2,19.69c-.02.06-.09.1-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.78,33.98c-.02.07-.09.1-.16.07-.07-.02-.1-.09-.07-.16.02-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.36,34.45c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.58,35.01c-.03.06-.1.09-.16.07-.06-.03-.09-.1-.07-.16.02-.07.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.18,35.35c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.93,40.03c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.53,39.77c-.02.06-.08.09-.14.06-.06-.02-.08-.08-.06-.14.02-.06.08-.08.14-.06.06.02.08.08.06.14Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.59,38.75s-.05.05-.08.04c-.03-.02-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.04.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.73,17.5c-.05.15-.22.22-.36.16-.14-.06-.22-.22-.16-.36.05-.15.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.84,18.17c-.03.07-.1.1-.16.07-.06-.03-.1-.1-.07-.16.02-.06.1-.1.16-.07.06.02.09.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.37,17.47c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.42,18.39c-.04.1-.14.15-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.09.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.88,15.42c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.12.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.08,14.55c-.02.06-.09.09-.16.07-.07-.02-.1-.1-.07-.16.03-.07.1-.1.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.06,13.74c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m123.12,14.55c-.04.11-.17.17-.28.13-.12-.05-.17-.17-.13-.28.04-.11.17-.17.28-.13s.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m122.61,14.92c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.1.14-.14.24-.11.09.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.66,12.42c-.05.13-.19.19-.32.14-.13-.05-.19-.2-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.75,11.74s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.18,11.15c-.06.14-.22.21-.36.16-.14-.05-.22-.22-.16-.36.06-.14.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.01,11.76c-.04.11-.17.17-.28.13-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.63,12.33c-.05.15-.22.22-.36.16-.15-.06-.22-.22-.17-.36.06-.15.22-.22.36-.16.14.05.22.22.16.36Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.37,12.91c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m121.17,10.56s-.07.07-.12.06c-.04-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m120.44,10.21c-.02.05-.07.07-.12.05-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.49,9.72s-.02.06-.02.06c0,0,.01-.03.02-.06.01-.03.02-.06.02-.06,0,0,0,.02-.02.06Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m118.55,9.56c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m123.19,11.93s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08,0-.03.04-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m119.7,9.87c-.05.13-.19.19-.32.15-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.15.13.05.2.2.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.07,12.4c-.06.16-.24.24-.41.18-.16-.06-.24-.24-.18-.4.06-.16.24-.24.4-.18.16.06.24.24.18.4Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m124.5,12.87c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.29,13.14c-.05.13-.19.19-.32.14-.13-.05-.19-.19-.14-.32.05-.13.19-.19.32-.14.13.05.19.19.14.32Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m125.64,13.71c-.04.11-.17.17-.28.12-.11-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.12.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.12,15.27c-.04.1-.14.14-.24.11-.1-.04-.14-.14-.11-.24.04-.1.14-.14.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.82,15.61c-.05.11-.17.17-.28.13-.11-.04-.17-.17-.12-.28.04-.11.17-.17.28-.13.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m127.96,16.3c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.55,16.58c-.04.1-.14.15-.24.11-.1-.04-.15-.14-.11-.24.04-.09.14-.14.24-.11.1.04.14.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m128.85,17.1c-.02.06-.09.1-.16.07-.07-.02-.1-.1-.07-.16.03-.07.09-.1.16-.08.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m113.55,9.72c-.03.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.09.09.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m114.54,9.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.21-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m114.24,10.18c-.04.1-.14.14-.24.11-.1-.04-.14-.15-.11-.24.04-.09.15-.14.24-.11.1.04.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m114.72,10.43c-.02.06-.1.09-.16.07-.07-.03-.1-.1-.07-.16.02-.06.1-.09.16-.07.06.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.8,10.91c-.07.19-.29.29-.49.22-.19-.07-.29-.29-.21-.48.07-.19.29-.29.48-.21.19.07.29.29.22.48Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m115.54,9.94c-.04.1-.15.14-.24.11-.1-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.1.03.15.14.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m112.61,9.83c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m111.88,9.11s-.07.07-.12.06c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m111.22,9.36c-.03.06-.1.09-.16.07-.06-.02-.09-.09-.07-.16.03-.07.1-.1.16-.07.07.03.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m111.79,9.71c-.04.1-.15.15-.24.11-.09-.04-.14-.15-.11-.24.04-.1.14-.15.24-.11.1.04.15.15.11.24Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m108.83,8.81c-.02.06-.1.1-.16.07-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.07.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m109.96,9.35c-.04.11-.17.17-.28.13-.12-.04-.17-.17-.13-.28.04-.11.17-.17.28-.12.11.04.17.17.13.28Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m109.43,8.88c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m110.64,9.4s-.07.08-.12.06c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.05.05.02.07.07.06.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.98,8.76s-.07.07-.12.05c-.05-.02-.07-.07-.05-.12.02-.05.07-.07.12-.06.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m107.41,8.41s-.07.07-.12.06c-.05-.02-.07-.08-.06-.12.02-.05.07-.08.12-.06.05.02.07.07.05.12Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m106.92,8.48s-.05.05-.08.04c-.03-.01-.05-.05-.03-.08,0-.04.05-.05.08-.04.03.01.05.05.03.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m105.86,8.28c-.02.07-.1.1-.16.08-.06-.03-.1-.1-.07-.16.03-.06.1-.1.16-.07.06.02.1.1.07.16Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m104.78,7.97c-.03.08-.12.12-.2.09-.08-.03-.12-.12-.09-.2.03-.08.12-.12.2-.09.08.03.12.12.09.2Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m103.75,8.04s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m103,7.81s-.05.03-.09.02c-.04-.02-.06-.05-.06-.07.01-.03.05-.03.09-.02.04.01.07.05.06.07Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m101.88,7.7s-.05.05-.08.03c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
          <path
            d="m100.6,7.54s-.05.05-.08.04c-.03-.01-.05-.05-.04-.08.01-.03.05-.05.08-.04.03.01.05.05.04.08Z"
            fill="#1b2e1a"
            strokeWidth="0"
          />
        </g>
        <g>
          <use transform="translate(4.73 20.87) scale(.24)" href="#image" />
        </g>
        <g>
          <use transform="translate(4.73 20.87) scale(.24)" href="#image" />
        </g>
        <g>
          <image
            width="323"
            height="317"
            transform="translate(6.73 19.37) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUEAAAE9CAYAAACV7tCLAAAACXBIWXMAAC4jAAAuIwF4pT92AAADsklEQVR4nO3c22rbQBSG0d+OU5/SE33/RyyFum3SJHZ6sTVICaEUIluuWQsGx+ALXZiP2RrFCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwD+ZTX0BXIzZYD0NFpy1q6kvgIswS7JIskzyLs+/V0LIWRNBxnCVCuCHJNtUCBM7Qv4DIsgYFkk2ST6nQrhMMk/F79AtIeQsiSBvNUt9j7ZJvqQiuEqFcd59RgQ5W4upL4CL0O4JrpO8794vu3WdiuQuyX2SfYzInBE7Qd5qltrxrZJ8TPIp/X3B6/QRnKc/OT5McqXwChFkLG03uElykwrhKhXDtq67zwohZ0MEGcshNerO0o/Fm/QhbK/X6Z8nTIzFTEwEGctTksduJRXCm1T8li9WC2Ibk+0MmYwIMqZDKoIP3d/z9Acm6/RBXA3eD0dku0JOTgQZ2yEVwdskv5L8ToVum+chXHbv2wlyOziBkxJBjqGF8Fe3HlKRu0qNwa+Nxy2ObURu7A45KhHkWNpofJ8K4Y/utY3Jwxi28bitYQzb/UIx5ChEkGN6Sp0Y3yf5meR7t16LYRuV16lT5XX6k+R9+oesYVQiyCm0XeFdakc4jOE+fQzbWDw8SLlKH1IhZHQiyKm0sfZlDHepXWLbGbadYLtHuEjFrx2yeJSGUYkgp/a3GN6lRuBNKoDt3+xuk3xLxXJ/+kvmkvkBBabSfmJrn9rhtXuGd6nobVOh3KV2gY8xCnMEIsjUhjF8SAXxa2on+JT+UGUX9wQ5Ag+nck7ajzC0h6eTPpCP8agMRyCCnKPXvpfiBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAT+QPVloprAE3nuwAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="318"
            height="322"
            transform="translate(9.16 17.69) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT0AAAFDCAYAAABIs9ksAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEP0lEQVR4nO3da08cZQCG4XtpsYUexLPR///TjMZWCx5KocD64Z03VBM/ubvT4HUlE8JmSebD5OF5DzNTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMD/0WbtE+DB+ec1tV3lLOBfCD12ZbMcj5Zj0wi8m+puOWB1j9c+AR6MTfWkeladVsfVbfVndVldLb9v0/5Y0aO1T4AHYTa859U31ffVd9XXy2dPqqPlu9sEHyvS9NiVGXxPq5fVF43Gd9doez9Xr6qfqjeN5mfIy8FpeuzKUeOf6NPqZDmeV2fVV40G+GXjmruqrhN6rEDosQ9H3S9ofFK9qD5vhN6L5Tvvu1/gMNzlYIQeuzKD63Y5bpbjthGCc9j7WSP4ThqBeNdofXORA/ZK6LFrt40W9676o3rbCLVtY0HjZWO4Oxc6HjdWdy8TfByA0GMfbhtB966xiDG3rdRY3DhrzPF925j3u64uGgFpno+9Enrsw7YRXrP1XTaC77pxzZ02hrhn1afL3/xSnTcWObQ99kbosW8z/Gbzu2kMaZ91v5H5qPqtsZXl7fIdwcdeCD0OYTa/943w23QfeieNRY45t3eeYS57JPQ4pLm6u2kE3Wx6MwCrXjca31z8gJ0SehzS3NYy9+Z90gi900bj2zQC73VjDlDbY+eEHoc2295NI+Rm05tD3OvG7WrnaXvsgdBjDbPt1f3tanOz8rYReK8zt8ceCD3W8OFtZ8eN0Dvtvu1dNbawXKTtsWNCj7UdN/bsPW80veNGuztvBN9l2h47JPRY2+Pu5/Vm6D1qhN2rRtt7v9rZ8eAIPda2aQTd3K93vHz+tvqh+rUxxIWd8BBR1nTXmL+7aITbWaPtnfT3x8vDzgg91nbbaHVzf95sfRd5ujJ7YHjLx2C2ufkejTmf92P1eyMYYSc0Pda2bczZvWnM7101rsuL5fDwAXbKe2/5GMyXCj1pLGYcNZ7IMp/KIvTYGaHHx2K+LPxo+fnh+zMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA/+QsZ07AQv1uaSAAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="313"
            height="332"
            transform="translate(26.57 20.65) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAFJCAYAAAARyAG9AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEi0lEQVR4nO3dyW4bVxAF0EuJ1GAltuEsEuT//y+JY9myzCGL6kJT2/RAWDoHIEzRWvSCuKpX9fp1AgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwc9hc+gJ4lTYZv1un4QWrub70BfDqbJJcJdkO/8Lqtpe+AF6dTep7tctYrR0vekW8Of6iMrer1Epgmwo5y1BWJ9iY0yYVaru8bHMIN1Yl2JhT99buUuGmYuMi9NiY01Uq0G6Gn8+no7AaFRtz6d7abSrYruP7xYX44jGXTSrQ3qWWoj08gNVZijKX7q/dDq/D8JlwY3UqNubQvbTev7Yb3l9Hn40LEGzMYZMKs/vUMvQmY+VmScrqBBtT9d61uyS/pHpst6mQexjeW5KyKj025tAV2/ngIKlw26WC7XCZS+MtEmxM1Te97/Jyq8cxY69NtcaqBBtT9TaPh4z9tavUHQd3Gau2fVRtrESPjSm6v/Yuycckv6aqtq7eHpK8TwWcPhurUbEx1VXGiu1+eH8aPr/POEzwR5TVCDbmsM24xWOX6q9dZdzy0QMEN8WzCsHGVOcn5vbm3FOqp3bMy20fzxe6Rt4YwcYU5+ev9UT0vGLbpHpsn5L8k+Rp+D9VG4vyzAOmuE5tyv0jyZ+pEOtl5/nrmORbkq9JfkSwsTAVG//X+UT0U2oi2tPPvgG+BwYfk/yW5K9UuKnaWJRgYw79wJaehvbZbB1w+yQfUiG4HX4WbCzGUpQpel9ah9n5CR/bvNy7tk/yJcm/qSGCJ1exGMHGFKdUVfaU5DHVR9ukJqF9skefpHtK8j01ROjlKCxCsDHVMTUQ6OHAIeMRRh1uXbk9pfpsX2I5yoIEG3M4pgLtOVWVHTMeE35+Jttzks/Dq38PZifYmEsPEH6kAuyQCreu3Po03Q63r6mqDWYn2Jhbh9v3jMvSPvVjmwrAHiKo2liEYGMJ5+F23kvrZ47uU1XbYyr89NqYlWBjKR1uX1PV2beMJ35cp0Ltc8bbrGA2go0lHVM9tcfhtU9VbDfD539nrNpgNu48YEmnVNV2yHjaxz7J76k+m0BjEU40ZS39XIT3qftKDxkrNtNRZiXYWFPfON8rhX4OguEB8NPzdHgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJvsPSkONP7ykQmUAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="327"
            height="323"
            transform="translate(39.33 26.98) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAAFBCAYAAADkEG12AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEhElEQVR4nO3d3U7bQBCA0Qk/Le37P2uBAEkvzMiTZROksrZDdY60ckCtxEX0adZ2nAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALheu63/APhH9b173Oyv4L8ljnwnn71fRZJhxJHvYtccW8fmCF8ijnwHu7gcxxpGcWSIu63/ALigBvFcINuJcRcCyQDiyLVqY3jT/HwugMLIEOLINdp11k2cBvMYttEsSBy5Jr1JsT2mQ/m3Aslw4si16E2KdeXvc1q8iYi38v9NkgwljmztUhRvy+t0jGlqfAt3W7AgcWQr7ZXoNoi35XU9z3iIj1eoTYsMJ45soTct3pZ1Fx+nxmNM02IbQoFkEeLImtoLLnVavCvHGseIOYyH8nO7IgSSgcSRNVzaQt+VdR+nYcwLMDkx9m7jEUQWIY4srXexpW6f72OOYh7reca6la7nHNvXIslQ4shS6g3bl6J4HxE/4uPUeG5iPJQliCxGHBmtF8W6ha5BrOs+PoYxIuI1Tm/fqWE0NbIYcWSkS1egaxR/Nse6nY6YIriP82FsAwnDiSOjnLvY0k6KDzFFMVfdTmcI9zFfjMkw1iWKLE4cGaENY159ziBmCB/KqlNjToxtGN9imh5fYw6jqZFViCOj1K10hjGD+Ot9PZRjPc+4izmMec4xJ8bXskSR1YgjX9V+2qXGMWP4O04D+RCn5xkPMcUvI5lRfInTqTEnR4FkceLIKL1tdT3X2J5nrNvp3jZ6H1McM5CiyKrEkRF6X2fQPnLs3PMYM4oZwn1EPMdpGJ1rZHXiyAi9p+TUT7Hktvkl5nOKea7xGPOk+BgRTzHF8Tnm23nqdhpWIY6MVGOY02C9sTsjWT8iWOP4FBF/Yg5kOzmaGlmNODJKnRQzdrmNrr8792CJl5iC+Pi+TI1sShz5qvahEPUJ3W342uc09uLZbqk9XIJNiCOjZBxTPde4j9Mne/e+SbBeqc6LMaZGNuM7OBjlsy/Iar9FsMYxov8xQVeo2Yw4MlLvlp5LK/9t7+p2+7xGWJU4soRd83rX/L49RvRvAxJGNiOOLK33HmvjGdH/HhhhZDPiyFbOvfcEEQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACo/gLqeyQ6e6OMGQAAAABJRU5ErkJggg=="
          />
        </g>
        <g opacity=".3">
          <image
            width="327"
            height="361"
            transform="translate(19.43 -1.87) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <image
            width="332"
            height="356"
            transform="translate(7.38 -6.76) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <image
            width="338"
            height="315"
            transform="translate(10.49 -7.7) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVMAAAE7CAYAAABg7GJDAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD60lEQVR4nO3cy07bQACG0Z9cCBS1UFV9/9cst9DFeJTJ4KAunDhJz5FGNpBFFtbHeDxJAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAX4mbuN8BV6q+rj1neBZyQmDKlm2EshpGUkG6HYx1wdZZzvwGuyiLlmtokuR/GOvthTfwT5wqJKVOpM9J1kockj8P4luQ2u1krXCUxZSo1ppsk35P8SvI7yVNKUNcp19tYUEWWiyemTKXGdJXkLiWoP4fxmDJb3WQ/qGarXA0xZWrt7X6N6o/hWIO6TonuMvsPq+BiiSnH0D61X6UE9GEY9ymR3aSspdbb/0V2M9V2wEUQU6ZWt0Jtk7wNx6Rca+uUiN5l97T/LiWq7Sy1D2slrpwtMeUYalDfU4L6Opy3Yb1NCWs7Q21v/8dmqxk5wlkQU46lBvUtyUuS5yR/hvNtdntSlykBXaXE9F/DOhZYmI2YckztDLUG9Tm7oLafimrjWkO6as77JYCxuCbWWpmJmHIKNaivKSF9Gc7reB9G+wmpfua6HBlj66v9GquwchJiyinU2We97a9RbW/927DW11bt5/2X3bEf1liZhZhyau2DqTao9fb/dfjbW3ZhbbdatWFtZ7CHZql2BHASYsoc2q1T7Sy1PfZRrbsBxr59qp+JHtpa1b4eJrWa+w3w36kRrGGsa6nLlBnqOp+f5tcotssF/Vf7JfsBXQy/b3+uSwe+BpDJ+Q/N3Oo1WGeT7QOm/iOnNajJ5xnq9sD46M59rypHIaaci35r09jDpfZ1H/l8/fYB7eMppByNmHKO+rAeWv/sn9T3ywD54giTElPO3Vdbm8Z+dyiaIspRiSmX6qtrVzgBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICr9xfbO5wBuyY/lAAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="312"
            height="328"
            transform="translate(31.28 -.15) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATkAAAFGCAYAAAARlejlAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEbElEQVR4nO3dzW7bOBQG0M9O3NhNMjPv/5TFBM1fa2cW5IXUQXdD0UDmHICQ42ShhfDlUqSuEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAuKrdtU+AT+nf19XHVc4CIuQYa7caa5d+FHZMd3PtE+DTqHC7SXKb5NA/rwNPyDGdkGOECrjbJHdJjv1427//yFLNwVS31z4BPo2bJF+SfO3jJsnPJK9pIXeOoOMKhBwj1DT1LslDHzdJ3vvv35Pss1R1MI2QY4QKuarkKuRek/xIu84q5AQdUwk5RtpnuS93SAuzL2mBt7/iefE/JuQY5SNLhVZV3Tkt7NaVHEwl5BihAu7Sj/ssldwxv1Zz9TcwhZBjlHXIVSW3z7Kd5BBTVq5AyDHKx2rs0kLtkOQ+bTGiqjmLD0zlPysjVLid0/bGndOurbskp7SQq83BrjmmcsExyiUt4N77uKSF2qmPY5YpqwUIphFyjLCu5N7S9sf9zHJP7ndTVphCyDHKR5ZK7iUt7JI2Tb1P2yB8imqOyYQco9TqaoXcS5Z9cvdJHvuxVl2FHFMIOUapkKuH8l/SHunap01VH9OquWOW7iSwOSHHSDVlfUvyPS3oLmnV20Na0NW9OdUcU+gnx2jrjiQ1TT317yv8ntOqvHPsl2NjQo7R1h2Cj1nuxR3SqrznPt76z0KOTQk5tlKPdj0k+SOtmktauD1nuWfnWVY2JeTYQlVz1UTzr36saq5WX1VzbE7IsZXqRPI1yZ99HPvvavVVNcfmhBxbWXcLrinr+t0PL3FvjgmEHFuqN3id0hYgHtNC7yPLvblqka6aYxNCji3t8uu0tfbJqeaYRsixld3quN5O8pClmnuNlVY2JuSYoZponrI82rVLe871ex9vsTmYDQg5ZlhPW6sd+j5LyD1leQrCC6gZSsgxS7VFr35yl7Rp6t9JvqWFnZBjOCHHDOu3eZ3Twuw1rYL71sdzlo7CMIwX2bC1dZ+5p/75Oe151vTPTxFwbESrG2apqeohbXX10L+r1kw/YhsJGxByzFTPtO6z9JOrd0NUxQdDCTmu4XfXnQoOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPiv/gH1abd7haFlpQAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <g>
            <image
              width="323"
              height="337"
              transform="translate(11.62 -2.43) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g>
            <image
              width="323"
              height="336"
              transform="translate(11.51 -2.42) scale(.24)"
              href="data:image/png;base64,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"
            />
          </g>
          <g>
            <path
              d="m52.15,40.59s.05,0,.07,0c.27-3.78-1.99-4.74-1.99-4.74h.02s-.01,0-.02,0c-.67-.35-1.32-.64-1.97-1.22,0,0,.03,1.97,0,2.43,0,0,.33,3.26,3.96,3.53"
              strokeWidth="0"
            />
            <g>
              <path
                d="m52.25,39.5c-.08.18-.2.33-.36.44-.37.26-.86.26-1.36.05,0,0-.01,0-.02,0-.01,0-.03,0-.04-.02-.02,0-.04-.02-.07-.03-.01,0-.02-.02-.04-.02,0,0,0,0-.02,0,0,0-.01,0-.02,0-.02-.01-.04-.02-.06-.03-.02-.01-.04-.02-.07-.04,0,0-.01,0-.02-.02,0,0-.01,0-.02,0,0,0-.01,0-.02-.01-.03-.02-.05-.04-.08-.05-.02-.01-.04-.02-.05-.04,0,0-.01,0-.02-.01,0,0,0,0-.01-.01-.02-.02-.04-.03-.06-.05-.03-.02-.05-.04-.08-.06,0,0-.02-.01-.02-.02,0,0-.01,0-.01-.01-.03-.03-.06-.06-.09-.08-.02-.02-.04-.03-.05-.05,0,0-.01-.01-.02-.02-.03-.03-.06-.06-.09-.09-.02-.02-.05-.05-.07-.07-.03-.04-.07-.07-.1-.11-.07-.08-.14-.17-.2-.26-.07-.1-.13-.19-.18-.29-.02-.04-.05-.08-.07-.12-.02-.03-.03-.06-.05-.09-.02-.03-.03-.07-.05-.1,0,0,0-.01-.01-.02-.01-.03-.03-.06-.04-.09-.01-.03-.03-.06-.04-.09,0,0,0-.01,0-.02,0,0,0-.02-.01-.03-.01-.04-.02-.07-.03-.11,0-.02-.01-.03-.02-.05,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.02-.01-.05-.02-.07,0-.03-.01-.06-.02-.09,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0-.01,0-.03,0-.04,0-.03,0-.06-.01-.09,0-.01,0-.03,0-.04,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.02,0-.03,0-.05,0-.03,0-.05,0-.08,0-.01,0-.03,0-.04,0,0,0,0,0-.01-.03-.54.14-1.01.5-1.27.26-.19.6-.24.95-.17-.24-.12-.48-.25-.72-.38-.22.04-.42.12-.58.27-.72.63-.54,2.11.41,3.29.43.54.96.95,1.5,1.15.61.23,1.16.18,1.54-.15.04-.03.07-.06.1-.1,0-.12-.01-.25-.02-.37Z"
                strokeWidth="0"
              />
              <path
                d="m49.08,35.95c-.37.26-.53.72-.5,1.27,0-.51.18-.96.54-1.21.27-.2.62-.25.98-.2-.02-.01-.04-.02-.06-.03-.35-.07-.69-.02-.95.17Z"
                fill="#b8b8b8"
                strokeWidth="0"
              />
              <path
                d="m50.53,39.99c.5.21,1,.21,1.36-.05.16-.11.28-.26.36-.44,0-.03,0-.06,0-.1-.09.2-.22.36-.4.48-.37.26-.84.28-1.32.11Z"
                fill="#b8b8b8"
                strokeWidth="0"
              />
              <path
                d="m50.51,39.98s.01,0,.02,0c.48.17.96.15,1.32-.11.18-.12.3-.29.4-.48,0,0,0,0,0,0-.09.2-.22.36-.4.48-.37.26-.85.28-1.34.1Z"
                fill="#b9b9b9"
                strokeWidth="0"
              />
              <path
                d="m49.12,36c-.37.25-.55.7-.54,1.21,0,0,0,0,0,.01,0-.52.18-.96.54-1.22.28-.2.62-.25.98-.19h0c-.36-.06-.7,0-.98.19Z"
                fill="#b9b9b9"
                strokeWidth="0"
              />
              <path
                d="m50.47,39.96s.03.01.04.02c.49.18.97.16,1.34-.1.17-.12.31-.29.4-.48h0c-.09.19-.22.36-.4.48-.38.27-.88.28-1.38.08Z"
                fill="#bababa"
                strokeWidth="0"
              />
              <path
                d="m49.12,36c-.37.26-.55.71-.54,1.22,0,.01,0,.03,0,.04-.01-.53.17-1,.54-1.26.28-.2.63-.25.99-.19h0c-.37-.06-.71,0-.99.19Z"
                fill="#bababa"
                strokeWidth="0"
              />
              <path
                d="m49.12,36c-.37.26-.55.73-.54,1.26,0,.03,0,.05,0,.08-.03-.57.14-1.06.54-1.34.28-.2.63-.25,1-.19,0,0,0,0,0,0-.36-.06-.71,0-.99.19Z"
                fill="#bbb"
                strokeWidth="0"
              />
              <path
                d="m50.4,39.93s.04.02.07.03c.5.2,1,.19,1.38-.08.18-.12.31-.29.4-.49,0,0,0,0,0,0-.09.2-.22.37-.4.49-.39.27-.92.28-1.44.05Z"
                fill="#bbb"
                strokeWidth="0"
              />
              <path
                d="m50.36,39.91s.03.01.04.02c.52.22,1.05.22,1.44-.05.18-.12.31-.29.4-.49,0,0,0,0,0,0-.09.2-.22.37-.4.5-.41.28-.95.27-1.48.04Z"
                fill="#bcbcbc"
                strokeWidth="0"
              />
              <path
                d="m49.12,36.01c-.39.28-.57.77-.54,1.34,0,.01,0,.03,0,.05-.05-.58.13-1.1.53-1.38.28-.2.63-.26,1-.19,0,0,0,0,0,0-.37-.06-.72,0-1,.19Z"
                fill="#bcbcbc"
                strokeWidth="0"
              />
              <path
                d="m49.12,36.01c-.4.28-.58.8-.53,1.38,0,0,0,.01,0,.02-.05-.59.12-1.11.53-1.4.28-.2.64-.25,1.01-.19h0c-.37-.07-.72-.01-1,.18Z"
                fill="#bdbdbd"
                strokeWidth="0"
              />
              <path
                d="m50.34,39.9s.01,0,.02,0c.53.24,1.07.25,1.48-.04.18-.12.31-.29.4-.5h0c-.09.2-.23.37-.4.5-.41.28-.96.27-1.5.03Z"
                fill="#bdbdbd"
                strokeWidth="0"
              />
              <path
                d="m49.12,36.01c-.41.29-.58.81-.53,1.4,0,0,0,0,0,.02-.06-.6.12-1.12.53-1.41.28-.2.64-.26,1.01-.19,0,0,0,0,0,0-.37-.07-.73-.01-1.01.19Z"
                fill="#bebebe"
                strokeWidth="0"
              />
              <path
                d="m50.33,39.89s.01,0,.02,0c.54.25,1.09.26,1.5-.03.18-.13.31-.3.4-.5,0,0,0,0,0,0-.09.2-.23.38-.4.5-.41.29-.97.28-1.51.02Z"
                fill="#bebebe"
                strokeWidth="0"
              />
              <path
                d="m49.12,36.01c-.41.29-.59.82-.53,1.41,0,.02,0,.03,0,.04-.07-.61.11-1.16.53-1.45.29-.2.65-.26,1.02-.18,0,0,0,0,0,0-.38-.07-.73-.02-1.01.18Z"
                fill="#bfbfbf"
                strokeWidth="0"
              />
              <path
                d="m50.27,39.86s.04.02.06.03c.54.25,1.1.27,1.51-.02.18-.12.31-.3.4-.5h0c-.09.2-.23.37-.4.5-.43.3-1.01.27-1.57,0Z"
                fill="#bfbfbf"
                strokeWidth="0"
              />
              <path
                d="m50.2,39.82s.05.03.07.04c.56.28,1.14.31,1.57,0,.18-.12.31-.3.4-.5h0c-.09.2-.23.38-.4.5-.44.31-1.06.27-1.64-.05Z"
                fill="silver"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.02c-.42.29-.59.84-.53,1.45,0,.03,0,.06.01.09-.09-.65.08-1.23.51-1.54.29-.2.65-.26,1.03-.18h0c-.37-.07-.74-.02-1.02.18Z"
                fill="silver"
                strokeWidth="0"
              />
              <path
                d="m50.18,39.81s.01,0,.02.02c.58.32,1.2.35,1.64.05.18-.13.31-.3.4-.51,0,0,0,0,0,0-.09.2-.23.38-.41.51-.44.31-1.07.27-1.65-.06Z"
                fill="#c1c1c1"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.02c-.44.31-.61.89-.51,1.54,0,.01,0,.02,0,.04-.11-.66.06-1.26.51-1.58.29-.2.65-.25,1.03-.18,0,0,0,0,0,0-.38-.07-.74-.02-1.03.18Z"
                fill="#c1c1c1"
                strokeWidth="0"
              />
              <path
                d="m50.16,39.8s.01,0,.01,0c.59.33,1.22.38,1.66.06.18-.13.32-.3.41-.51h0c-.09.2-.22.38-.41.5-.45.32-1.08.27-1.67-.06Z"
                fill="#c2c2c2"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.02c-.45.31-.62.91-.51,1.58,0,0,0,.01,0,.02-.11-.67.06-1.28.51-1.6.29-.21.65-.25,1.03-.18h0c-.38-.08-.74-.03-1.03.18Z"
                fill="#c2c2c2"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.02c-.45.32-.62.92-.51,1.6,0,0,0,.01,0,.02-.12-.68.04-1.29.5-1.61.29-.21.66-.26,1.04-.17,0,0,0,0,0,0-.38-.08-.75-.03-1.04.18Z"
                fill="#c3c3c3"
                strokeWidth="0"
              />
              <path
                d="m50.14,39.78s.01,0,.02.01c.59.34,1.22.38,1.67.06.18-.13.32-.3.41-.51h0c-.09.2-.22.38-.41.51-.45.32-1.09.27-1.69-.08Z"
                fill="#c3c3c3"
                strokeWidth="0"
              />
              <path
                d="m51.83,39.86c-.48.34-1.15.26-1.77-.13.03.02.05.04.08.05.6.34,1.24.39,1.69.08.18-.13.32-.31.41-.51h0c-.09.2-.23.38-.41.51Z"
                fill="#c4c4c4"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.02c-.46.32-.62.94-.5,1.61,0,.03.01.06.02.09-.15-.71,0-1.37.48-1.7.29-.21.66-.25,1.05-.17h0c-.38-.08-.75-.03-1.04.17Z"
                fill="#c4c4c4"
                strokeWidth="0"
              />
              <path
                d="m51.83,39.86c-.49.35-1.19.26-1.82-.16.02.02.04.03.05.04.62.39,1.29.46,1.77.13.18-.13.32-.31.41-.52,0,0,0,0,0,0-.09.21-.23.39-.41.52Z"
                fill="#c5c5c5"
                strokeWidth="0"
              />
              <path
                d="m49.13,36.03c-.47.33-.63.99-.48,1.7,0,.02.01.05.02.07-.18-.74-.02-1.42.47-1.77.29-.21.67-.26,1.05-.17,0,0,0,0,0,0-.39-.08-.76-.03-1.05.17Z"
                fill="#c5c5c5"
                strokeWidth="0"
              />
              <path
                d="m51.83,39.85c-.49.35-1.2.25-1.84-.17,0,0,.01,0,.02.01.63.42,1.33.51,1.82.16.18-.13.32-.31.41-.52h0c-.09.21-.22.39-.41.52Z"
                fill="#c6c6c6"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.03c-.49.35-.64,1.03-.47,1.77,0,0,0,.01,0,.02-.19-.74-.04-1.44.46-1.78.3-.21.67-.26,1.06-.17,0,0,0,0,0,0-.39-.08-.76-.04-1.05.17Z"
                fill="#c6c6c6"
                strokeWidth="0"
              />
              <path
                d="m51.83,39.85c-.5.35-1.21.25-1.85-.18,0,0,0,0,.01.01.63.43,1.35.52,1.84.17.19-.13.32-.31.41-.52h0c-.09.21-.23.39-.41.52Z"
                fill="#c7c7c7"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.03c-.49.35-.65,1.04-.46,1.78,0,0,0,.01,0,.02-.19-.75-.04-1.45.46-1.8.3-.21.67-.26,1.07-.17,0,0,0,0,0,0-.39-.08-.76-.04-1.06.17Z"
                fill="#c7c7c7"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.03c-.5.35-.65,1.05-.46,1.8,0,.02.01.04.02.05-.21-.76-.07-1.49.44-1.85.3-.21.68-.26,1.07-.17,0,0,0,0,0,0-.39-.09-.77-.04-1.07.17Z"
                fill="#c8c8c8"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.85c-.51.36-1.26.24-1.91-.23.02.01.04.03.06.05.64.44,1.35.53,1.85.18.19-.13.32-.31.41-.53,0,0,0,0,0,0-.09.21-.23.4-.41.53Z"
                fill="#c8c8c8"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.03c-.51.36-.65,1.09-.44,1.85.01.04.02.08.03.11-.26-.8-.13-1.59.41-1.96.3-.21.68-.26,1.08-.17,0,0,0,0,0,0-.39-.09-.77-.04-1.07.17Z"
                fill="#c9c9c9"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.85c-.53.38-1.32.24-1.99-.28.02.02.05.04.08.06.65.47,1.4.59,1.91.23.19-.13.32-.31.41-.53,0,0,0,0,0,0-.09.22-.22.4-.41.53Z"
                fill="#c9c9c9"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.85c-.54.38-1.33.23-2.01-.3,0,0,.02.01.02.02.67.52,1.45.66,1.99.28.19-.13.32-.31.41-.53t0,0c-.09.22-.22.4-.41.54Z"
                fill="#cacaca"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.04c-.53.37-.66,1.15-.41,1.96,0,0,0,.02.01.03-.27-.81-.14-1.61.4-1.99.3-.22.68-.26,1.08-.17,0,0,0,0,0,0-.39-.09-.78-.05-1.08.17Z"
                fill="#cacaca"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.04c-.54.38-.67,1.17-.4,1.99,0,0,0,.01,0,.02-.28-.82-.15-1.62.39-2,.3-.22.69-.26,1.09-.16,0,0,0,0,0,0-.4-.09-.78-.05-1.08.17Z"
                fill="#cbcbcb"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.84c-.54.38-1.34.23-2.02-.31,0,0,0,0,.01.01.68.53,1.47.68,2.01.3.19-.13.32-.32.41-.54h0c-.09.21-.22.4-.41.53Z"
                fill="#cbcbcb"
                strokeWidth="0"
              />
              <path
                d="m49.14,36.04c-.54.38-.67,1.18-.39,2,.01.03.03.06.04.09-.32-.85-.21-1.7.36-2.09.3-.21.69-.26,1.09-.16h0c-.4-.1-.78-.06-1.09.16Z"
                fill="#ccc"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.84c-.57.4-1.42.21-2.11-.39.03.03.06.05.09.08.68.54,1.48.69,2.02.31.19-.13.32-.32.41-.54,0,0,0,0,0,0-.09.22-.23.41-.42.54Z"
                fill="#ccc"
                strokeWidth="0"
              />
              <path
                d="m51.82,39.84c-.58.41-1.46.2-2.16-.44.02.02.03.03.05.05.69.6,1.54.79,2.11.39.19-.13.33-.32.42-.54h0c-.09.22-.22.41-.42.54Z"
                fill="#cdcdcd"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.04c-.56.39-.68,1.24-.36,2.09,0,.03.02.06.04.09-.36-.88-.26-1.78.32-2.19.3-.21.69-.26,1.1-.16h0c-.4-.1-.79-.06-1.09.16Z"
                fill="#cdcdcd"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.04c-.58.41-.69,1.31-.32,2.19,0,0,0,.02.01.02-.38-.89-.27-1.79.31-2.21.31-.21.7-.26,1.1-.15,0,0,0,0,0,0-.4-.1-.79-.06-1.1.16Z"
                fill="#cecece"
                strokeWidth="0"
              />
              <path
                d="m51.81,39.84c-.58.41-1.47.2-2.18-.45,0,0,.01.01.02.02.71.64,1.58.84,2.16.44.19-.13.33-.32.42-.54h0c-.09.22-.23.41-.42.54Z"
                fill="#cecece"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.04c-.58.41-.69,1.32-.31,2.21.02.04.03.07.05.1-.43-.92-.34-1.88.27-2.3.31-.22.7-.26,1.11-.16h0c-.4-.1-.79-.06-1.1.15Z"
                fill="#cfcfcf"
                strokeWidth="0"
              />
              <path
                d="m51.81,39.84c-.61.43-1.54.18-2.27-.54.03.03.06.06.09.09.71.65,1.59.86,2.18.45.19-.14.33-.32.42-.55h0c-.09.22-.23.41-.42.55Z"
                fill="#cfcfcf"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.05c-.61.43-.69,1.38-.27,2.3.01.03.03.06.05.09-.48-.94-.41-1.96.22-2.39.31-.22.7-.26,1.11-.16h0c-.41-.1-.8-.06-1.11.15Z"
                fill="#d0d0d0"
                strokeWidth="0"
              />
              <path
                d="m51.81,39.83c-.63.44-1.61.16-2.33-.61.02.02.05.05.07.07.72.72,1.66.96,2.27.54.19-.14.33-.33.42-.55h0c-.09.22-.23.41-.42.55Z"
                fill="#d0d0d0"
                strokeWidth="0"
              />
              <path
                d="m50.27,35.9s0,0,0,0h0s0,0,0,0Z"
                fill="#d0d0d0"
                strokeWidth="0"
              />
              <polygon
                points="50.27 35.9 50.28 35.9 50.27 35.9 50.27 35.89 50.27 35.9"
                fill="#d1d1d1"
                strokeWidth="0"
              />
              <path
                d="m51.81,39.83c-.66.46-1.7.14-2.43-.72.03.04.07.08.1.11.73.77,1.7,1.05,2.33.61.19-.14.33-.33.42-.55,0,0,0,0,0,0-.09.23-.23.42-.42.56Z"
                fill="#d1d1d1"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.06c.31-.22.71-.27,1.12-.16h0c-.41-.11-.81-.07-1.12.15-.63.44-.7,1.45-.22,2.39.02.04.04.08.07.12-.55-.97-.5-2.05.15-2.51Z"
                fill="#d1d1d1"
                strokeWidth="0"
              />
              <path
                d="m50.28,35.9h0c-.41-.11-.81-.07-1.12.15-.65.46-.7,1.53-.15,2.51.05.1.11.2.18.29.06.09.13.18.2.26.73.85,1.77,1.18,2.43.72.2-.14.33-.33.42-.56h0c-.09.22-.23.42-.42.55-.71.51-1.89.07-2.62-.97-.73-1.04-.74-2.3-.03-2.8.32-.23.72-.26,1.14-.15,0,0,0,0-.01,0h0,0Z"
                fill="#d2d2d2"
                strokeWidth="0"
              />
              <path
                d="m49.15,36.06c-.72.5-.71,1.76.03,2.8.73,1.04,1.91,1.48,2.62.97.2-.13.34-.33.42-.56,0,0,0,0,0,0-.09.23-.22.43-.42.56-.71.5-1.89.07-2.62-.97-.73-1.04-.74-2.3-.03-2.8.32-.22.72-.26,1.15-.15,0,0,0,0-.01,0-.42-.11-.82-.08-1.14.15Z"
                fill="#d3d3d3"
                strokeWidth="0"
              />
              <path
                d="m49.16,36.06c-.72.5-.71,1.75.03,2.8.73,1.04,1.91,1.47,2.62.97.2-.13.34-.33.42-.56h0c-.09.23-.23.43-.42.56-.72.5-1.89.07-2.62-.97-.73-1.04-.75-2.29-.03-2.79.32-.23.73-.26,1.16-.14,0,0,0,0-.01,0-.42-.12-.83-.08-1.15.15Z"
                fill="#d4d4d4"
                strokeWidth="0"
              />
              <path
                d="m49.16,36.06c-.72.5-.71,1.75.03,2.79.73,1.04,1.91,1.47,2.62.97.2-.13.34-.33.42-.56,0,0,0,0,0,0-.09.23-.23.43-.42.57-.72.5-1.89.07-2.62-.97-.73-1.04-.74-2.29-.02-2.79.32-.23.74-.26,1.16-.13,0,0,0,0,0,0-.42-.12-.83-.09-1.16.14Z"
                fill="#d5d5d5"
                strokeWidth="0"
              />
              <path
                d="m49.16,36.06c-.72.5-.71,1.75.02,2.79.73,1.04,1.9,1.47,2.62.97.2-.14.34-.34.42-.57,0,0,0,0,0,0-.09.23-.23.44-.43.57-.71.5-1.89.07-2.62-.97-.73-1.04-.74-2.29-.03-2.79.32-.23.74-.26,1.17-.14,0,0,0,0,0,0-.43-.12-.85-.09-1.17.14Z"
                fill="#d6d6d6"
                strokeWidth="0"
              />
              <path
                d="m49.16,36.06c-.71.5-.7,1.75.03,2.79.73,1.04,1.9,1.47,2.62.97.2-.14.34-.34.43-.57t0,0c-.09.23-.23.44-.42.57-.71.5-1.88.07-2.61-.97-.73-1.04-.74-2.28-.02-2.78.32-.23.75-.26,1.18-.13,0,0,0,0,0,0-.43-.12-.85-.09-1.17.14Z"
                fill="#d7d7d7"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.07c-.72.5-.7,1.75.02,2.78.73,1.04,1.9,1.47,2.61.97.2-.14.34-.34.42-.57h0c-.09.23-.22.43-.43.57-.71.5-1.88.07-2.61-.97-.73-1.04-.74-2.28-.02-2.78.33-.23.76-.26,1.19-.12,0,0,0,0-.01,0-.43-.13-.85-.1-1.18.13Z"
                fill="#d8d8d8"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.07c-.72.5-.7,1.75.02,2.78.73,1.04,1.9,1.47,2.61.97.2-.14.34-.34.43-.58,0,0,0,0,0,0-.08.24-.23.44-.43.58-.71.5-1.88.07-2.6-.97-.73-1.03-.74-2.28-.03-2.78.33-.23.76-.26,1.2-.12,0,0,0,0,0,0-.43-.13-.86-.11-1.19.12Z"
                fill="#d9d9d9"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.07c-.71.5-.7,1.75.03,2.78.73,1.04,1.9,1.47,2.6.97.2-.14.34-.34.43-.58,0,0,0,0,0,0-.08.24-.23.44-.43.59-.71.5-1.88.07-2.6-.96-.73-1.03-.74-2.28-.03-2.78.33-.24.77-.26,1.21-.12,0,0,0,0-.01,0-.43-.14-.87-.11-1.2.12Z"
                fill="#dadada"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.07c-.71.5-.7,1.74.03,2.78.72,1.03,1.89,1.46,2.6.96.2-.14.34-.35.43-.59,0,0,0,0,0,0-.08.24-.23.45-.43.59-.71.5-1.87.07-2.6-.96-.73-1.03-.74-2.27-.03-2.77.33-.24.77-.26,1.21-.12h0c-.44-.15-.87-.12-1.21.12Z"
                fill="#dbdbdb"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.07c-.71.5-.7,1.74.03,2.77.73,1.03,1.89,1.46,2.6.96.2-.14.35-.35.43-.59,0,0,0,0,0,0-.08.24-.23.45-.43.59-.71.5-1.87.07-2.6-.96-.72-1.03-.73-2.27-.03-2.77.33-.24.78-.26,1.22-.12,0,0,0,0,0,0-.45-.14-.88-.12-1.21.12Z"
                fill="#dcdcdc"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.08c-.71.5-.7,1.74.03,2.77.73,1.03,1.89,1.46,2.6.96.21-.14.35-.35.43-.59h0c-.08.24-.23.45-.43.59-.71.5-1.87.07-2.59-.96-.72-1.03-.73-2.27-.03-2.77.34-.24.78-.26,1.23-.11,0,0,0,0,0,0-.45-.15-.89-.12-1.22.12Z"
                fill="#ddd"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.08c-.71.5-.7,1.74.03,2.77.72,1.03,1.89,1.46,2.59.96.21-.14.35-.35.43-.59t0,0c-.08.24-.23.45-.43.6-.71.5-1.87.07-2.59-.96-.72-1.03-.73-2.26-.03-2.76.34-.24.79-.26,1.24-.11,0,0,0,0,0,0-.45-.15-.89-.13-1.23.11Z"
                fill="#dedede"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.08c-.71.5-.7,1.73.03,2.76.72,1.03,1.88,1.46,2.59.96.21-.15.35-.35.43-.6h0c-.08.24-.23.45-.43.6-.71.5-1.87.07-2.59-.96-.72-1.02-.73-2.26-.03-2.76.34-.24.79-.26,1.25-.11,0,0,0,0,0,0-.45-.15-.9-.13-1.24.11Z"
                fill="#dfdfdf"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.08c-.71.5-.69,1.74.03,2.76.72,1.03,1.88,1.46,2.59.96.21-.15.35-.36.43-.6,0,0,0,0,0,0-.08.24-.22.46-.43.6-.71.49-1.87.07-2.58-.96-.72-1.03-.74-2.26-.03-2.76.34-.24.79-.26,1.25-.1,0,0,0,0,0,0-.45-.15-.9-.13-1.25.11Z"
                fill="#e0e0e0"
                strokeWidth="0"
              />
              <path
                d="m49.17,36.08c-.71.5-.69,1.73.03,2.76.72,1.03,1.88,1.45,2.58.96.21-.15.35-.36.43-.6,0,0,0,0,0,0-.08.25-.23.46-.44.61-.71.5-1.86.07-2.58-.96s-.73-2.26-.03-2.75c.34-.24.8-.26,1.26-.1h0c-.46-.16-.91-.14-1.25.1Z"
                fill="#e1e1e1"
                strokeWidth="0"
              />
              <path
                d="m49.18,36.09c-.71.5-.69,1.73.03,2.75s1.88,1.45,2.58.96c.21-.15.35-.36.44-.61,0,0,0,0,0,0-.08.25-.23.46-.43.61-.71.5-1.86.07-2.58-.96-.72-1.02-.73-2.25-.03-2.75.35-.24.81-.26,1.26-.1,0,0,0,0,0,0-.46-.16-.91-.14-1.26.1Z"
                fill="#e2e2e2"
                strokeWidth="0"
              />
              <path
                d="m49.18,36.09c-.71.5-.69,1.73.03,2.75.72,1.03,1.87,1.45,2.58.96.21-.15.35-.36.43-.61,0,0,0,0,0,0-.08.25-.23.47-.44.61-.7.49-1.86.07-2.58-.96-.72-1.02-.73-2.25-.03-2.74.35-.24.81-.26,1.27-.1h0c-.46-.17-.92-.15-1.26.09Z"
                fill="#e3e3e3"
                strokeWidth="0"
              />
              <path
                d="m49.18,36.09c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.58.96.21-.15.36-.36.44-.61,0,0,0,0,0,0-.08.25-.23.47-.44.62-.7.5-1.86.07-2.57-.95-.72-1.02-.73-2.25-.03-2.74.35-.25.81-.27,1.27-.09h0c-.46-.17-.92-.15-1.27.09Z"
                fill="#e4e4e4"
                strokeWidth="0"
              />
              <path
                d="m49.18,36.09c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.14.35-.36.44-.62h0c-.08.25-.23.47-.44.62-.7.49-1.85.07-2.57-.95-.72-1.02-.73-2.24-.03-2.74.35-.25.82-.26,1.28-.09h0c-.47-.18-.93-.16-1.28.09Z"
                fill="#e6e6e6"
                strokeWidth="0"
              />
              <path
                d="m49.18,36.1c-.7.49-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.15.36-.36.44-.62,0,0,0,0,0,0-.08.26-.22.48-.44.62-.7.49-1.85.07-2.57-.95-.72-1.02-.73-2.24-.03-2.74.35-.25.82-.26,1.29-.08,0,0,0,0,0,0-.46-.17-.93-.16-1.28.09Z"
                fill="#e7e7e7"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.1c-.71.5-.69,1.72.03,2.74.72,1.02,1.87,1.45,2.57.95.21-.15.36-.37.44-.62h0c-.08.26-.23.47-.44.62-.7.49-1.85.07-2.56-.95-.72-1.02-.73-2.24-.03-2.73.35-.25.83-.27,1.29-.09,0,0,0,0,0,0-.47-.18-.94-.16-1.29.08Z"
                fill="#e8e8e8"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.72,1.02,1.87,1.45,2.56.95.21-.15.36-.37.44-.62,0,0,0,0,0,0-.08.26-.23.48-.44.63-.7.49-1.85.07-2.56-.95-.71-1.02-.73-2.24-.03-2.73.36-.25.83-.26,1.3-.08,0,0,0,0-.01,0-.47-.18-.94-.17-1.29.09Z"
                fill="#e9e9e9"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.71,1.02,1.86,1.44,2.56.95.21-.15.36-.37.44-.63t0,0c-.08.26-.23.48-.44.63-.7.49-1.85.07-2.56-.95-.71-1.02-.73-2.24-.03-2.73.36-.25.84-.26,1.31-.07,0,0,0,0-.01,0-.47-.19-.95-.18-1.3.08Z"
                fill="#eaeaea"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.1c-.7.49-.69,1.71.03,2.73.71,1.01,1.86,1.44,2.56.95.22-.15.36-.37.44-.63,0,0,0,0,0,0-.08.26-.23.48-.44.63-.7.49-1.84.07-2.56-.94-.71-1.02-.73-2.24-.03-2.73.36-.25.84-.26,1.32-.07,0,0,0,0,0,0-.48-.19-.96-.18-1.31.07Z"
                fill="#ebebeb"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.11c-.7.49-.69,1.71.03,2.73.72,1.01,1.86,1.44,2.56.94.22-.15.36-.37.44-.63,0,0,0,0,0,0-.08.27-.23.49-.44.64-.7.49-1.84.06-2.55-.95-.71-1.01-.73-2.23-.03-2.72.36-.25.85-.26,1.33-.06,0,0,0,0,0,0-.48-.19-.96-.18-1.32.07Z"
                fill="#ececec"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.11c-.7.49-.69,1.71.03,2.72.71,1.01,1.86,1.44,2.55.95.22-.15.36-.38.44-.64,0,0,0,0,0,0-.08.27-.23.49-.45.64-.69.49-1.84.07-2.55-.94-.71-1.01-.72-2.23-.03-2.72.37-.26.85-.26,1.34-.06,0,0,0,0,0,0-.49-.2-.97-.19-1.33.06Z"
                fill="#ededed"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.11c-.7.49-.69,1.71.03,2.72.71,1.01,1.86,1.43,2.55.94.22-.15.37-.37.45-.64h0c-.08.26-.23.48-.45.64-.7.49-1.84.07-2.55-.94-.71-1.01-.72-2.23-.03-2.71.37-.26.86-.26,1.34-.06,0,0,0,0,0,0-.49-.2-.97-.2-1.34.06Z"
                fill="#eee"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.11c-.7.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.55.94.22-.15.37-.37.45-.64,0,0,0,0,0,0-.08.27-.23.5-.45.65-.69.49-1.84.07-2.55-.94-.71-1.01-.72-2.22-.03-2.71.37-.26.87-.26,1.36-.06h-.01c-.49-.21-.98-.21-1.34.05Z"
                fill="#efefef"
                strokeWidth="0"
              />
              <path
                d="m49.19,36.11c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.55.94.22-.15.37-.38.45-.65,0,0,0,0,0,0-.08.27-.23.5-.45.66-.69.49-1.83.06-2.54-.95-.71-1.01-.72-2.22-.03-2.71.37-.26.87-.26,1.36-.05,0,0,0,0,0,0-.49-.21-.99-.2-1.36.06Z"
                fill="#f0f0f0"
                strokeWidth="0"
              />
              <path
                d="m49.2,36.11c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.54.95.22-.16.37-.38.45-.66,0,0,0,0,0,0-.08.28-.23.51-.45.66-.69.49-1.83.06-2.54-.95-.71-1-.72-2.22-.03-2.71.37-.26.87-.26,1.37-.05h0c-.49-.21-.99-.22-1.36.04Z"
                fill="#f1f1f1"
                strokeWidth="0"
              />
              <path
                d="m49.2,36.12c-.69.49-.68,1.7.03,2.71.71,1.01,1.85,1.43,2.54.95.22-.16.37-.38.45-.66,0,0,0,0,0,0-.08.28-.22.51-.45.66-.69.48-1.83.06-2.54-.94-.71-1-.72-2.21-.02-2.7.37-.26.88-.26,1.37-.04,0,0,0,0,0,0-.49-.21-.99-.21-1.37.05Z"
                fill="#f2f2f2"
                strokeWidth="0"
              />
              <path
                d="m49.2,36.12c-.69.49-.68,1.7.02,2.7.71,1.01,1.84,1.43,2.54.94.22-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.22.51-.45.67-.69.49-1.83.06-2.53-.94-.71-1-.72-2.21-.03-2.7.38-.26.88-.26,1.38-.04,0,0,0,0,0,0-.5-.21-1-.22-1.37.04Z"
                fill="#f3f3f3"
                strokeWidth="0"
              />
              <path
                d="m49.2,36.12c-.69.49-.68,1.7.03,2.7.71,1,1.84,1.43,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.23.52-.45.67-.69.49-1.82.06-2.53-.94-.7-1-.72-2.21-.02-2.7.38-.27.88-.26,1.38-.04,0,0,0,0,0,0-.5-.22-1-.22-1.38.04Z"
                fill="#f4f4f4"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.12c-.69.48-.68,1.7.02,2.7.71,1,1.84,1.42,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.07.28-.22.52-.45.67-.69.49-1.82.07-2.53-.94-.71-1-.72-2.21-.02-2.69.37-.27.89-.26,1.39-.03,0,0,0,0,0,0-.5-.22-1.01-.23-1.38.04Z"
                fill="#f5f5f5"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.13c-.69.49-.68,1.69.02,2.69.7,1,1.84,1.42,2.53.94.23-.16.37-.39.45-.67,0,0,0,0,0,0-.08.28-.22.52-.45.68-.69.49-1.82.07-2.52-.94-.7-1-.72-2.2-.03-2.69.38-.27.89-.26,1.4-.03,0,0,0,0,0,0-.5-.22-1.01-.23-1.39.03Z"
                fill="#f6f6f6"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.13c-.69.48-.68,1.69.03,2.69.71,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.68,0,0,0,0,0-.01-.08.29-.23.53-.45.69-.69.48-1.82.07-2.52-.94-.71-1-.72-2.2-.03-2.69.38-.27.9-.26,1.4-.03h0c-.5-.23-1.02-.24-1.4.03Z"
                fill="#f7f7f7"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.13c-.69.48-.68,1.69.03,2.69.7,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.69,0,0,0,0,0,0-.07.29-.22.53-.45.69-.69.48-1.81.07-2.52-.94-.7-1-.71-2.2-.02-2.68.38-.27.9-.26,1.41-.03,0,0,0,0,0,0-.5-.23-1.02-.24-1.4.03Z"
                fill="#f8f8f8"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.13c-.69.48-.68,1.69.02,2.68.7,1,1.83,1.42,2.52.94.23-.16.38-.4.45-.69h0c-.07.29-.23.53-.45.69-.69.48-1.81.07-2.52-.93-.7-1-.71-2.2-.03-2.68.39-.27.91-.26,1.41-.02,0,0,0,0,0,0-.51-.23-1.03-.25-1.41.03Z"
                fill="#f9f9f9"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.14c-.69.48-.68,1.68.03,2.68.7,1,1.83,1.42,2.52.93.23-.16.38-.4.45-.7h0c-.07.29-.22.53-.46.69-.69.48-1.81.06-2.51-.93-.7-1-.71-2.2-.03-2.68.39-.27.91-.26,1.42-.02h0c-.5-.24-1.03-.26-1.41.02Z"
                fill="#fafafa"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.14c-.69.48-.67,1.68.03,2.68.7,1,1.83,1.41,2.51.93.23-.16.38-.41.46-.7,0,0,0,0,0,0-.07.29-.22.54-.45.7-.68.48-1.81.06-2.51-.93-.7-1-.71-2.19-.03-2.68.39-.27.92-.26,1.42-.01,0,0,0,0,0,0-.51-.24-1.03-.25-1.42.02Z"
                fill="#fbfbfb"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.14c-.68.48-.67,1.68.03,2.68.7.99,1.83,1.41,2.51.93.23-.17.38-.41.45-.7t0,0c-.07.29-.22.54-.45.71-.69.48-1.81.06-2.51-.93-.7-1-.71-2.19-.03-2.68.39-.27.92-.26,1.44,0,0,0-.01,0-.02,0-.51-.24-1.04-.26-1.42.01Z"
                fill="#fcfcfc"
                strokeWidth="0"
              />
              <path
                d="m49.21,36.14c-.68.48-.67,1.68.03,2.68.7.99,1.82,1.41,2.51.93.23-.16.38-.42.45-.71,0,0,0,0,0,0-.08.29-.22.54-.46.71-.68.48-1.81.06-2.5-.93-.7-.99-.71-2.19-.03-2.67.4-.27.93-.26,1.45,0,0,0,0,0,0,0-.52-.25-1.04-.27-1.44,0Z"
                fill="#fdfdfd"
                strokeWidth="0"
              />
              <path
                d="m49.22,36.14c-.68.48-.67,1.68.03,2.67.7.99,1.82,1.41,2.5.93.24-.16.38-.42.46-.71,0,0,0,0,0,0-.07.3-.22.55-.46.71-.68.48-1.8.06-2.5-.93-.7-.99-.71-2.19-.02-2.67.39-.28.93-.25,1.45,0,0,0,0,0,0,0-.52-.25-1.05-.27-1.45,0Z"
                fill="#fefefe"
                strokeWidth="0"
              />
              <path
                d="m49.22,36.14c-.68.48-.67,1.68.02,2.67.7.99,1.82,1.41,2.5.93.24-.16.39-.42.46-.71-.24-1.65-1.04-2.5-1.53-2.88-.52-.26-1.06-.28-1.45,0Zm2.51,3.2c-.5.43-1.43.11-2.09-.71-.66-.83-.79-1.85-.3-2.28.5-.43,1.43-.12,2.09.71.66.83.79,1.85.3,2.28Z"
                fill="#e2a228"
                strokeWidth="0"
              />
              <path
                d="m49.34,36.35c-.49.43-.36,1.45.3,2.28.66.83,1.59,1.14,2.09.71.5-.43.36-1.46-.3-2.28-.66-.83-1.59-1.14-2.09-.71Zm1.25,1.94c-.08-.1-.06-.26.05-.35.11-.09.27-.08.36.02.09.1.06.25-.05.35-.11.09-.27.08-.36-.02Zm.65.07s-.09.02-.12-.01c-.03-.04-.03-.09,0-.12.03-.03.09-.02.12.02.03.04.03.09,0,.12Z"
                strokeWidth="0"
              />
              <path
                d="m51,37.96c-.08-.1-.24-.11-.36-.02-.11.09-.13.25-.05.35.08.1.25.11.36.02.11-.09.13-.25.05-.35Z"
                fill="#fff"
                strokeWidth="0"
              />
              <path
                d="m51.13,38.23s-.04.08,0,.12c.03.04.08.04.12.01.03-.03.04-.08,0-.12-.03-.04-.08-.04-.12-.02Z"
                fill="#fff"
                strokeWidth="0"
              />
              <line
                x1="50.27"
                y1="35.89"
                x2="50.27"
                y2="35.9"
                fill="none"
                stroke="#ec008c"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
              />
              <line
                x1="50.28"
                y1="35.9"
                x2="50.27"
                y2="35.9"
                fill="none"
                stroke="#ec008c"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
              />
              <line
                x1="50.26"
                y1="35.89"
                x2="50.27"
                y2="35.89"
                fill="none"
                stroke="#ec008c"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0"
              />
            </g>
            <path
              d="m52.58,40.85s-.14-.77-.19-1.6c0,0-.08-2.7-2.6-3.75,0,0-1.14-.65-1.62-1.15,0,0,.27.69,1.65,1.43,0,0,1.98.87,2.39,3.35.4,2.48,0,.06,0,.06,0,0,.27,1.42.38,1.66Z"
              strokeWidth="0"
            />
          </g>
          <path
            d="m49.19,35.8s2.53,1.73,2.78,4.27l.34-.39s.09-2.87-2.82-4.22l-.29.35Z"
            fill="url(#linear-gradient)"
            strokeWidth="0"
          />
          <image
            width="313"
            height="325"
            transform="translate(14.47 -.96) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAFECAYAAACtVhJjAAAACXBIWXMAAC4jAAAuIwF4pT92AAAElElEQVR4nO3dS24TQRAG4EpISAI3YsOlOEYuxYYz8UhsFjOFK00nKDPdRqDvk1q2kiyMZP1U9WsiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGCji7/9Afj33X/52P0effrw+XjuzwIRgo0dSqC1r8f6KuA4N8HGJmuotSPW1xpsh3wv4DgXwcarNaF2WUb9PmWoHcp74cZZXP3tD8A/K0PtTRk13DLUHtdxERGH+y8fDxHaU+ZSsfEqpVrLULtax3Wcwi1iqdIeyngs4xiqNya6/POfwG/acLtex01E3EXEuzLuIuI2It7GEoC/KrvnVlNhL8HGVu0c23Us4ZXhVgPubv15hlu2rMKNKcyxMUKG21WcwitXR3/E00qtyrYUhlKxsdWxMyKWQMuAu42lYnsfp5Y0KzctKdMINraoYVZXPmsFlnNv7bzbXSzBVhcbhBtDCTZeZV3JbEPtIZaWM8fD+vuce6vzbrVqq/NtMIxgY6tesH2PiG/r64/199ma3sQSalZJmU6w8WqlaqvBlqGWo4ZbXVi4iVPFdh2qNiYQbGzyQrh9LeP7+vMMt7olpLv946z/CP5bgo3NSrjlwkFtR2u45aJCDbdasWlHGUqwsUsn3HptaZ1vqycV2mCDIXyZ2K1pS3sLCW3VVsPtScUW2lEGEGwM0Qm3GnC5BSTvZsvbQPIAfXszCOwi2Bip3sHW29uWwZYtaXvdkXk2hhBsDFOuIXpu4+5jnObaXrrLDXYRbIzWO2pV72SrZ0ovm2GOjSEEGzP05ttquNWWtPfcBNhFsDFUaUfrfFut2nKurb0R5KLzHjZxHxsz1IPybTv6sP5NfdCLO9kYSrAxS1ux5cmEN/E09NpwE3LsJtiYqXcDSA22OueWARch3NhJsDFLDanaiubxqmP8vnlXoDGExQOGe2YBoT1qlWdIa9Vmvo0hVGzM1Lv9I2L5DzVb0bpxV9XGEIKNWepetqzY8slVNdjaLSCeEs9ugo3Z6gJCBlu+5tybVpShBBsz1VY0yvvcgJuBpw1lKDu8mWa9paPe3FHPhLat6iEiDtpQRlCxMVu98SODrAZb+8Bl2E3FxlRr1fbcOdAnJw5Ua4wi2JiuXBzZ+75ZCWU4wcbZ9G7GFWgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwH/kJK5N57pSQgX8AAAAASUVORK5CYII="
          />
          <g opacity=".5">
            <image
              width="313"
              height="325"
              transform="translate(14.37 -1.21) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAToAAAFDCAYAAACqb8JVAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEQElEQVR4nO3dzYtcRRTG4d/NhxrBr4VKokgU0ZUbQRD8/9eioKibiESMiWBI4iSZOFMu6o6O4LK7r0yeBy69mFnUonk5dU7V7QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADg/2jZegFcPGOMs+/VUo2qZVnGdivieSfo2Kk15K5WL1aXq9PqafVsWZbTLdfG8+vK1gvgwrlSvVrdqN5ohtyd6rcxxuPqVHXHoQk6dmat5i5Xr1UfVR83K7ofqu+agfdojKG646AEHTuzLMsYY5xUj6uH1Un1ZnWtGX63qh+re2OMx8uynGy1Vp4venTs1BjjUvVS9VZ1s3q/+qB6vXpQfV19Vd2uhB0HoaJjp5ZlOR1jPKl+aVZ195oV3mfVh83+3dX132+PMY5sY9k3QcfOrWF3XN2vjptb2MvNSeyN6vPqz/VvP48xjg0o2CdBx16swXUyxjhqblOX6lL1RfVu9Wmz2ntQ/d4MQ9gLQcdeLctysh4rud38vr3S7Ne915zK/lo9sYVlny5tvQAuvnXgcNTs231f/dQcWHyyPm9WV8/dqICdEnQcymlzOHGr+rJ5pu56M+jeaQafoGMvBB0HsfbsnlV3q2+qb5vDiLebFZ2gY28EHQez9uCeNMPudvWo2bO73jxQbPvKXgg6Du20ea7uXvVbs5K72azsXthuWVxkgo5DG82L/neb18EeN6ewZweJVXTsnKDjoM716h70z62JF6qX109Bx84JOrYwmoOIo/XzWnMg8Wr6dOyBoGML56u6+82gu9l8EYA+HTsn6NjKcf/u073WnMDq07Fzgo6D+48+3VHzu3g5IcceuOvKVs7C7sn6nDTfaOItJuycoGNL5yu7R+vns4QdOybo2Npx8w0md5o9u+Ntl8NFpEfHls4quofNsHvQ/FlEFR07JejY2lnYPc22lT0RdGxJyHEQgo6tnB9E/L1tTdixB4YRbOns0PAf62MQwV44nMlm1jutV5oHhU+qPw0igAvJJX4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4vL8A32rmHK+kYSAAAAAASUVORK5CYII="
            />
          </g>
        </g>
        <g>
          <image
            width="331"
            height="322"
            transform="translate(55.55 3.34) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUkAAAFCCAYAAAB8TS9rAAAACXBIWXMAAC4jAAAuIwF4pT92AAAE8ElEQVR4nO3dbU/bVhjH4T8h5SkMVrZ9/8+3lrEC5bnAXtw+sonaSSUOMdV1SVZaEqS8iH66j49jEgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMaxtek3AK+0/Nl93si74Jcnkrw3W985nlKRbAeMZnvTbwB+QoviLMmH7tjufiaQrMV8028AfsJWKoofkux2j89J7rrHp+51YsloRJL3YpY+kAfdsZPksXv+W/fvx+/+NrySSDJ1bYm9nYriQZLfkhymPr93Se6T3MY5dtZAJJmyYSB3kyySHCU5TsWymUcgWRORZKpaIOfpA3mc5GMqlG2KTF7ubsOoRJIpGgZyL7W0/j3JSSqUO6lzkA+pZfZd93+RZHQiydS0S3y2k+ynzj9+TPJHKpS7qSDeJLnsjtv0kRRKRiWSTEk7/9gmyKPU9PhnKpQtkNdJviT5NxXJu9SutkAyOpFkCpZ3sPfTB/KvVCD3Usvr61Qcz5JcxBTJmokkmzT8Bs3yBs1J+iX2fiqQV0n+SXKa5DwVzIf0GzcwOpFkE4ZxbBeID88/nnSPh+k3aS6TfO6OLxFI3ohI8la2Bo/DOO6mrnk8yssNmv3u9bepqfE0yafUUvsqdQG5QLJ2LsBl3dpnbJZ+Wd2W1vupabFd/9iugWzT40Vqed2O8wgkb8wkyToMp8a2IdMmx71UHBep5fVxanI87n4+T0XwPMnf6afHdqmPJTZvyiTJmJbv8ziMY1tWH6bieDQ4FulvVnGTiuKnVCTPknxNhdMuNm9OJBnDMIztfOM8Fb52Sc8i/dL6KBXKg1Q8Z+mnx7Z7fZraoGnLa9dBshEiyaqGU+M8/c1w97qjTY9tgjxMBbPF8Sk1PbbNmc/pl9c3sbxmw0SSVQwnx51U+FoY29EmyEVqotztXv+UOsd4lf7bM2d5uTljec3GiSSvNbwJxfKSetEdLZQtjrP0dxK/Su1en3fHZfeztjljec0k2N1mFT+6Ge5hKox73XNJTYb3qSX0RSqKF6lNmev0N89tcRRIJkEkWcXwK4XDY9Y9/5D+nOJ9KoZf00+NLY7tTy8498jkiCSraH986zEVuru8PN/4nIrkfffcdWqSvEl/zlEcmTSRZBXPqci1O4S3+zy2P6fwlD6Sw8dv3XPiyOTZuGEVw93tdglQ+/ph0ke0RXE4NYoj74JIsqrlb9m0I+ljOJwYxZF3RSQZy/99loQRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODH/gOZ4ejU/spJdQAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="322"
            height="318"
            transform="translate(54.16 3) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUIAAAE8CAYAAAC1hbgtAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEfElEQVR4nO3dy24UVxSG0d/3trEBgwFFef83SyRIOybx/RLjDPY5qooHYUC1qxOtJR31hR70AH3a1aeqnAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC9tY+4vAN/x/P/o0yzfgv+17bm/ADyzMXrcGL1+yhBBMWRSJkLWwTh+m6PHrbaS5DHJX+3xW8SQCZkImVMP4GaG8G2P1m577ynJXZKb9jieDuGHCSFz6Ye9ferbbWuRZG/0uJXkPslFahLsUyFMRgiZw/MA7iU5aOtVW4skO6n4XaQmQT/lsBJCyEsaT4E7GQL4KslRksO29lOBTJLrJJepKbD/PgiTEkJeyngDZDcVu8MkrzNEcD81CW63z98luU2F8DrJQ2yUsAJCyEvoU+B2hinwKMmbtg7a+5up0N2koneV5GtbV6nfCoWQyQkhq/T8UHiRYQocR3A7ddh7k5oAr9vzflh80d5/jAiyAkLIqowj2KfAHsC37fl+agq8TwXvz1T0rlLhu2vrPs4fZIWEkFXoEeznAh6mAvguyXGGCG5k+A3w9yRnGaa/h9SpMt8yBFAEWQkhZGrjCO6lInic5H1bb1IRTOrw9yIVwdPURNh/H+wBTASQFRNCpjSO4CK1IXKc5EOSk9QhcY/gdZLzVABPk/wRO8PMRAiZ0jiCr1MT4IckH1MRPGifu0pNf8uIIGtACJlK3xhZpA5/T5J8SkXwXYYIXqbC91sqhF8jgsxMCJlCj2DfGDlJ8lNb71NXjjxliOCXts7i/EDWgBAyhR7C/dRvgp+S/NweD9u/n6emv89tiSBrY3PuL8B/Xt8g2Ukd/r5NHQ5/zD+nwfPUFPg5tUt8mTpHUASZnRAyhX4N8fjKkaP2OqnoLVMhPG2vTYKsDYfGTKmf9PyY2vzol8otU5sjfRLsV4qIIGth6/sfgX81vsv0Toa7Sj+mTpZeJvklya+pEN6krhgRQdaGiZAf1afAh9S096U9X6aCeJvaJDlLTYgiyNpxx1+m0O812C+r209Nh5upKN5muH7YITFrRwiZyvhuM/2PMW2kNkT6nWNsjrCWhJCpjf8WcefOMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwMjfIzDI4zgmeKYAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="311"
            height="313"
            transform="translate(34.79 7.86) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAAE4CAYAAAA6gWTaAAAACXBIWXMAAC4jAAAuIwF4pT92AAADFklEQVR4nO3bS08TYQBA0VtaUVDEuPH//zAXRjea+ExEImBdfNMUXJoZGvGcpJk+ZjGL5vZ7TAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPgrq0NfAA/Gqjqajts/HnBv1oe+AB6Eo+pRdVI9qTbtfzBFjXslaszhqBG08+r59Hzd3bCJG/dC1JjDujquzhpRO60etx+x/UrUuCeixlxWjYg9qZ52N2zb6qYRN1iUqDGX3RRz1Zh+njXCdtyYntYI281Bro7/hqgxl91obNsI2XkjbCfT6/Wtc3bnwexEjTntQrVpBO28MRW9Hbab6iphYyGixtx2oXrUCNuL6lljre14+vyy+pmpKAsQNZaw2xA4rV5VL9uvr9WI2kVjxGbzgFltDn0BPDjb6rr6MT3WjWnophG2VSNoX6ajaSizEjWWsG2Mwi6n42nj/rVnjZ3QL9WbzBRYgKixlOvqW/V5en3WWGf73tg4uP1XKpiNqLGE3a0bF9XXxojtRyNw76uP03vW05idqLGUX40dzo/V6+pD9a562z5sV1lPY2aixpIuGyG7aayffWo/cnNLB4uwpsGSjho/nMeN79rPxlqbP7izGFFjaX9+x8QMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPj3/QYOkFviC+f03QAAAABJRU5ErkJggg=="
          />
        </g>
        <g clipPath="url(#clippath)">
          <image
            width="644"
            height="576"
            transform="translate(14.73 -27.3) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <path
            d="m45.35,31.92s0-1.64-.42-1.81c0,0-.53-.25-.51.52,0,0,.21.39.43.61.23.22.5.68.5.68Z"
            fill="url(#linear-gradient-2)"
            strokeWidth="0"
          />
          <path
            d="m45.35,31.92s0-1.64-.42-1.81c0,0-.53-.25-.51.52,0,0,.21.39.43.61.23.22.5.68.5.68Z"
            fill="url(#linear-gradient-3)"
            strokeWidth="0"
          />
          <image
            width="304"
            height="307"
            transform="translate(8.52 -6.22) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS0AAAExCAYAAAAp9/QOAAAACXBIWXMAAC4jAAAuIwF4pT92AAAC3ElEQVR4nO3cS27bMBQF0Cs56S/phjrJprqMbqqTbqmJ608HpGBaRQaRCKgxzgGIAIoGHBA3N0+WEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA+I8MW2+A2/Dj19PVWfr+7ed5q71w24QWqzRhNT9L50R40Z/QYrEaWNMac32eTinBdUqEF/3cbb0B3qcmsMaUc7Sra0gJqmOSQ739tMUeuU3j1hvg3WoD60OSL0m+1vWY5HO9vksyzmdesJSmxZs1ATSF1sckDylBdZfkT5Lf9Z5TXUPqnAvW0LRYa962HlPa1kOST/V3Y/LvE0ZYQtNirak9teG1S5ln3ecy59K06ELT4s2aJ4HT08FDyr+Eh1yG7sNsQReaFku1gbVP8pwyx5qa1bHeo13RlabFIrVtvRZcLynNS3DRnabFGlNoHVNC6yXlD+E00xJcdCe0WOucywdJn+u1MSXM2tCCLgxIWaV+jKF9cnif69Dapw7ovcpDD5oWPUxta19/Ds01TYuuNC1Wm72H2J6paeZ11rLoRWjRxStfUePraehOaNFV+6qOsAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJb7C9pQdG0j1yLRAAAAAElFTkSuQmCC"
          />
        </g>
        <g opacity=".6">
          <image
            width="318"
            height="312"
            transform="translate(18.12 -4.9) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT4AAAE3CAYAAAAzNy34AAAACXBIWXMAAC4jAAAuIwF4pT92AAADt0lEQVR4nO3cS4tcVRSG4fck0UYlGagxqEFEBxloFAcOxP8/FhQnXiCQhGjEe6dDbr0d7FPaqJlVVzXJ80BxqMtgD4qPtWqtUwUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7Nyy7wPwbBljbL5TT/tujaplWcZuTgT/JfjYmjX0XqheXK//DsFRPa4erNdjAcg+XNj3AXimXKguVm9Ul9bn59brwfqZP6u71S/VvTHGowQgOyb42Iq12jtfvVK92Qy/g2bld2l9/lL1e3Vjfdyqfq4OxxiPlmU53vnBeS5pddmaMcbJkLvUDL2D6kr1/no9aLa8v1bfV981Q/BudT/VHzsg+Niap/zGtwnDK9Xr1VvVtert6lF1s/qi+qq6Ux1Wqj9OleBjq/5nqrsJv4Nmq3u5+rD6pHpnfe1O9WX1dfVts/19qPLjtPiNj606EVZ/h9YY47h6WN1rVnT3mq3tterj6mr1WjMUa059f6ue7ObUPG8EH6duDcNRHY8xjqrb1R/N8DusPq/eqz6ofmpWfA/GGEdaXk6D4GOnlmU5HmM8bA43Nvt8m2C8Wl1f3zuqbo8xtLxsneBj59Yge7JWfzfXl0f1WbPdvV790Fx90fKydYKPvVmW5ckY437/hF/Vp9Wr1bvNPb/DMYYVF7ZK8LFXJ8LvVnMB+uXqo2bbe7n6sTkYga0RfOzdGn5HzbWWb5oT3nPNNZjzzZUYFR9bI/g4K46bE94bzZ2/i80hx2b4AVsj+DgTlmUZ6x8W3G22tpv7eh/s9WA8k9y5wZkyxjjXbG/PN6e5jw02gOfCiVvfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzpy/AGCruusoklVVAAAAAElFTkSuQmCC"
          />
        </g>
        <image
          width="330"
          height="354"
          transform="translate(7.33 -6.74) scale(.24)"
          href="data:image/png;base64,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"
        />
        <path
          d="m50.36,42.2c-2.72-1.44-3.74-3.82-3.74-3.82-.39-1.25-1.54-4.09-2.74-6.12-.76-1.28-.63-2.37-.49-2.99,0,0-.56,1.27.25,2.78,0,0,1.39,2.64,1.65,3.36,0,0,.83,1.9,1.13,2.86,0,0,.89,2.53,3.93,3.93Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <g opacity=".9">
          <image
            width="330"
            height="354"
            transform="translate(7.19 -6.25) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <image
            width="339"
            height="334"
            transform="translate(41.67 31.1) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVEAAAFNCAYAAAC5YlyiAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFcUlEQVR4nO3dW08bVxiG0ddAoGnT9ChVVf//3+p1miZVmxMxGNOLPZ9m4zhpBdsBTdaSRjYxJL5Aj/ZpnAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABIspouWJSj+34DfBEElMU6vu83wOKtIqIs2Ml9vwEWbZU226mAXt/je4GDMJ3nUCqgdcEi+eXmUCqix7k5lTcaZVFElEPoA9qPRAWUxRFRDqECWpdNJRZLRBmtRqEn07WKESgLJqKMtEobeZ4keZR5FHrdXbAojjgx2lFaQGsUuo2AsmBGooxUa6GPcnMkak2UxRJRRqm10N2AJkaiLJiIMsoqbQp/luQ08y3FV2lTelgka6KMUjvyp2kj0STZxKYSCyeijFC78meZR6LbOGTPF0BEGaHWQr9Ki+ijtIjWHUs2llgsEWWEWg+tiB6nrYXWMSdYLBFlhP4updpU2mQeicJiiSh3VSPNimh/vKlGokajLJaIMkof0YrnSeaRqHvoWSQRZYR+Kn+aOaJ13MmUnsUSUe6q31TqN5aOpq8fp8V0k7bZBIsiotxVf6dSXXX//DbJD0neJrnI/GEkh34/+7524J+DEFHu6jpthHmVm/fOX6cF7DItouvpz+ouptHqE/QrmvVYt59upsstqAwlotxVRXSTeR30dHqt1kYrXi+TnGcO2W1iuu9nak22Dvqvdl67SvJmerTBxVAiyig1rT9Ni1kybyzV9P6bzDHrQ7YbtU99vfu8jlCdJXky/ZtHmeO+TvIqybs4asUBiCij1FT+LG1DKWkhq6g+TvJjWtT6iF7vPN/3Z//1vA94nVG9Sgvny7T12Mt8njVZvjAiykirzCHt/1uQbVpYn07P+0+73xfGj12f+p56rf/7N2kj3zdpIRVQhhNRRtimRepd5ts96+PwdmO3L6C3ubaZ12Lr8XJ6D+vp+idtKv8+Hy4hwBAiyl3V2uOrJH+kHWn6NsnXmXfGbxPP7Z7nFcsK5zptlLlOi/jbtHC+TQvq++n5oU4EgIgyxFVarJ6lTdl/TvJdPpzWfyqWu9HsY1mjzvdJXk+PF2kB/StzNNdpI9GLnZ8TUA5GRBmh1h9fJ3me5M+0EWkdvu8/nLm/6nxpHcTv1zLP00a355lHoK+TvMi8xrnOfAa1j2Z/FlRAOSgRZZRtWsxeJPk97XdrneSntJ35OnbUX5u0kePf02ONGi/TAvo8LZyXuTl9rzXOPpq7O/zwWTg3x0h12P5pkl+S/Jrkt7Sp/Uk+3GG/SFvDfDY9Xmaezp9nnrpf5eY0XzR5MESU0foPJHmS5Pu0kehx9z39dP48LaA1bU/32m4wE9HkgRFRDuUo81Gn4498Tx/LfRtAgsmDJ6Ic2v/5HRNLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODB+ReQhFbwIFcW/AAAAABJRU5ErkJggg=="
          />
        </g>
        <image
          width="334"
          height="359"
          transform="translate(16.31 -1.13) scale(.24)"
          href="data:image/png;base64,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"
        />
        <path
          d="m56.7,33.56s1.83-.48,1.04.79c0,0-.65-.23-1.04-.79Z"
          fill="url(#Fade_to_Black)"
          opacity=".5"
          strokeWidth="0"
        />
        <g clipPath="url(#clippath-1)">
          <image
            width="335"
            height="356"
            transform="translate(20.56 -2.57) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <path
          d="m59.29,35.54s.54-.6.15-1.21c0,0-.5-.68-1.67-.04,0,0,.56.79,1.52,1.25Z"
          fill="url(#Fade_to_Black-2)"
          strokeWidth="0"
        />
        <path
          d="m59.32,35.46s1.02-.63,1.41-.26c0,0,.07.69-.51.98,0,0-.61-.1-.91-.72Z"
          fill="url(#Fade_to_Black-3)"
          strokeWidth="0"
        />
        <path
          d="m60.28,36.16s.61,1.03,1.3,1.48c0,0,.94-.6.78-1.5,0,0-.31-.52-2.08.03Z"
          fill="url(#Fade_to_Black-4)"
          strokeWidth="0"
        />
        <path
          d="m61.61,37.62s1.58-.93,2.47-.23c0,0-.11,1.29-1.53,1.68,0,0-.76-.82-.94-1.45Z"
          fill="url(#Fade_to_Black-5)"
          strokeWidth="0"
        />
        <path
          d="m62.64,39.06s-.29,1.05.44,1.77c0,0,1.5-.45,1.57-1.25,0,0-.39-.78-2-.52Z"
          fill="url(#Fade_to_Black-6)"
          strokeWidth="0"
        />
        <path
          d="m63.07,40.8s-.55,1.15.11,2.09c0,0,1.12-.01,1.67-.76,0,0-.05-.73-1.78-1.33Z"
          fill="url(#Fade_to_Black-7)"
          strokeWidth="0"
        />
        <path
          d="m63.16,42.87s-.51.58-.28,1.27c0,0,.49.25,1.3-.3,0,0,.2-.48-1.01-.96Z"
          fill="url(#Fade_to_Black-8)"
          strokeWidth="0"
        />
        <path
          d="m62.93,44.13s1.04.24,1.16.8c0,0,.07.52-.94.82,0,0-.64-.6-.22-1.62Z"
          fill="url(#Fade_to_Black-9)"
          strokeWidth="0"
        />
        <path
          d="m63.22,45.76s-.18.59.52.91c0,0,.32-.08.36-.47,0,0-.15-.37-.88-.44Z"
          fill="url(#Fade_to_Black-10)"
          strokeWidth="0"
        />
        <path
          d="m52.47,34.92s.61.64,1.17.65c0,0,.27-.51-.09-.62,0,0-.42-.23-1.09-.03Z"
          fill="url(#Fade_to_Black-11)"
          strokeWidth="0"
        />
        <path
          d="m54.95,36.43c-.99-.14-1.31-.87-1.31-.87,1.68-.17,1.66.16,1.66.16,0,0,.07.38-.36.71"
          fill="url(#Fade_to_Black-12)"
          strokeWidth="0"
        />
        <path
          d="m54.95,36.43s.53.96,1.19,1.19c0,0,.68-.52.31-.95,0,0-.43-.39-1.51-.24Z"
          fill="url(#Fade_to_Black-13)"
          strokeWidth="0"
        />
        <path
          d="m56.21,37.69s.26.91,1.16,1.51c0,0,1.06-.72.88-1.23,0,0-.44-.55-2.04-.28Z"
          fill="url(#Fade_to_Black-14)"
          strokeWidth="0"
        />
        <path
          d="m57.47,39.14s.16,1.21.78,1.86l.61.09s1.43-.59,1.33-1.47c0,0-.06-.67-2.72-.47Z"
          fill="url(#Fade_to_Black-15)"
          strokeWidth="0"
        />
        <path
          d="m58.25,41s-.22,1.04.24,1.73l.39.11s1.1-.36,1.25-.93c0,0-.2-.63-1.88-.91Z"
          fill="url(#Fade_to_Black-16)"
          strokeWidth="0"
        />
        <path
          d="m58.49,42.73s-.46,1.52.13,1.92c0,0,1.39-.12,1.69-.78,0,0-.04-.77-1.82-1.14Z"
          fill="url(#Fade_to_Black-17)"
          strokeWidth="0"
        />
        <path
          d="m58.63,44.65s-.69.45-.24,1.45c0,0,.96-.27,1.24-.7,0,0,.19-.4-.99-.76Z"
          fill="url(#Fade_to_Black-18)"
          strokeWidth="0"
        />
        <path
          d="m58.38,46.1s-.47.76.22,1.35c0,0,.4-.03.79-.55,0,0-.3-.54-1.02-.8Z"
          fill="url(#Fade_to_Black-19)"
          strokeWidth="0"
        />
        <path
          d="m58.47,47.52s-.09.75.39,1.35c0,0,.64-.65-.39-1.35Z"
          fill="url(#Fade_to_Black-20)"
          strokeWidth="0"
        />
        <g>
          <path
            d="m52.47,34.92s2.01-.53,1.14.68c0,0,.39-.92-1.14-.68Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m53.64,35.57s1.59-.4,1.77.08c0,0,.1.44-.47.79,0,0,.54-.63.23-.78-.31-.15-1.54-.09-1.54-.09Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m54.99,36.45s1.53-.25,1.65.3c0,0,.21.41-.5.88,0,0,.59-.58.22-.85,0,0-.31-.42-1.38-.33Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m56.21,37.69s1.66-.5,2.16.12c0,0,.39.55-1,1.39,0,0,.93-.78.81-1.16,0,0-.08-.49-1.97-.35Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m57.47,39.14s2.7-.5,3.01.42c0,0,.16.9-1.49,1.47,0,0,1.35-.75,1.2-1.41-.15-.66-2.72-.47-2.72-.47Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m58.25,41s2.25.06,2.01,1.04c0,0-.17.44-1.18.72,0,0,1.1-.51.95-.9-.15-.39-1.49-.8-1.78-.85Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m58.49,42.73s2.16.2,1.99,1.26c0,0-.09.67-1.85.66,0,0,1.5-.16,1.57-.8.08-.64-1.71-1.12-1.71-1.12Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m58.68,44.67s1.14.17,1.02.82c0,0-.3.52-1.29.58,0,0,1.13-.41,1.08-.79-.05-.39-.8-.61-.8-.61Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m58.38,46.1s1.22.4,1.08.85c0,0-.16.41-.86.5,0,0,.71-.29.61-.63-.1-.34-.83-.72-.83-.72Z"
            fill="#131c13"
            strokeWidth="0"
          />
          <path
            d="m58.47,47.52s1.29.73.39,1.35c0,0,.48-.65-.39-1.35Z"
            fill="#131c13"
            strokeWidth="0"
          />
        </g>
        <g>
          <image
            width="328"
            height="356"
            transform="translate(20.7 -2.41) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <use transform="translate(48.61 15.5) scale(.24)" href="#image-8" />
        </g>
        <g>
          <use transform="translate(48.98 23.23) scale(.24)" href="#image-5" />
        </g>
        <g>
          <use transform="translate(48.98 23.23) scale(.24)" href="#image-5" />
        </g>
        <g>
          <use transform="translate(82.55 -15.14) scale(.24)" href="#image-7" />
        </g>
        <g>
          <image
            width="311"
            height="348"
            transform="translate(21.59 13.01) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATgAAAFbCAYAAABBH5KeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFdUlEQVR4nO3dUW/iOBQG0Evb2f//c3cGGvaBXGEsB8rkmu7unCNZhIQiHqpP17FjRwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlDh89w/gj7D1f3Z+6a/gj/Px3T+A/7XDxnFP0DGFCo5ZDs3roTsXcQm1bBFCjgkEHLMcNlrKcFtCyDGJLioztIH21r2mDLeI25CDMgKOmTLk3uMScG/r+bZrmpbmGpQQcMzSVnDva8tzbfUW6/s8D2UEHNX67ul71yIuQfbZHC9xe49O0FFCwDHDKOA+4lrFZaCd49p1XYbfBDsIOCptVW8fEfEjrgMN7eDC0v2d6o0yAo5qGW59wGUFF3HpnmY3dTSFBEoIOKpsVW8/mvbWfHaJaxCO5sqp5NhNwFGprd6yW9oHXAZXTh1RvTGNgKPCqHrLgPtrbR9xHUw4x+3cON1UphBwVLkXbhlwEdeBha1wM9BAGQFHlUcBlwMMpxjfd1PBUU7AsVcfUP39tzbg+u7pVrAZaKCEgKPKqILrBxja7umoa2ouHKUEHBXakGrnwH00LT8zWl1E15QpBBxV+m5qOxcu359ju2oTcpR7e/wReNrovtzWgIJgYxoBxwxbK/SOqrf+OpTRRaXKuWtL9z6aV8HGS6jgqNAGWIZb3x7tu6DLSjkBR5VH4TZapjxCoDGRgGOvc3f8qJuajJwynYCjyqib+jt7n5rkSxkBxyvZ3Z6XEnBU25rrdm96CEwh4KgymtzbL4nUb/4c8XwXFr5MwLHXoTvuw619XMtjWbyUib5UuPccar+rfRtu/Qhsfw52EXBUubcXaoZcPmzfGnVRt+bMwVMEHBXudU2z9Q/dw3QCjipbAwxf3T1LxUY5AUele2vB5fVR0Ln/xhQCjr1Gi1e2q/aOAi6518ZUpolQYbRked/udVHNhWMKFRxVHq3iGzEOOIHGNAKOPbb2VhhVb/3fwHS6qFT6yuNarX7em2qOUgKOKn01d2+jmQj33HgBAcdeo2dRt1r/+S1CjxICjpm+er/NKCpTCDj2eiaQ7j2H+ux3wUMCjir9fgyjQQMBxksJOCr1G85s7az1O3s1wNMEHHuMpnmMtg1sQ24Udu13QRkTfanSh9zn2k5xufe2rMd5/tF+qbCbgGOvUbCd1naMy/9YXj/GbcgJOqYScFTJgMqAO0bEz7jcBjmt136t537FNegy4KCcgKNCG26fcQ239/V8vh4j4u+4BNwxVHFMJuCokl3UU1wCLJcpP63Hee1nXEPuFLfhBqXev/sH8J83elQr5T25Y1y7p9naKk43lSlUcOzVTvPIKi3ff8YlyA7d9XawQfeUaQQcVdoAy7A6xe16cEvcThdp58hBOQFHhay8lub9ErdLJo0mA5voy1RWV6XSvSWSRk89CDemEnBUG6371gZchGDjRQQcs9zbQQsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4F/gH3qxEZ3zw9DkAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="311"
            height="348"
            transform="translate(21.59 13.01) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATgAAAFbCAYAAABBH5KeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFBElEQVR4nO3dS28jRRQG0M+OE8K8woyGx///byxgARpGkGTyMIvqkjtNJyDRty2Nz5FaTrzqhfXpVt16JAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8DXZHPsFOBnbHH5v+ySPR3wXTsTZsV+Ak7BNskvybZLz4bv98EAZAUe1TVrAvUpylRZySXIfVRzFdsd+AU7CNq1ye53Db+5LkofhgRLbY78AJ6MPUy+SfDM8ZzEPTCEBxxq2aWHWP8/Tgm4Xv0EK+XFRrQ9PL9NCbRxy53naXYVFmYOjUm8wXCZ5O3w+5hByKjhK+XFRbZcWbK9yqOCmjwqOEgKOStu0UHuTtjxkl0OY9epOuFFGwFFlkzbH9i7Jh7QlIr1rOn5UcZQRcFQ5SxuWfkjyPm2YOl4W0sPNUhHKCDgq9KHpd0l+SNvBcJGn4TYeoqrgKCHgqLBNG5J+PzzT4emYYKOMZSIsbTz39lPa8HST5Dbz4WYOjjIqOCps07qm79Lm4aZzb3ONhrnqDv4XAUeFTQ67FfoWrecCzBwcZQQclcZV2kv/QwkBR4V92jFI/cy3fTQXOAIBR4XHJDdJ/hg++8GW0woOSgk4lrZPcpcWbr8m+ZxWzc1VcNMHFiXgqNAruM9JrqOC40gEHBXm5uASwcbKBBxrmHZOp99BCQFHtbl5tnGw9TtSXSHI4gQc1aaV2jTcesAJORYn4Kg0Dba54ek+LoGmiICjwnNbtZL5eTfhRgkBR4WztM32V3m62V6DgVUJOJa2STuG6yrJj2mHXvbDLqfBNm4wqOJYnICjQj+ufFrBJYeQ66H2kMNCYFiUgKNCn4O7yGEOrn8/9hgdVAoJOCr9lwW+go0yAo5qz22o12ignICjykvVm2BjFQKOSv92HJLuKaUEHFXmznsbB91jWgdVyFFGwLG0vg5u3EGdhltf/3aXQ8jB4gQcS+rh9jrtPtQ3w/9zm+17BWeJCGUEHEvb5XDp81XaftTndjEYnlJKwFFhrmLTSWV1Ao6l3Sf5lOSXtDsZ7vPySSJQRsCxpH1aoP2V5Pckf2b+whlVHKsQcCyth9xd/hluiVBjRQKONbx0JwOUEXBUm2s46KCyCgFHpefm2/qdqRb5UkrAsba+g+Fm+BRwlNkd+wX4KvVGw01aR/V2+PsmyfXw3XVUcBQTcFR4SFsD93NakN0N/39K8lvaEhIBRzndLCrskrxN8jHJZdqw9EtaJXedtj7uNvahUkzAUWF8L2qf5x3fv+CYJFYh4KjkkmcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAE7W3/fqlHyvK3IfAAAAAElFTkSuQmCC"
          />
        </g>
        <g opacity=".7">
          <image
            width="363"
            height="337"
            transform="translate(11.98 22.43) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <image
            width="355"
            height="323"
            transform="translate(12.96 25.47) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWIAAAFECAYAAAAdqTRRAAAACXBIWXMAAC4jAAAuIwF4pT92AAAFa0lEQVR4nO3d3VIbRxCA0QZhCCTv/6LxTwwGcoG6ttUaCRJWlrQ6p2pKBiuxLsznqd7RKgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgwK6O/QJYlP/y9+n1YK8CzszNsV8Ai3FVHq/a9yKm8I4CLMpcNCFmDldlXbev0+uOFe05cHGEmM+qAb6OiNV6ZZBThvelrVGUBZmLIsTMIUN8ExFf1o8Z41Qj/LxeL+UxV7T/BhZPiPmMq7ZWMcW474xz1/tc1q/2a0HmIgkxh9JHFTmmqLviX2U9xRTmUZDFmMVaHfsFsAijC3X9+xnlm9gcYeQYY1WeN7rYF4OvYRGEmM/qcewX5V7L83J8kesmNuN8E9sxjtiOsiCzKELM3EYnI/qYIXfJPcL1Ql8daQgyiybEzG10TK3OfetRtX6B70tE3Mb22GI0shBkFkOImdvoTRv7dsj96FvGOFc/DpfPHxFkzpIQc0ijIPdTEbk7rjHOCN/FZozzWNy+C3qx43twsoSY3+G9HXIdVfSd8V1MQb6N/acsOkHmLAgxv9NHYzwaVYyCXKO87z4XgsxJE2KO4b35ccTmyYoM8l1bt+X3RkffBJmzIMQc20fnxxnku4j4o6y6Sx5d2OtH38SYkyPEHFu9T3G/F0WufM4oxvcxBTmj/N7Rt4jtQI/s2lnDrISYU9F3xv1eFM/r5+X8OOfGNcY1yqMd8mhssSvMu+ItyMxOiDklu2KcNwTad9ytjivu16vPkfsd4UZxfi/YMDsh5hSN7l1cd8Y5rniN6d15dWRxHxEPsRnkvkvux+BWg5XfH330E8xGiDlVozeC9NtmPsXHZ8j3sXmBr4a57prrKYyMde6I933uHvxvQsyp68fcnmOK8GNsBvklNnfIdY7cd8p9plwDXS/65dup6+sQYmYlxJyLfqqixvgxIn7G5s3lU95UKOfIOa54GPw6fz93yPnzUf8RGH3oKXyKEHNORqOKjPHPsjLOGeacJefFvdz11jDnrrlGOP+s/ukhQsyshJhz9F6Qf0TEP+XxMaZTFynDPPq0kIgpwDXuGWMhZlY+s45zkxHMnWmN8WO8hfdbRPwdbyOHh4j4q6yHeNsN5663XoSrx9TqiY36jj+YnRBzrurxtVGQf0TE15hGDn+u10NMF+ZyJ5z/j6eYQv41Ir7H9o7ajJjZORfJUvQ3X9TPxetz4X6v4xxHPMe0q/4eb0H+tv66nswQYmYlxCxNffNFvkMuo1xnwaOzwvV4XJ0NizAHJcQs1eiua9dlrdpjxPYRuXpS4qU8B2YlxFyCUZR33Ueiv6OvzoRFmIMQYi7N6Ebx/eegh1eAOSgh5tLt+hkQXwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACW41+FaFv4YW64bQAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="334"
            height="326"
            transform="translate(43.95 8.72) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAU0AAAFDCAYAAAC++ly0AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEz0lEQVR4nO3d2W7bVhQF0E3ZloekTYsmBfr/H1f0qUGHxLP6cHgginCbPlCWLKwFXChSaEAPxNa5IxMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/rfh0F+AkzOMbTW+fx4bnISzQ38BTsqQuqeuktwkOY/Q5MScH/oLcDKG1P30LsmHVHD+neRp0uDNE5osZZWqLn9O8jHJJsn9+H+bQ30pWNrq25fAN3WV+V2SX8b2ffwoc4Lc1CxlleQ6yY9jW6W66uskdzGuyYkQmixlleQi1UV/P77/mOT3JLcxIcSJEJos6SxVWd6kAvRTKjR7Qughxjd544QmS+nlRpepbvpVKjS/pLrnmyR/RnDyxglNltKhuU6F5pDqjj+mqszN2P6K4OQNE5osaZMKy3Xq3tqkgrMDM0l+jeDkDROaLOUpNeHT45c34+cdnB2eSfJbtsE5/RyOnm2ULOksNXP+KbUr6CLbvehnqR/p6T03D1M4ekKTpa2T/JRabnSd3Q0U56kgvRyvS3bHPOHoCU2W1GOaN9mtNlvvHFqPn59lO1lkDSdvgtBkSV0tTqvNm1S12ZNB8+76KrtHFE4njeDoCE2W9pwKwXepwzt+yG612YHYwXkxtvX4vpcqCU+OktBkaR1262z3oV9ne6/Nw7CDs8c5e0XH0wvXwsEJTfbhORV6Qyow36d2CPWk0Gb2uspu1dkV55Dd0BSgHJzQZB82qcmd2/H1MtVdv8xucM4ryX5MRu8smo55qjo5CkKTfdikKs27JF9TwbnOfwfnNBBX2S5P6soz2R3r9HwrDkJosi8vBedFqps+7X73tfMu+7TqPMs2aIcXroVXIzTZp2lw9mlHvQvofGzTrvc8BKdPtuzwPM/L453wKoQm+9bBeZs6Gu5zat/5JtulSA9jm+4MmgfpfCvmvFqFVyE0eQ19aEcH5x+pLvt96oCPz2P7kgrOnn1/nLQO1K48Ozzni+Nhr5xyxGt5TlWTj6mw/Jo67eh6cs1VauvlZSok7yet/7a3W56P10+773fjNU5PYm/8QnMI03WZXSkOqbDsR2V0ddrPTO8Q7L3rq+wGcV/3kG3IetY6ixOaHNIw+3eH6b8tgk92xzWnhxz33/fz1udjpLAIocmx+dY9OeTlCaAOzSG71SksSmhyCobZq3WcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACQ5B+rN9f9UaknbQAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <path
            d="m66.42,52.7s.9.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.13Z"
            fill="url(#linear-gradient-4)"
            strokeWidth="0"
          />
          <path
            d="m69.59,54.23s1.25.49,1.85.47c0,0-.08-.7-.84-.85,0,0-.61-.13-1.02.38Z"
            fill="url(#linear-gradient-5)"
            strokeWidth="0"
          />
          <path
            d="m75.97,55.92s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
            fill="url(#linear-gradient-6)"
            strokeWidth="0"
          />
          <path
            d="m78.73,56.22s2.72.43,3.19.32c0,0-.16-.89-1.77-1,0,0-1.25.09-1.42.68Z"
            fill="url(#linear-gradient-7)"
            strokeWidth="0"
          />
          <path
            d="m83.42,56.66s2.23.33,2.96.28c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
            fill="url(#linear-gradient-8)"
            strokeWidth="0"
          />
          <path
            d="m91.47,56.77s-.47-1.12-2.18-.97c0,0-.84.19-1.02.89,0,0,2.27.48,3.21.08Z"
            fill="url(#linear-gradient-9)"
            strokeWidth="0"
          />
          <path
            d="m93.39,56.7s2.4.16,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.12.97Z"
            fill="url(#linear-gradient-10)"
            strokeWidth="0"
          />
          <path
            d="m98.13,56.58s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
            fill="url(#linear-gradient-11)"
            strokeWidth="0"
          />
          <path
            d="m103.06,55.59s1.01-1.75,2.74-.65c0,0-1.66.82-2.79.78l.05-.14Z"
            fill="url(#linear-gradient-12)"
            strokeWidth="0"
          />
          <path
            d="m107.99,54.18s2.29-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
            fill="url(#linear-gradient-13)"
            strokeWidth="0"
          />
          <path
            d="m115.04,51.03s-1.37,1.32-2.55,1.49c0,0,.23-2,2.55-1.49Z"
            fill="url(#linear-gradient-14)"
            strokeWidth="0"
          />
          <path
            d="m118.85,48.32s-.73,1.55-2.12,1.72c0,0-.16-1.8,2.12-1.72Z"
            fill="url(#linear-gradient-15)"
            strokeWidth="0"
          />
          <path
            d="m122.41,45.5s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
            fill="url(#linear-gradient-16)"
            strokeWidth="0"
          />
          <path
            d="m125.15,42.63s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
            fill="url(#linear-gradient-17)"
            strokeWidth="0"
          />
          <path
            d="m127.38,39.17s-.34,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
            fill="url(#linear-gradient-18)"
            strokeWidth="0"
          />
          <path
            d="m128.78,35.87s-.04,1.28-.76,2.11c0,0-.18-1.4.76-2.11Z"
            fill="url(#linear-gradient-19)"
            strokeWidth="0"
          />
          <path
            d="m129.43,32.59s.27.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
            fill="url(#linear-gradient-20)"
            strokeWidth="0"
          />
          <path
            d="m104.82,7.09s.65-.28,1.17.19c0,0-.8.07-1.17-.19Z"
            fill="url(#linear-gradient-21)"
            strokeWidth="0"
          />
          <path
            d="m107.35,7.53s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
            fill="url(#linear-gradient-22)"
            strokeWidth="0"
          />
          <path
            d="m110.04,7.97s.53.32,1.12.29c0,0-.4-.55-1.12-.29Z"
            fill="url(#linear-gradient-23)"
            strokeWidth="0"
          />
          <path
            d="m113.13,8.68s.9.44,1.45.36c0,0-.89-.84-1.45-.36Z"
            fill="url(#linear-gradient-24)"
            strokeWidth="0"
          />
          <path
            d="m116.09,9.45s.69.46,1.34.41c0,0-.43-.69-1.34-.41Z"
            fill="url(#linear-gradient-25)"
            strokeWidth="0"
          />
          <path
            d="m119.02,10.58s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
            fill="url(#linear-gradient-26)"
            strokeWidth="0"
          />
          <path
            d="m121.68,11.73s.75.79,1.61,1.07c0,0-.43-1.09-1.61-1.07Z"
            fill="url(#linear-gradient-27)"
            strokeWidth="0"
          />
          <path
            d="m124.79,14.17l1.42,1.23s-.26-1.5-1.42-1.23Z"
            fill="url(#linear-gradient-28)"
            strokeWidth="0"
          />
          <path
            d="m127.23,16.76s.17,1.03,1.11,1.95c0,0-.3-1.44-1.11-1.95Z"
            fill="url(#linear-gradient-29)"
            strokeWidth="0"
          />
          <path
            d="m129.24,20.92s-.29.86.65,2.07c0,0-.24-1.63-.65-2.07Z"
            fill="url(#linear-gradient-30)"
            strokeWidth="0"
          />
          <path
            d="m129.96,24.63s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
            fill="url(#linear-gradient-31)"
            strokeWidth="0"
          />
          <path
            d="m130.08,29.01s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
            fill="url(#linear-gradient-32)"
            strokeWidth="0"
          />
        </g>
        <g opacity=".8">
          <image
            width="429"
            height="320"
            transform="translate(29.49 16.51) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g>
          <path
            d="m66.43,52.7s.89.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.12Z"
            fill="url(#Fade_to_Black-21)"
            strokeWidth="0"
          />
          <path
            d="m69.59,54.22s1.25.49,1.85.47c0,0-.08-.7-.83-.85,0,0-.61-.13-1.01.39Z"
            fill="url(#Fade_to_Black-22)"
            strokeWidth="0"
          />
          <path
            d="m75.98,55.91s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
            fill="url(#Fade_to_Black-23)"
            strokeWidth="0"
          />
          <path
            d="m78.73,56.21s2.72.43,3.19.33c0,0-.15-.89-1.77-1.01,0,0-1.25.1-1.42.68Z"
            fill="url(#Fade_to_Black-24)"
            strokeWidth="0"
          />
          <path
            d="m83.43,56.65s2.23.33,2.96.27c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
            fill="url(#Fade_to_Black-25)"
            strokeWidth="0"
          />
          <path
            d="m91.47,56.76s-.47-1.12-2.18-.97c0,0-.84.2-1.03.89,0,0,2.27.48,3.21.08Z"
            fill="url(#Fade_to_Black-26)"
            strokeWidth="0"
          />
          <path
            d="m93.39,56.69s2.41.17,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.13.97Z"
            fill="url(#Fade_to_Black-27)"
            strokeWidth="0"
          />
          <path
            d="m98.13,56.56s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
            fill="url(#Fade_to_Black-28)"
            strokeWidth="0"
          />
          <path
            d="m103.07,55.58s1-1.75,2.74-.64c0,0-1.66.82-2.79.78l.05-.14Z"
            fill="url(#Fade_to_Black-29)"
            strokeWidth="0"
          />
          <path
            d="m107.99,54.17s2.3-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
            fill="url(#Fade_to_Black-30)"
            strokeWidth="0"
          />
          <path
            d="m115.04,51.01s-1.37,1.32-2.55,1.5c0,0,.23-2,2.55-1.5Z"
            fill="url(#Fade_to_Black-31)"
            strokeWidth="0"
          />
          <path
            d="m118.86,48.31s-.73,1.55-2.13,1.72c0,0-.16-1.79,2.13-1.72Z"
            fill="url(#Fade_to_Black-32)"
            strokeWidth="0"
          />
          <path
            d="m122.41,45.48s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
            fill="url(#Fade_to_Black-33)"
            strokeWidth="0"
          />
          <path
            d="m125.15,42.62s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
            fill="url(#Fade_to_Black-34)"
            strokeWidth="0"
          />
          <path
            d="m127.39,39.16s-.33,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
            fill="url(#Fade_to_Black-35)"
            strokeWidth="0"
          />
          <path
            d="m128.78,35.86s-.04,1.27-.76,2.11c0,0-.18-1.4.76-2.11Z"
            fill="url(#Fade_to_Black-36)"
            strokeWidth="0"
          />
          <path
            d="m129.44,32.57s.26.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
            fill="url(#Fade_to_Black-37)"
            strokeWidth="0"
          />
          <path
            d="m104.83,7.09s.65-.29,1.17.18c0,0-.8.07-1.17-.18Z"
            fill="url(#Fade_to_Black-38)"
            strokeWidth="0"
          />
          <path
            d="m107.35,7.52s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
            fill="url(#Fade_to_Black-39)"
            strokeWidth="0"
          />
          <path
            d="m110.05,7.96s.53.32,1.12.28c0,0-.4-.54-1.12-.28Z"
            fill="url(#Fade_to_Black-40)"
            strokeWidth="0"
          />
          <path
            d="m113.13,8.67s.9.44,1.45.36c0,0-.88-.84-1.45-.36Z"
            fill="url(#Fade_to_Black-41)"
            strokeWidth="0"
          />
          <path
            d="m116.1,9.44s.69.46,1.34.4c0,0-.43-.69-1.34-.4Z"
            fill="url(#Fade_to_Black-42)"
            strokeWidth="0"
          />
          <path
            d="m119.02,10.57s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
            fill="url(#Fade_to_Black-43)"
            strokeWidth="0"
          />
          <path
            d="m121.69,11.72s.75.78,1.61,1.06c0,0-.44-1.09-1.61-1.06Z"
            fill="url(#Fade_to_Black-44)"
            strokeWidth="0"
          />
          <path
            d="m124.79,14.16l1.42,1.23s-.27-1.5-1.42-1.23Z"
            fill="url(#Fade_to_Black-45)"
            strokeWidth="0"
          />
          <path
            d="m127.24,16.75s.17,1.03,1.11,1.95c0,0-.31-1.44-1.11-1.95Z"
            fill="url(#Fade_to_Black-46)"
            strokeWidth="0"
          />
          <path
            d="m129.24,20.91s-.29.85.65,2.06c0,0-.24-1.63-.65-2.06Z"
            fill="url(#Fade_to_Black-47)"
            strokeWidth="0"
          />
          <path
            d="m129.96,24.61s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
            fill="url(#Fade_to_Black-48)"
            strokeWidth="0"
          />
          <path
            d="m130.08,29s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
            fill="url(#Fade_to_Black-49)"
            strokeWidth="0"
          />
        </g>
        <path
          d="m66.43,52.7s.89.88,1.69,1c0,0,.14-.51-.51-.87,0,0-.65-.37-1.18-.12Z"
          fill="url(#linear-gradient-33)"
          strokeWidth="0"
        />
        <path
          d="m69.59,54.22s1.25.49,1.85.47c0,0-.08-.7-.83-.85,0,0-.61-.13-1.01.39Z"
          fill="url(#linear-gradient-34)"
          strokeWidth="0"
        />
        <path
          d="m75.98,55.91s-1.65-.25-2.47-.7c0,0,1.62-1.18,2.47.7Z"
          fill="url(#linear-gradient-35)"
          strokeWidth="0"
        />
        <path
          d="m78.73,56.21s2.72.43,3.19.33c0,0-.15-.89-1.77-1.01,0,0-1.25.1-1.42.68Z"
          fill="url(#linear-gradient-36)"
          strokeWidth="0"
        />
        <path
          d="m83.43,56.65s2.23.33,2.96.27c0,0-.4-.9-1.68-.93,0,0-.69.06-1.28.66Z"
          fill="url(#linear-gradient-37)"
          strokeWidth="0"
        />
        <path
          d="m91.47,56.76s-.47-1.12-2.18-.97c0,0-.84.2-1.03.89,0,0,2.27.48,3.21.08Z"
          fill="url(#linear-gradient-38)"
          strokeWidth="0"
        />
        <path
          d="m93.39,56.69s2.41.17,3.06.02c0,0-.66-1.12-1.94-.98,0,0-.98.07-1.13.97Z"
          fill="url(#linear-gradient-39)"
          strokeWidth="0"
        />
        <path
          d="m98.13,56.56s2.07.35,2.9-.32c0,0-.77-.85-1.83-.57,0,0-.83.24-1.07.88Z"
          fill="url(#linear-gradient-40)"
          strokeWidth="0"
        />
        <path
          d="m103.07,55.58s1-1.75,2.74-.64c0,0-1.66.82-2.79.78l.05-.14Z"
          fill="url(#linear-gradient-41)"
          strokeWidth="0"
        />
        <path
          d="m107.99,54.17s2.3-.41,2.93-1.15c0,0-2.15-.91-2.88,1.01"
          fill="url(#linear-gradient-42)"
          strokeWidth="0"
        />
        <path
          d="m115.04,51.01s-1.37,1.32-2.55,1.5c0,0,.23-2,2.55-1.5Z"
          fill="url(#linear-gradient-43)"
          strokeWidth="0"
        />
        <path
          d="m118.86,48.31s-.73,1.55-2.13,1.72c0,0-.16-1.79,2.13-1.72Z"
          fill="url(#linear-gradient-44)"
          strokeWidth="0"
        />
        <path
          d="m122.41,45.48s-1.69-.07-1.81,1.58c0,0,1.27-.58,1.81-1.58Z"
          fill="url(#linear-gradient-45)"
          strokeWidth="0"
        />
        <path
          d="m125.15,42.62s-.68,1.25-1.3,1.42c0,0,.12-1.78,1.3-1.42Z"
          fill="url(#linear-gradient-46)"
          strokeWidth="0"
        />
        <path
          d="m127.39,39.16s-.33,1.34-1,1.82c0,0-.33-1.35,1-1.82Z"
          fill="url(#linear-gradient-47)"
          strokeWidth="0"
        />
        <path
          d="m128.78,35.86s-.04,1.27-.76,2.11c0,0-.18-1.4.76-2.11Z"
          fill="url(#linear-gradient-48)"
          strokeWidth="0"
        />
        <path
          d="m129.44,32.57s.26.88-.3,1.84c0,0-.3-1.03.3-1.84Z"
          fill="url(#linear-gradient-49)"
          strokeWidth="0"
        />
        <path
          d="m104.83,7.09s.65-.29,1.17.18c0,0-.8.07-1.17-.18Z"
          fill="url(#linear-gradient-50)"
          strokeWidth="0"
        />
        <path
          d="m107.35,7.52s.38.25,1.1.18c0,0-.67-.47-1.08-.2"
          fill="url(#linear-gradient-51)"
          strokeWidth="0"
        />
        <path
          d="m110.05,7.96s.53.32,1.12.28c0,0-.4-.54-1.12-.28Z"
          fill="url(#linear-gradient-52)"
          strokeWidth="0"
        />
        <path
          d="m113.13,8.67s.9.44,1.45.36c0,0-.88-.84-1.45-.36Z"
          fill="url(#linear-gradient-53)"
          strokeWidth="0"
        />
        <path
          d="m116.1,9.44s.69.46,1.34.4c0,0-.43-.69-1.34-.4Z"
          fill="url(#linear-gradient-54)"
          strokeWidth="0"
        />
        <path
          d="m119.02,10.57s.88.64,1.45.6c0,0-.45-.71-1.42-.63"
          fill="url(#linear-gradient-55)"
          strokeWidth="0"
        />
        <path
          d="m121.69,11.72s.75.78,1.61,1.06c0,0-.44-1.09-1.61-1.06Z"
          fill="url(#linear-gradient-56)"
          strokeWidth="0"
        />
        <path
          d="m124.79,14.16l1.42,1.23s-.27-1.5-1.42-1.23Z"
          fill="url(#linear-gradient-57)"
          strokeWidth="0"
        />
        <path
          d="m127.24,16.75s.17,1.03,1.11,1.95c0,0-.31-1.44-1.11-1.95Z"
          fill="url(#linear-gradient-58)"
          strokeWidth="0"
        />
        <path
          d="m129.24,20.91s-.29.85.65,2.06c0,0-.24-1.63-.65-2.06Z"
          fill="url(#linear-gradient-59)"
          strokeWidth="0"
        />
        <path
          d="m129.96,24.61s-.43,1.59.11,2.4c0,0,.35-1.83-.11-2.4Z"
          fill="url(#linear-gradient-60)"
          strokeWidth="0"
        />
        <path
          d="m130.08,29s-.55,1.47-.28,2.1c0,0,.6-1.56.28-2.1Z"
          fill="url(#linear-gradient-61)"
          strokeWidth="0"
        />
        <path
          d="m113.25,8.64c.21.19,1.16.44,1.16.44-1.41-.22-1.37-.43-1.37-.43.62-.63,1.54.39,1.54.39-.9-.77-1.33-.4-1.33-.4Zm-2.06-.43s-.71-.65-1.25-.28c0,0-.16.23,1.07.32,0,0-.74-.15-.88-.31,0,0,.59-.13,1.05.27Zm-2.85-.58c-.27.08-.82,0-.82,0,.83.23,1.08.1,1.08.1-.58-.62-1.23-.2-1.23-.2.46-.2.98.11.98.11Zm-2.53-.43c-.27.07-.82,0-.82,0,.82.23,1.07.1,1.07.1-.59-.62-1.23-.2-1.23-.2.46-.2.98.11.98.11Zm-7.59,49.27c.76-1.18,2.22-.69,2.22-.69-1.89-.88-2.56.89-2.56.89,1.6.37,3.16-.42,3.16-.42-1.21.61-2.82.21-2.82.21Zm7.08-1.92s-1.86-.38-2.62,1.27c0,0,1.59.03,3.14-.87,0,0-2.14.76-2.74.64,0,0,.6-1.21,2.22-1.04Zm4.87-1.79s-2.11-.29-2.42,1.5c0,0,1.68.15,3.1-1.06,0,0-1.54.95-2.79.85,0,0,.08-1.26,2.12-1.28Zm2.43-.36c.14-1.55,2.05-1.4,2.05-1.4-2.41-.32-2.26,1.62-2.26,1.62,1.73-.27,2.68-1.6,2.68-1.6-.66.93-2.46,1.38-2.46,1.38Zm5.7-3.96s-1.66-.26-1.77,1.84c0,0,1.45-.25,2.22-1.55,0,0-1.07,1.17-2,1.33,0,0-.02-1.56,1.55-1.61Zm2.32-1.36c.15-1.43,1.43-1.59,1.43-1.59-1.8.16-1.65,1.86-1.65,1.86,1.53-.49,2.02-1.85,2.02-1.85-.4.98-1.81,1.58-1.81,1.58Zm4.32-4.55s-.67-.59-1.31,1.68c0,0,.61.5,1.54-1.57,0,0-.74,1.3-1.3,1.42,0,0,.22-1.68,1.07-1.53Zm2.19-3.3s-.88.15-.92,2.07c0,0,.86-.34,1.19-2.13,0,0-.52,1.54-1,1.82,0,0-.11-1.06.74-1.76Zm1.5-3.23s-.91.85-.69,2.16c0,0,.48-.22.88-2,0,0-.46,1.43-.76,1.69,0,0-.02-1.23.57-1.85Zm.81-3.41s-.73,1.1-.4,2.09c0,0,.43.21.52-1.94,0,0-.24,1.51-.42,1.69,0,0-.18-.76.3-1.84Zm.41-1.67c-.21-.44.18-1.75.18-1.75-.65,1.64-.22,2.1-.22,2.1.49-.53.37-2.19.37-2.19.08.79-.33,1.85-.33,1.85Zm.25-4.15c-.35-.37-.2-1.92-.2-1.92-.37,1.9.17,2.22.17,2.22.24-.04.23-.83.23-.83-.04-1.58-.34-1.62-.34-1.62.33.59.14,2.14.14,2.14Zm-.28-3.98c-.29-.24-.64-1.4-.64-1.4.29,1.53.75,1.77.75,1.77.25-1.24-.68-2.24-.68-2.24.43.39.58,1.87.58,1.87Zm-1.61-4.4c-.34-.28-.94-1.33-.94-1.33.33,1.01,1.13,1.81,1.13,1.81.04-1.63-1.23-2.14-1.23-2.14.8.53,1.03,1.66,1.03,1.66Zm-3.41-4.22s.88.89,1.5,1.37c0,0,.22-1.21-1.22-1.45,0,0,.92.22,1.08,1.12,0,0-1.14-.81-1.35-1.05Zm-1.45-1.33s-1.02-.46-1.58-1.09c0,0,1.01.03,1.46.89,0,0-.48-1.2-1.73-.95,0,0,.71.87,1.85,1.15Zm-3.09-1.93s-.74-.64-1.5-.38c0,0,.61.45,1.52.67,0,0-.88-.36-1.22-.65,0,0,.65-.02,1.2.35Zm-2.78-1.04s-.98-.11-1.29-.4c0,0,.62-.23,1.13.23,0,0-.69-.71-1.33-.29,0,0,.13.54,1.49.46Zm-49.36,43.52s-.45-1.22-1.83-.74c0,0,.45.86,1.74,1.04,0,0-1.08-.43-1.41-.89,0,0,.58-.42,1.51.6Zm1.58.76c.82-.75,1.67.28,1.67.28-.12-.51-.66-.7-.66-.7-.83-.23-1.25.48-1.25.48.6.41,1.99.5,1.99.5-1.28-.2-1.74-.56-1.74-.56Zm5.99,1.22s-.94-1.33-2.46-.14c0,0,.56.41,2.76.7,0,0-1.92-.4-2.39-.74,0,0,.99-.78,2.09.18Zm5.94.64s-1.94-1.43-3.36.23c0,0,2.24.55,3.66.31,0,0-2.61-.2-3.16-.41,0,0,.97-1.14,2.85-.13Zm1.93.61c1.35-1.27,2.68.04,2.68.04-1.66-1.77-3.05.08-3.05.08,1.22.31,3.34.21,3.34.21-1.05.02-2.97-.33-2.97-.33Zm7.56-.4s-2.32-1.51-3.05.59c0,0,1.97.44,3.41-.03,0,0-2.24.17-3.11-.12,0,0,.52-1.54,2.75-.44Zm4.61-.24s-1.89-1.12-2.59.79c0,0,1.68.38,3.14,0,0,0-2.07.05-2.74-.16,0,0,.25-1.37,2.2-.62Z"
          fill="#231f20"
          strokeWidth="0"
        />
        <g opacity=".5">
          <image
            width="305"
            height="308"
            transform="translate(8.82 -6.29) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS8AAAEyCAYAAACrlladAAAACXBIWXMAAC4jAAAuIwF4pT92AAADE0lEQVR4nO3c2WrcMAAF0OvJJF1o+//fWdJZMov6IKl2U0JhrDaEnAPCZtCDH8zNlSWSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHCbUsr02s/A++BFY7VFYD1/n0qSTNNU/u8T8R4IL1ZpwTUl2bRrf6dKkmu7FgHGaMKLmy2C666NbWqIJTW4zkkubQgwhtq+9gPwNj1rXNskH9q4b1POSY5tJMmllGIJyTDCizV667pP8inJ13bdpIbWjySPbW5JbWAwhPBirSlz8/qS5FtqmD0lecgcWpckpZRy1b4YQXgxQm9gD6kB9jnJKbWBnVKD7BTNi4GEF2v1XcW+s7hJ8rGNa5Jd6vJxnxpgfR6ssvn7FPhTW/r14DqntqtjakCV1D+MPcQeMu9ETg6yMoLwYo1leB1T29W+3V8zfw+7y3wODIawbORm0zSVUkr/IH9KckhdIu5Sg+qcGmIwnPBirWX76uH1PfN3sEN86+IfEF6MUDIvHR9T36un9vsuNcB6CxNgDCG8WGWxdLymNqy+ZDy0Kcf83r6csmcI4cUIy/BKu9+3+97Izm2e4GIIuz8M0Y4/bNrou4tJDbJLuzpdzzCaFyP9+hc4L/wOw2heDPXSAVSNCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHjbfgKc0qFAxIsZ2gAAAABJRU5ErkJggg=="
          />
        </g>
        <path
          d="m56.76,33.57s1.09-.46,1.21.11c0,0-.03.35-.19.6,0,0,.42-1.1-1.01-.72Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m57.77,34.29s1.18-.62,1.67.04c0,0,.33.67-.12,1.13,0,0,.41-.75-.21-1.13,0,0-.41-.28-1.35-.04Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m59.41,35.38s.96-.48,1.28-.15c0,0,.18.43-.41.93,0,0,.44-.62.25-.81,0,0-.08-.25-1.12.03Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m60.28,36.16s1.74-.49,2.08-.03c0,0,.12.78-.62,1.39,0,0,.57-.8.37-1.19,0,0-.15-.33-1.84-.18Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m61.84,37.49s1.73-.61,2.24-.1c0,0-.21,1.2-1.32,1.62,0,0,1.04-.71,1.01-1.48,0,0-.19-.36-1.93-.04Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m62.82,39.04s1.28-.14,1.78.49c0,0,.24.75-1.54,1.28,0,0,1.2-.52,1.32-1.15,0,0,0-.48-1.56-.62Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m63.07,40.8s1.77.6,1.78,1.33c0,0-.51.67-1.69.73,0,0,1.19-.26,1.42-.79,0,0-.23-.73-1.52-1.27Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m63.16,42.87s1.2.55,1.01.96c0,0-.5.43-1.16.37,0,0,.68-.14.93-.47,0,0,.07-.33-.78-.86Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m63.13,44.2s.88.37.96.74c0,0,.04.49-.87.83,0,0,.61-.3.65-.82,0,0,.01-.29-.74-.74Z"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m63.22,45.76s.52,0,.88.44c0,0-.03.33-.3.48,0,0,.65-.61-.64-.92"
          fill="#131c13"
          strokeWidth="0"
        />
        <path
          d="m49.97,41.7s.34.34.29.45c-2.64-1.45-3.53-3.74-3.53-3.74-.39-1.25-1.54-4.09-2.73-6.12-.76-1.28-.74-2.38-.59-3.01,0,0-.45,1.29.35,2.8,0,0,1.39,2.64,1.65,3.37,0,0,.83,1.9,1.13,2.86,0,0,.77,2.45,3.72,3.86-.02.03-.09.03-.24-.02,0,0,.83.39-.04-.44Z"
          fill="#231f20"
          strokeWidth="0"
        />
        <g opacity=".7">
          <image
            width="329"
            height="331"
            transform="translate(50.19 9.22) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <g opacity=".7">
          <image
            width="323"
            height="336"
            transform="translate(36.1 6.02) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <path
          d="m75.19,50.52s-2.61.19-3.3.13c0,0,4.92-.43,5.56-1.78,0,0-.05,1.06-2.26,1.65Z"
          fill="url(#linear-gradient-62)"
          strokeWidth="0"
        />
        <path
          d="m82.92,50.21s2.87.04,4.92.56c0,0-3.56-.99-5.58-1.12l.66.55Z"
          fill="url(#linear-gradient-63)"
          strokeWidth="0"
        />
        <path
          d="m89.32,51.23s2.06.64,3.71,1.35l.04-.55s-2.06-.29-3.75-.8Z"
          fill="url(#linear-gradient-64)"
          strokeWidth="0"
        />
        <path
          d="m63.34,58.3s-.77,2.2-.8,3.33l.62.79s-.46-1.99.17-4.11Z"
          fill="url(#linear-gradient-65)"
          strokeWidth="0"
        />
        <path
          d="m78.52,68.43s1.15-2.12,2.32-3.98c0,0-2.21,2.65-2.86,3.93l.54.05Z"
          fill="url(#linear-gradient-66)"
          strokeWidth="0"
        />
        <g opacity=".8">
          <use transform="translate(58.12 -35.74) scale(.24)" href="#image-6" />
        </g>
        <g opacity=".8">
          <use transform="translate(58.12 -35.74) scale(.24)" href="#image-6" />
        </g>
        <g>
          <use transform="translate(5.71 26.35) scale(.24)" href="#image-3" />
        </g>
        <g>
          <use transform="translate(5.71 26.35) scale(.24)" href="#image-3" />
        </g>
        <g>
          <use transform="translate(5.51 24.65) scale(.24)" href="#image-2" />
        </g>
        <g>
          <use transform="translate(5.51 24.65) scale(.24)" href="#image-2" />
        </g>
        <path
          d="m58.47,49.73s-.49,2.84-.89,3.28l-.25-.5s.98-1.69,1.13-2.78Z"
          fill="url(#linear-gradient-67)"
          strokeWidth="0"
        />
        <path
          d="m87,68.98s-1.6-.71-2.47-.95c0,0,2.47.75,3.34.49l-.87.46Z"
          fill="url(#linear-gradient-68)"
          strokeWidth="0"
        />
        <path
          d="m85.97,73.85l.45-.7s-4.44,1.77-6.21,1.82c0,0,2.91-.26,5.76-1.12Z"
          fill="url(#linear-gradient-69)"
          strokeWidth="0"
        />
        <g>
          <image
            width="328"
            height="341"
            transform="translate(54.99 34.05) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAAFUCAYAAAC3C/5eAAAACXBIWXMAAC4jAAAuIwF4pT92AAAGt0lEQVR4nO3dbW8bVRoG4NuJkzZt2kIXECABEuL9G///b7BShbTalRAslJdSWhqI45gPzznyJATKlhnHXl2XNLJdz7j9MLr7nNdJAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeJ5ZO2AruBm5DrNL7/fbkSTLdqwG5wzfw0YIRzalV4b7SQ7aa/98M8lxKgSfJjnJOiCXSc7y+8CESQlHpraXCsDDdtxO8lKSo/bdPMmdJC+nwu+7JD8mWaRC8STJT0meJTmNkGRDhCNTmaXC7zAVhq8kuZfkH0leT3K3fZ92zlGS8ySPk/ycCsfT9vmbJN8meZQKyUU7dxVByUSEI1PoFeFRKgzfTfJ+kldTzec7qWryLBWAPeCWSX7NxfA7SYXiwyRfpyrLx4PzloNzYTTz6/4H8H9nL8mNVDP5zSRvJ/koyTupYEwqEJ8m+aG9DkNu2c45SDXBj9r7W6lq836qivypXfskyS+D62AUwpEx7aUGV15N8kGST5K8leS1VMgtUqH2TZIvk3yR6l/s1eN5+539VJC+0X7rRupefam9v5cKxW/bbwwrTRiFcGQsvWJ8LcnHST5N8l4qyFapUPxvKsz+k+SrVBP5WX4/yLKXqhofp8LzOBWY86yryFm79jC6h5iAcGQMs9S99HKqb/HTJB+mmsGLVPP5X0kepMLxYS42hy9XfLP23S/t2ptZ92HebZ8X7TdOr7ge/jbhyFgOUiPSH6YGYI5T4fVVqlJ8kOTfqcGVPo/x/KofSoVdD79nuTgd6Ki9nqfC80lM72ECwpEx9MrxODU6fSs1HefzJJ+lwvHrrEeZ/8oUnFXWk7/733GSGoTpU4D6AM4fhSy8MOHIGPpKlxupCnKZGix5kOSfqQGYk1TY/a8V3urS6+UgVDEyCeHIGPZT1eK9VH/gMtXcfZjk+1QVOdZosjBkI/aefwr8qV413kn1Od5qf95XuJzFNBt2kHBkLL0fcbhRhFBkZ2lW83f1gZMnqb7FH1P/6RpBZqepHBnDMjXl5lHWywGT9T6NJmmzc4QjY+jV42kqGFepUes7qQEa9xk7x03LmM7bMUst/3slFZAHUT2yY4QjY+qbR6xSq1iOo3JkR7lpGctwtLpP1O4bReh3ZOcIR8byR/2Ot1MrZ9xr7BQ3LGM5Ty0R7I85OE9tEnE/1byeR/XIDtl//inwl+2lAvFee12lpvh8n5oH+SJrq+FaqBwZS68cH6U2tv01VSkepUasNa3ZKSpHxjRLjVLfzbopPdx3se/jCFtPODK2/jjW26lpPLNUc/pp1qtn7L/I1hOOjKn3J/YtzG6lqsdVqpn9NKpHdoRwZGw9IOe5OI1nkRrFfpb1VB/YWsKRsfXJ4P0xrf2xqv25MD+nqkjVI1tNODKVvoxwnuqD3M96cOZFH5kAGyMcmUJfY32WdQV52N73lTSLCEi2mHBkKj0g+/Sew1xcZz3cMVxAsnWEI1NZXTr2U+F4kPVSQgHJ1hKOTO081YRepprV88ExG3zveTNsFeHI1Po2Zr2PcZarA7JXjwKSrSAc2YRhQPZ+yHnWz5i5as31rB3CkmshHNmUqwJyL3UP9k1x+4BNP1SSXBvhyCYNA3L4XOs+WNNHtW+0z/0aIcnGCUc2rU/xWaRWyvSlhHvt6KPZ8/Z5NrhOSLIxwpHrMKwgh5PBe/D1Jndvdvcmdn+6IUxOOHJdhg/kWqSePXPaPvd117OsB2z6yhpzItkI4cg26M3s08HrsErsIXoWSw7ZEOHINuhVZF+PvRgcvZI8G3ynac3kPA2ObdPvyd7X2CeKX54KpHpkUsKRbTYbHIkRawAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADbhN47YggFX25NXAAAAAElFTkSuQmCC"
          />
        </g>
        <g>
          <image
            width="345"
            height="311"
            transform="translate(51.09 8.61) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVgAAAE0CAYAAABpWithAAAACXBIWXMAAC4jAAAuIwF4pT92AAAERElEQVR4nO3cXW8bRRQG4NexGwIUFZBAcMH//2ncVKUEpW1IbXMxO/LxxA5RunEq+Xmko/3wRrsXqzdnZ7xOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAnWrz0BcAJPXS/b092FZyN1UtfAGdhMSy77ZH15zz/IvvXsT3hdXBmBCzPpYbZxVQ13LalNsN28mVBtxjWD11HtxkKZiNgmVsPs+VUqySvplqmBVyyC7S7JJ+nWpf9TwnasVPuodqv56JUD/b1E84DjyJgmVMPslWSq6m+neoqyWX2w+0uyW2Sj0k+Tds1cMeutjsWhjVQ63Ksfv5kv3uGWQlY5tLD9TLJ6yRvkvyY5Ick303Vu9jepfZwvZnqU6ketGM3e2i9qyFahwXGoYneKa/LuoBldgKWuSzS7qfXSX5N8luSX5J8P+1fZRd0PdDWSf5NC9kP07JXD9k6Pro9sKxB20O+hmnK8T1UP+f+sIQultkJWObQg+0qrWv9PckfSX6aPr9NC9LekSa7ILxI63qTdj9+k9bt9uNrl7k5sF7D81ig1lCt2/XvhCuzE7DM5SItHN+kda4/p91f10neJvk7LWg3acF6OdUq90NyUT6rIXno0X78vAboOq0LrttjMCfClWciYJlD70RfZTeplST/JPlzqr/SHvu35dhedda/T5Itp311iOBYJ7vJ/mP/2K2Oxya6Vk5AwDKXHrJJC7SbJO+yC9jrtMf+3qHWIK0TUn1/vTcPjbuO+8budRy7nes7tvBoApa51Emrm2n5Ni1kr6d9/dF8nOFP7ods/ezYtwe2Qz00ASZUOTkByxx6qPVwfZcWku+n7dvsT3AlLTzXZb3uH19nPXS+Q9vHlvAiBCxz6d9rfZ8WbMu0MdiP2b00UD30/v9Tf4RIoPJVWf7/IfBodZjgQ3YvD9xF+HGG/Fwhc6njp30MdZxwgrMiYJnTOH567LcEAPgC/nkDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwNfnP0xJKZN4cq2SAAAAAElFTkSuQmCC"
          />
        </g>
        <g>
          <image
            width="317"
            height="323"
            transform="translate(52.87 .72) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAAFBCAYAAAAIZQhgAAAACXBIWXMAAC4jAAAuIwF4pT92AAAEc0lEQVR4nO3dW2sbVxQG0E+WL0rcRm2SXv7/f+tDoa3TuLZ8Uew+7DnMuAlxQXMBZy04jAzC6EF87H32mVECAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALw0q6U/AOTL38PH2T8FL9rx0h+Ab9pqcG3rMX3QCTxGI+xYSgu3o8FKKuA+JXkY/A0HE3bMrVVzR0nWqe/gultJsu+uwwoPDibsmNOwmjtOcpLktHt9lKrmVt3100KfkRdK2DGXFnLrVMidJDlLH3aPSe7TV3YwKmHHHFrQtUpukwq6s/TfwX23HqOFZQLCjqkN29ZNktdJzvN50N2nWtd9qo0VdoxK2DGltke3ToXbeZLvu+tJ9567VLjtu9f7VOip7hiVsGMqLeiO8zTo3qQqvFWqmntIcpvkJn3YPXzh/8FBhB1TaUG3SfJdkm23zlNtbduju0mySx92qjomIeyYQpu6blLV3A9JfkyF3nEq5Hbduu6ut7Ffx4SEHWNrA4mzVLi9TfIu1b6e5mk1d9Wtmwg6JibsGNPwiMnrVEX3PhV2r1JhdpcKun+6dZN+EivomMzR82+B/63t071K7c+979Y21dIm1a5epYJul34aK+iYlLBjLMMjJm9SIfdzqo1tQ4m7fB50w5v+YTLCjrG09vU8FXC/JvkpVdWdpPbkrpJcdtc2kFDRMQthxxiGVd02FXKtqtukAu06ycduXac/YyfsmIWwYwztdrBW1f2SamNb+3qTCrm/U1Xd8DwdzELYcajhUZPhXt02ddTkPhV0F911l76qg9kIO8bw38FEG0okVcldJPmQGkyYvrIIYcehWmV3mjpbt00dJm5DictU0H1Mf3hY0DE7YccY2oDiNP0DOR9TLWsbSgzbV2HH7NxBwZjar4O1xzRdpoKuHTUxlGAxwo4xtF8Eu03ty/2VquL+TLWwu2hfWdj6+bfAV7Xn1rVHrq9Te3N/JPktye+pIye3MYFlQSo7DtWqul0q4B5S98bep0LuIhV+WlgWtXr+LfBVwycSb7q1ztMnEBtMsDhhxxiGvwe7Tj+oaL//6snDLE7YMaYWekkfbkIOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD41v0LTLLD59QT40oAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="310"
            height="322"
            transform="translate(51.38 .5) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAFDCAYAAACwUyLbAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0UlEQVR4nO3dXUscMRQG4Hc/dKtW//+PrJS2tFrdrr04E2aUllJIRtDngZBFvZiL4eUkJ2YTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgDzav/QC8K397355WfQrevP1rPwDvxubFSCrQnhafoQvBxho2SbbT2E1zkpySHKc5EW50ItgYrYXaPsnZNLapEHvMXLUJNboRbIy0SVVo+ySHabRgO6bC7Bh7vXQm2BilhdpZkg9JLqZ5n3npudxrg24EGyO05ecuVaVdTeMw/f5hGpagDCHYGKEFWwu162nepZaeD0l+pSq3U4QbnW3//SfwX9pxjrYE/ZgKtovMy9BjqnHQOqIqN7oSbPTW9tYOqVC7mebzVHg9JLlP8jPPj3pAN4KNnl5Wa9eZq7Vtqkq7T3KXCrjWGVWt0ZVgo7ddqjq7SlVr13lerd3lebUm1OhOsNHTshPa9tYuM++ttW7oY6p5INQYQrDRy3IZepGq1m5SS9J2ILeFmkqNoQQbPW1TwdaWocumwWPmfTXBxlDOsdFLO7vWKraraT6llp2WoKxGxUZPL/+N6mz6+WOqYWAZyioEGz0tb/LYp0LulAo159ZYjWCjt9YZPZvmp9Ty85h5GapiYyjBRk+tM9quKmrDtUSsSrDR23Kf7ZDaa1vewwbDedHobVm1HTJ3SNtdbNuo4BhMsNFT209rY5MKt8vMXVLvHMM5x0ZPp9SRju9JvqQqtRZ2y2+ngqF2r/0AvCnLm3M3qU7otyS3ST4l+Zo69uHIB0Op2OjplLqW6DZVqX1OhdyP6fN9hBorsDSgp1axnWfuiLbKzeWSrEaw0dvyy5FbB7Tts7kGnFUINkbZLOYWZAINAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADg9fwGdyiFaI29qAUAAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="324"
            height="316"
            transform="translate(29.04 4.06) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUMAAAE7CAYAAABHQuOrAAAACXBIWXMAAC4jAAAuIwF4pT92AAADjUlEQVR4nO3c227aQBiF0e1Azn3/F62a5gi98Iz81yUXVY1xo7WkkUkAiQv0aYaxnQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAf2a49Afgyxhmx2N57hjYuP2lPwBfwjAb3TFTCAWRTRNDljIkuUqyyxTEQxsf7W9BZLN2l/4AfAlXbezbuM743bq65IeCv2FmyBL6jK/PDvfteGjHIcl7LJnZMDFkKfX3wSHTd6svm/vS+SNjJBNRZEMsk1lC3TzZZVou7zMtl525wKaJIUvpsZv/flijeGrHOSf+htWJIUuqses7y/NNlXkYYRPEkHOoS+YewOskN+3Yw/hZEEWS1YkhSzq1/J3H8KY87rvO9TfF+RFWIYasYR7E20xh7FHclWEJzerEkHOqp9rUINYo3rXjbfmfXWhWJ4acWz2XsG+qzIN438ZjkoeMgazL6FM3f4BFiSHndupmDfVKletMQXxM8i1TFO/b80N77yGCyJmIIWvoQTyU0aNWZ4t3+TOKd+35/v6PCCJnIIaspcbsvYx+ed4x02V8N5nCeJsphvU9dcYJ/0wMWVOfFfaovSZ5S/LSHtfQzW8H9t5e99zeY8nMosSQtfWI9Rnia8bIvST5mTF2PY79ueckT0l+tNe8ZrpHIizCaQtcwvw65r6ZUk+3eci0RD5kjOL3Np4yzQ5hEWLIpc3veFPPR+yn1iTjTLDPFt9iI4WFiSFbUS/Dq5fo1XMMT+1GwyLEkC367Ppkd8oGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgN/9AsfcbrEYO6nvAAAAAElFTkSuQmCC"
          />
        </g>
        <path
          d="m72.18,46.72l1.09-.26s-.9.17-1.09-.11v.37Z"
          fill="url(#linear-gradient-70)"
          strokeWidth="0"
        />
        <g>
          <image
            width="309"
            height="330"
            transform="translate(33.3 -1.72) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAAFKCAYAAAB8a8gQAAAACXBIWXMAAC4jAAAuIwF4pT92AAAECElEQVR4nO3dy04bQRAF0GtjAiT5/3/MIg8pDwWC4yx6StMMRNl02xI5RxrZ7GZhXaqrXwkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADA7tIvwKuy23yeNp8wnVBjlN3y7PM01E5JfkewcSZXl34BXoU+0A5JrpfPCjiBxtkINUaoQLtKC7Q3y3OVNdQEG2dxuPQL8KpUuF0vz2n5+5SnwSbgmEaoMUofXLu0Km2fNdSqr/Z4qRfk/yDUGKGCrMLr9/L3IS3cTkmOy7OPiQMm0lNjtAqz6q3VP85j9wg0phFqjNTPgvahtkurzh6zhppgYwqhxmh9qN1knQWtftpjWsDBFPtLvwCvTvXVjll7a33A1fo1mMKPi5H6HQTVP6se283yXOfprgMYSqgxWj8DWsPMQ1qVdpuni3IFG8MJNWbog60W4L6JIShn4IfFDH/rq9X2qX5fKAwl1Bjtpb5a0oLsNs+HoDCUHQXM8tJkwS7JXZ731axZYxihxgzbc9Rq+FnVmkqNaYQas2yDrXpo27PWYCg9NWbZ9tVOadVZbXIXakwh1JihqrRj2raoX1mrtUPWYLNWjeGEGrNUpdZvYr+KZR1MpqfGTP3BkRVopyRv0xbimgFlOJUa51DDzrsk75fnLus+UBhGpcZs/VFEt2lD0nfL91q7plJjGKHGbHVfQR0/lDxfgAvDCDVmqiqsvzovy3fLOphCqDHb9pLjWoCrSmMKocZMfaVWoZasFZpQYzgzT8z0UvO/FuX2h0jCMCo1ZqsFuA9JfqYF2o/le13CYuaTYYQas9SOgl9Jvif5nDb8fEzyMcnXtKBTrTGUK/KYpfpl+6w9tPskX5J8SAu2b3FlHoMJNc7hmFaVVcX2Ka1Su896Mi4MYfaJmV66rT1pAfcQVRoTCDVmq6UbNQzdHh5pkoChhBrnsv2tCTMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPi3Pz5HmyfuoUpGAAAAAElFTkSuQmCC"
          />
        </g>
        <g>
          <image
            width="305"
            height="325"
            transform="translate(35.57 -1.12) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATIAAAFDCAYAAAC5uIKhAAAACXBIWXMAAC4jAAAuIwF4pT92AAADhklEQVR4nO3dXWsTQRQG4Ddpmqj//2eKaOsHVtN4MTvsNBREMsdgfB5YFtIW9mJ5c87ZnWkCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8qzbXvgBu1vm9dbrKVfBfuLv2BXCTNsuxjS9L/gJBxmw9xO6GQ5hRSpAxWw+x+yT7JLu0yizRXlJkd+0L4KaMLeUuLci2SY7Lz09Zw0yoMY0go0IPs/vlOA+yn1e6Lm6UIKNKbzH3WauvY1qI9ZmZqowptr//FbhID7N9WnVm+M90goyZxvnX83LeZJ2X9SBz3zGV1pLZTnk51O+zsmQNs6e0gNNaMoVvRiqMYdafYB6SvMnL9lKLyRQqMqr0aqu3lok5GUUEGRV6Nfa8HONLsn1GJsiYRmvJbGOIHZdzYskShQQZVcaKLFlnZaoxphNkVBifWiZriI1tpTBjGkFGtW1agO2yhpkQYypBRqVxAXk/VGRMJ8ioMu6E0RePn1dkwowpBBkVxqDqbWUPM0uUmM4NRZVejb22yaLWkqkEGZX6fKwHmbf6KSHIqHJejfUg8y4Z0wkyKoxLkg5J3qYtGN9HRUYBQcZs42zskORdWpAJMcoIMiqM21wfsv63ruNy2IeMqex+QZVTWmh9T/J1OT8m+ZbkR9YdZOFigowKz2lh9TnJ++WzTZIPST6mhdrx9T+FPyfImK3vevGU5GH57HE5f0nyKS3IVGRMY/BKhXFpUn/tImlV2lO0lkwmyKgyrrXsD5X6/mTn2/zARQQZ1c7vMQEGAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAzPILYiBTNsTf2v0AAAAASUVORK5CYII="
          />
        </g>
        <g>
          <image
            width="307"
            height="321"
            transform="translate(37.52 0) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATEAAAFACAYAAADUG0sMAAAACXBIWXMAAC4jAAAuIwF4pT92AAADi0lEQVR4nO3d2WobMQCG0d9L7DTp8v6vWCi0dMtiJ73QiJFb2guPhME9B4Qd52YuzIekGc8kAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcKbVpQ+Aq9R+r14vdhT8F7aXPgCuyqp5XeU0YGLGECJGT6sk62nUiL1MQ8QYYnPpA+Bq1IBtk+yS3Ex/v0bAGMhMjB7q8nGdEq99ynfrOP2/DZmg0ZWI0VOdie1TYnZICdkhf+6RQRfrSx8AV6POxDaZZ2P7lKXlJs6EM4iI0dMqc8R2mSNW98eEjO5EjF7qvtgm8+Z+nY1tM8/GhIyu7InR0+8zsWNOAwbdiRi91IDViG2bz2EYy0l6aDf1d9PYZr5OrL3g1RlKuhIxeqizsF2S22nschox8WIIEWOpulm/TYnX3TTaiLUDurInRg/1Itcasdvm80TAGMhMjKXapeSbzBFbpywjj9MrDCFiLNH+6Ps2yf00blJmXs/TOMZsjEEsJ1miRmyfEq/30+smZfb1lDliZmMMYSbGEu2G/ruUiN2lfK8OSR4zRwyGEDHO1d565y7Jh5SI7VOWjY+ZI+YSC4YRMZZYp2zo36dE7G3mW/A8pETsEPthDCRinKu9Pqz+2HuTEq2fSX7kNGIwhI19lqpX5D9nDtfnJF+n95aSDCVinKuN1/ckn1LORj4k+ZgSsaeIGIOJGEu8ZJ55vaacpXxK8iXJt8yb+jCM26SwRL1zRb354SblcorHlJgdImIMJmIs0T7l6G/PmrSUZCgRo4f2yd8ezQYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMC//AKT3HBHdo9wHQAAAABJRU5ErkJggg=="
          />
        </g>
        <g opacity=".7">
          <image
            width="307"
            height="308"
            transform="translate(29.5 4.04) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAAEzCAYAAAC/hP8nAAAACXBIWXMAAC4jAAAuIwF4pT92AAADHUlEQVR4nO3bS2tdZRSA4TfHNOK1VWgHWpGjTvL/f0yHAcGBiNpKvaS5OVg7EJ1o4TsG4vPAJiEngz04vFnrOzsFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8HaO7vsGeHhenO3/8r463Z/d3Ne98P8iaCyzheyoeqfabT++vr2EjUPb/fOvwL92VD2q3qs+rh5XH1bvVsd/n9xgNW8wlthiddzE7HH1pInbH9Wr6pft+0uTGodiQmOlXTONPameV99s1/Pq0yZ2JjUORtBYbVedNCvnZ9XXTdS+SNQ4MEFjpevqojqv3jQr59PqqyZsnzfr6Em1EzVWEzSW2M7FrpuYvap+3L7umqjtqy+rZ9UHzXmboLGUoLHSdTOZva5+qL6vXjbh+qRZQZ816+hJgsZigsYy25R2Vf1e/VR9V33bhO28idhH1ftZOzmA4/u+AR6cm+Yc7XUTsuMmck+bCe6qefD27sO3sISgsdTp/uzmxdn+dvV82QTuvFlBT6rftutyew2WETSW26J22TxIe/tBwc9N0K6a6e3N9hos4/yCg9nOx3bNH85HzZpZs5JeVFen+zNRYxlnGBzMnUc5LpoPCn5t1s3zZlKzcrKUCY3/zN1PNP0/JwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwgP0JY0xwNmQT0PgAAAAASUVORK5CYII="
          />
        </g>
        <g opacity=".7">
          <image
            width="302"
            height="306"
            transform="translate(31.96 .26) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS0AAAEyCAYAAACvY4agAAAACXBIWXMAAC4jAAAuIwF4pT92AAACm0lEQVR4nO3bMWsUQQCG4ffOM0bRqKUWQkr//4+xzA8QBCWJJpo7i9kDtVDILh6ezwPT7G4xxfLxzcxuAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHBvq0NPgOPw7uL8p3fp7fnF7lBz4bgJLWaZwmpVradRtZ3GTnixtPWfH4HfWlWb6nH1rDqrnlQPq/WvDQzm2hx6Avy7pkB6UD2qnjcCa11dVh+r6+prpW2xGE2LudbVafWiel29qV41QuwkbYuFaVrMtW9b++A6azSvz9VVdVvdHWx2HB1Ni7m2jVDaNsLrafWy0bROp2uaFosRWtzbdDK4q741GtXtdOtkGpsEFguzPGSubSO0vjQ24C9/uGYDnsUJLebaN63r6kPjU4cap4c3jQCDxQgt5tqH1lX1vhFUVZ8aQaZxsSihxRLuGsvDXSOoauxv3eTkkIXZJGU2v/LwNwktFuOnaQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOA/9R0GN00HiW3ragAAAABJRU5ErkJggg=="
          />
        </g>
        <g opacity=".7">
          <image
            width="305"
            height="307"
            transform="translate(33.76 -1.97) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS8AAAEyCAYAAACrlladAAAACXBIWXMAAC4jAAAuIwF4pT92AAAC6klEQVR4nO3cS2sTURiA4beJt3qpKIiKCoor//+PcSUKVtSNRS1q1TYuzgSqCwUzpV6eB4ZCksUshpfznZymAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKjaOu0b4N/w+OmD756lRw+erk7rXvg/iBcbmaK1VS2rxfTy0foSMU6KePHbjoXrbHV+uhbV5+pg+nsoYJyExa8/Aj+1rC5U16o71b3qVrXTFLMfR0qYw5nTvgH+autx8WJ1oxGui9XbardaVYeNFZjVF7Oy8mJTi8bYeLm6Wd2vHlZ3q+vVdrW0+mJu4sWmVo3N+VXjebrSGBvvNmK2U53L+MjMxItNrMfCT41Rca/62NgDu1ndbuyFbTfGS5iNeLGpw0aw9qqX1etGzLYb4braiNky324zI/Hit01HII4aG/LvGuHarV5V76f3thrPmXAxK/FiI1PA1quvN414PameNWK2X31phAxm46gEc1g1ArXfWHUdVJeqr41x8kMjcI5LMBsrLzZ2bHw8aIyPr6rn1YtGvD414gWzsQ/BbKajEItjV42oHVYr/ybEnMSL2fmFCQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAP8I3LiVj6WNWGvsAAAAASUVORK5CYII="
          />
        </g>
        <g opacity=".7">
          <image
            width="305"
            height="310"
            transform="translate(36.01 -1.28) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAAE3CAYAAAAt/h1LAAAACXBIWXMAAC4jAAAuIwF4pT92AAADI0lEQVR4nO3cO28USRSG4Xc8XJebVqzYaJEQEf//xxBCggi47mJzWfAMQbWFcQDBlBnJPI9Uaqlnggpan845XeoCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAXWe17A1wcj588+O55evTgyXZfe+H3IMDY2RJcq+pgWVWbZW0FGedFgLGTU+F1ubpaXVl++r/6VH2pNkKM83Bp3xvgQlhX16o7y1pVh9Xb6qj6XAkwpjv4+V/gh1aNALte/VXdrx5W/1R3l/vrs/MxmEGAMcNBo4W8Wd1rhNf96u/qdqOtPBBizKaFZIZt34b260ZoXWvMwI6qD402crOvDXIxqcDY1bY6boTVu+q/xuD+ZqMCu1vdaFRoKjCmEmDMcFx9rP6tXi7XVXWr+rMRZtpIphNg7GQ5HrFpHJs4rF5VbxqBdrXRTp4E2HpP2+SCEmDsbAmxkyrsXSPADhvt5fXqj0aYrdNGMpEhPrNsGoP6o+p1o5W81Ai2dcKLcyDAmOm48cbxTfV8ubdpVGbHOczKZFpIpjgzC3vbCLCn1bNGRfYxxyiYTAXGTNtGG/m+erFc18v1Q6owJlOBMc2pKuxT395IvmycDTtpI2EaQ1WmO/N5nRpV1zaf1mEyAca5OX1oVXABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQNVXYRx3wSCmerAAAAAASUVORK5CYII="
          />
        </g>
        <g opacity=".7">
          <image
            width="301"
            height="306"
            transform="translate(38.95 0) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASsAAAExCAYAAAAk6YRJAAAACXBIWXMAAC4jAAAuIwF4pT92AAAClElEQVR4nO3bwWpTQRTH4V/SVimirnyALn3/h3HZd1CxqamJi7mXtiIKvVeC4ftgFhOyOIvw58ycTAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/N7m1AVwHj7d3jz7LX28uT2eqhbOk7BikSmkNtV2WlWHaR2FFmvZ/v0r8Eeb6rK6rt5O67q6qja/dlzwUpenLoD/1xREF9Xr6l0jqDbVl+pzo7t6OFmBnBVhxVLbRli9rz5M+6tqX32vflSOgiwmrFhq7q5eVW8aQbWb9hcnrIsz486Kpeaj3kOjmzr2eOFehjisRFjxYtOk79gIqrvqW6Or2jdCDFbjGMhSc2e1q742wms3fXbIfRUrEVYsNXdWu8YEcN/osu7TXbEiYcVSx8bEbzft7xqBdZ9JICsSVqzh0PibwqFxDzofDXVWrMakhsWePLmZ13zx7rkNqxFWrObp0xohBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/AM/AV7wT7fxTYiAAAAAAElFTkSuQmCC"
          />
        </g>
        <g>
          <g opacity=".7">
            <image
              width="306"
              height="307"
              transform="translate(51.76 .49) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATAAAAE0CAYAAACram/lAAAACXBIWXMAAC4jAAAuIwF4pT92AAADBElEQVR4nO3cTVLCQBAG0CaInoOl9z8MS+4hfy6SNpMYF0wGLan3qqYSCrSyoD47PW0iAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJ7f4bjfHI77zV9fB8/Ll4tmZmFVnt/y5H1/vAU0IsBoYgivXBHfAyyD6ybEaEWAsUpRdXUxBlgZZBF9eF1jDDIhRhMvf30B/F+zqqsb1jamAZbhtRmOGWSwmgqMKrPw2i6sTYwV1zkiLsW6hiqMBlRgrFGG1y7679NueB3Rh9cllqsx4cVqAoy7FdVX3jZmcL3GGGB5y3iKaZCp+mlGgFErAyyrr9eIeBuO3fCZc4zh1S38DlhFgHGXhcb9NsYKLFcX0/5XhFtGHsBfRWot7T5ui9fp9sOC1QQYNebzXktjE9eY7j6WIxR2IGnCLSS1JtP1MQZVOkffwD/FGGQZYtCEAKNGGVzX6MMpe11lA/8UER/D8ZI/p/qiFQFGrazAyvDK3cZs3meITQZYf/1KeVpmcrjbsBNZzoCVDfwcUr0sLL0vmlKBUauswMoJ+/l7X8174UVrKjCqzObBsiIrefoEDyfAqFY8SmfpX4S+dimFF48iwFjtp8dGCy4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAe5hMGSqHAU94F7gAAAABJRU5ErkJggg=="
            />
          </g>
          <g opacity=".7">
            <image
              width="307"
              height="306"
              transform="translate(54.91 .48) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATIAAAEzCAYAAACymo9gAAAACXBIWXMAAC4jAAAuIwF4pT92AAADBUlEQVR4nO3czW7aQBiG0ZfftpeRZe//YrrMfTQGurAHDyM3VfCkqPQcaWQUiORF9OjDHicBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgP/W5tEnwHP68fqy+Lf1/eX18rfPhecnZHRVBaw9XuqjoNGTkNFFE7B2JWPAbpaY0YuQsdoUsbK21apDds4YsHO1xIwu9o8+Af5tTcR2zSoxKwE7TSuZJzNYbfvoE+AplIjtkxySfEnyrVpfp58dps9cp7Xf3RSAjzCRcbcpQtvcRuyYOVq76aPnJG/T60vGqWwbUxmdCBl3Wbguts8YsTJ9HTOG7JJkmH7tNL02hdGVkLHGexPZMfPUtck8hbV3M2E1IWOt+k7lvlmbjF8ri3YLBnQhZNyr3SvWTlslVKdqXbddRMzoSMj4sHfuNJZtFkPmSA1Jfk7rLXPQ7PCnGyGjh3IncsgYq0vm62NLIbuJGazlgit3abZeHJq1y/z1ssStrCFTyExj9GIiY60yjdWPIm2b94bqaBKjOyFjjXJNrCgR2zTvl8eTrhf6TWP05Ksld1vYFLu0P6x+WNwFfj6FkLFKFbM0x5v/PxZTGJ9IyFjtTw9+CxgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAT+sXGjuW/O1AUfUAAAAASUVORK5CYII="
            />
          </g>
          <g opacity=".7">
            <image
              width="308"
              height="304"
              transform="translate(57.54 2.38) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAAExCAYAAAAdjjUSAAAACXBIWXMAAC4jAAAuIwF4pT92AAADAUlEQVR4nO3cQW6bUBAG4LFDnTa38LL3P0yWPkcaY7IoUwaC0qo81637fdIIZLNggX7N8IAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIB7tLv1CXC/nk/HD6+vr8fT8KfOhf+HUKO5Ema7mF9ju4jIIBtyX7jRklCjmZUw25f9/G8odcl9wUYrQo0mxkCrYZb1EO9D7RIR/bjNEmw00d36BPj3LQLtoVRX9jPU+rHOY0WUURS22t/6BLgbNdA+RcRjRHyOiKdSX8bfHsdjuigj6s8WFuBX6NTYpHRpOW52MYXaYaxuPCY7tJeYj6H70K3RiFCjhTp6Zqgd4ntXdohp/OxjHm7ZpUEzQo2t1hYIupXKTqyuiEJz7qnx2xb3wJaPc6w9xrG66hnGThrSqXENGVjnmMbNISJeS51jCjjBRjNGADZ5Ph1znMwx87CovJ+WIfet1CzcPKdGCzo1thpiCq3anUVMK5t53LnUa8w7NWhCqNFCjo99+e0S89XNDL2+lLcJaM74yWYrz6pl1esrFwou4b1Prkio0cTiVam11c/c1vKFDpoTajSz+EpHbmto/dgXZlyLUKO5tXc4hRgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMBf7g1MS5cAxkSUHwAAAABJRU5ErkJggg=="
            />
          </g>
          <g opacity=".7">
            <image
              width="306"
              height="306"
              transform="translate(61.27 3.62) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATMAAAEzCAYAAABdWOReAAAACXBIWXMAAC4jAAAuIwF4pT92AAADCklEQVR4nO3cS24aQRQF0AvBzjoYZv+L8ZBlxHGAzqDriaYDtkQXdkTOkUpV4iPVoHV5jy5IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAf83Lbrt62W1XX70PHpsLjO5mwTVdD7X4sd0NgY6EGV21IKuRXA6zIckg0OhJmNHFpBpbZ7yuap5eY8eMQVazQKMbYcZis2rsW8Ygq7musQqxQxsCja42X70BHkYF2WY2r9vzFWLTD9DDZ26QxybMWKRVZVWJbdp4TvLU1uuMFdg+ye/2tmMbq0xuCsASwoybzdrLCrTnJN9zCrRVxuCqCq3WvuKgK2HGUvPK7CmnQNu056udPOQ8yAQa3QgzergUaNVylv2F92kx6Wb98UvgqtVsrHP9SMZfxzI+dac8PJUZN3nn50nTIxhp6/1knB3LuPM2+Y8IM3oZMgbVPqeKf59TmP3KeDezAm1I/KyJfrSZ3KSFUI1qIw8ZA+styWuSn21+bY+95RRwVZ1BFyozeqiqrFrP+VGMqtjO2kxVGT0JM5aqyqzMz5FNv0OriuwoyOjNOR8WuXBwdn4nc96Oqsi4C2HGYpNAy2ye/uVPIsi4I2FGFx/9k6wQAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC44g/4KJTKEL/bhAAAAABJRU5ErkJggg=="
            />
          </g>
          <g opacity=".7">
            <image
              width="310"
              height="304"
              transform="translate(58.86 8.5) scale(.24)"
              href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAAExCAYAAADyTF4sAAAACXBIWXMAAC4jAAAuIwF4pT92AAAC6klEQVR4nO3cS3LaQBiF0QvEC/Ew+19Mhl5IDMoAt/gltyd0E/I4p6oLKHuggeqrfggSAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgNzk8+wL4f/x4e13vt++vb8szr4V/k6DxMDVg+XyvrUETN2YRNKYrITuUkfK6lJEki6gxg6AxxS5iSXLMLWbHbO+1JcnlY6xxEzVGfXv2BfD3+4jZPmTHzki2MTtnGzYYYobGkBKzNk65xuu0G3W5eU7yvnu9xCyNQWZo3G0XszYLO+V6X9VRg9Yillzjdsw1ZoeYpTFI0JihBa3F7KWMGrQlt5i1JWddrsIQQeMunaXmV0F7yW3/rO2VCRkPIWiM6i076x5a74SzN2CYoDFD71mz5HaiWZeb7RBgPQiIqDGJoDFDDVJ9JKN9bv/TgvYzu9PNOOFkAkFjVItZb5P/XN63v79nO1PzDBrT2JTlbuVgYL9vdsr2YdpkO3OrS07PnzGNGRoztBlafb8/xbwkn77yJGZMZYbGkM7jG/svpCfb/TVfSudhBI1hnV/X+MoaMyHjEQSNaXa/f9YlZAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8SX4B9p2a+yXjuYkAAAAASUVORK5CYII="
            />
          </g>
        </g>
        <g opacity=".7">
          <image
            width="316"
            height="310"
            transform="translate(44.98 7.96) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAAE1CAYAAACY1ke3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAEKklEQVR4nO3dQW7bMBAF0Emci2TZ+x+my16kibtoGEzHI1mS6aRp3wMIUYbkeGH8DCVSjgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4mh4++wPw//j+43nx+/bt+cf5Iz8L/x9hx92shds1wo/ZhB1TNQG39zv2R8gJPWYRdkxRQm5LPzs3/ffXBB4zCDtushBy17ZZDbd2K/C4lbDjsBR0eVv7S4FXq7lz/BlwdV/gcZOnz/4AfD1NNbelRVz+cz0vtHoM3Exlxy4r1dxDRDyWbe7ncyL6kHst24sQVN1xlMqOI3J45YCr/Rx6o9Whag64eNs+pv1xfD4XdlPZsVmp6rqgOzX9LuxqNfcaES+pn5vqjilUdmyyEnQj1E4L/Rx4EZch113H6ypBuImwY49apeUq7hS/v0+nuB52uZobr53Te57T8QKPKYQdVy2siqhh95RaDbxa1b00r+XrdvnvCDqmEHbssVbVLQVeV9UN9WaEa8jcjbBjq6WpJt1Qtgu7HHSj312vW9uHw4QdR9TAOzXtKfohbLVp9QTc6vGzPwB/tx2rJR5L61ZQDHWO3dK+oGMaYcdRW5eIRVyfVzf6XdCZY8cUhrHMthRWLyttbSIxTCHsOKqrvOrSr1HdjertJSJ+vrW10LMulumEHUcsBV2eKDzuttbK7mdptbLrrt0JOm4m7NijDk9zSOWJwmP+XD4nh13edkNZQ1imM4mTq97uyG6ZTLy0aiIHYg26pet141xVHVOo7NgrD1tHAOY1rrmqq8fXSi7fhRV03JWwY6tz6ddVEHUxf3fs0qOc2rl1go6ZDGPZpAxlu2fZdU84iehvYqw9kTgiBB3zqezYIwdQ90ThPLTN5yytkhj99/cWctyLyo7Nmgd4Xls5MXTz5lyf40Op7DiiezpJDbr6exNj2/UFHXensmOXjT+K3emCT8jxYYQdhyyEXu1HXN7FfSfo+EjCjsOax7UPeTrKBSHHZxB2TLESfBEh4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPg3/ALglZhwDo7jKQAAAABJRU5ErkJggg=="
          />
        </g>
        <g>
          <image
            width="310"
            height="306"
            transform="translate(7.6 19.93) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATQAAAExCAYAAADyTF4sAAAACXBIWXMAAC4jAAAuIwF4pT92AAADJElEQVR4nO3bQYscRRjH4d/OJiaLcZUICorioJf9/h9mjxMED0EUWTXrxsyMh6oh6tHp7LDxeaCYprsPdWje/tfbNQUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANyTs1NPgPfD9Wb9j2fpar3Zn2ou/H8paBxlFrKzajXHWbWbY1/tFTfuy6NTT4AH76w6rz6onszjbfXnHG+uN+tdChv3QELjP5vpbNUoZM+qy+qikc5uq1fz9656M88rbLwzq1NPgAfvkNAuqufVF9U31br6qvq8+qT6sJHiVv/ut8FSFDSWsJ/jvJHUPmsUte+qb6uv57nL6ml1rqjxLnioOMr1Zr1qJK/LRtH6spHKPq4eV6+rX6qXc/xY3TSWoVvLT5bkowDH2jf6Y79XPzVekttGv+zT6qPGcvRJ43nbzeuHexQ0FmPJyVFmwto2EtdNI4V9X72ofqh+bqS0x739cPC0Udz001iUhMbRrtab/fVmva3+aBS31/P410Zqe9Z41u7m9cPeNViUgsYiZlHbNYrZYR/aq0b/7KLRZ6uxjeN23mO5yaK8JVnc3/annTeWmo/m76G/dtcsfFfrze5U8+T9o4fG4mZfbddIabeNDwY3c/zW26WnhMaiJDTuhT+vAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPDx/AaRzf3it8voHAAAAAElFTkSuQmCC"
          />
          <image
            width="313"
            height="310"
            transform="translate(10.01 17.89) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATgAAAE0CAYAAAC4vS8RAAAACXBIWXMAAC4jAAAuIwF4pT92AAADgUlEQVR4nO3cS29bRQCG4TfBpaQU1IAKiALCsMr//zFZWiAQCpdy6YVAk7iLOZHTSCxQj20peh7J8lXWWRx9/ubMjAsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYBYH+z4A7o7T1fKN8+lkuVrv61igBBwzmILtoDqcbgfV1XRbV2thxz4c7vsAuBMOqneq+9X71QfVw+qoulcd3m53sAtOOt7KFFyHbcLtw+nxVfV39WK6/7e6TJtjhzQ45nDd4I6qR9Wn1efVk+nxcSP83k2bY4cEHHNZN1pbjSB7VH1WfdkIuseNdvdetRBy7IKTjLd2uloeNq61PWy0tcfVR41AW1Tn1R/VL9Wv1Z/TaxeGq2yTBscc1tVF9bL6vTqrfq6eNQLuk+qb6tvqi0b4HaXJsWUCjrc2tbCrxkTCi+ppI+TOGs2tRrP7qlo2hqxCjq0TcMziVsi9bATbWfVTY1j6qrF85En1dWMS4jghxxY5qZjdFFaLRngd92aoPaieVz9U31U/NsLwvLp0TY45LfZ9ANw9J8vV+nS1vGisf6vND+m6MbN6v/p4ev96jdxFm50PMAtDVLZiamLXIfe00dRW1ffVb41Fv0dtdjwsskaOmWlwbM2tJrduhNp5Y6b1wfT8cvq4YGN2Ao6tuhFy520mIf5qtLbDNsPUywxPmZlfTXbixp7VRWOnw73G9q7L6p+mvaony9XVf34J/E+uwbETN5aRvGosI3nWaHLPGwGnwTE7DY698OeYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAExeA+N4nqA1qhUjAAAAAElFTkSuQmCC"
          />
          <image
            width="317"
            height="310"
            transform="translate(5.29 21.5) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAT0AAAE2CAYAAAATXEVeAAAACXBIWXMAAC4jAAAuIwF4pT92AAADy0lEQVR4nO3cy04cVxiF0c9gGzuG4PiSxLkMeuj3fxiGPcogiiEJli8YQ2dwqgVGKImUgo7QWtIRCGpQA7TZ/6lTXQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8HfubfoGuFsOlosv/qZeL5arTd0LXEfoMYsp7O5VW9OqWlXn1bnw4//i/qZvgDvjXrVdPZzWdvW5+lSdHiwXZ9VK+LFpmh7/2dTytqqdarfam74/rd5V76uPjRA8T/ixQVv/fAn8K+um97j6pnpV/Vz9VH03/exJowVuXd37g9tivGVOq2ltNxrfV9Xz6m31+7T+bLS/EyMvm+C/LbM4WC62Gi3u6+rb6sfq+8aou2oE32/Vr9VhddwYeU8z8nKLND3msmrs2b1vNLqdxqi7Wz29tPYaY+6b6o/p+pPq88FyIfy4cZoes5n26e5XjxoB96qxp/dDtd/YQ35XHTVa35tGQB5XH5rCL82PGyT0mNWV4NuvXjbG3JeNhxk706UfG4F32EX4ve1S88v5Pm6A0GN2l4LvYWOUfVo9q140Hmw8a4y+542gO5rWYV8+7PiU4GNm9vSY3evFcnWwXKzH1LNGc3vb2MNbB9qLRiA+bhxpWZ/ve9LF3+WqEXxCj9loetyYK6+mPWiMvHuNMfd5Y/xdH22533iSe1T9Mq2jxhh8pu0xF02PGzMF1epguVi/g7t+Le19o/Wt293+9PXBdM1W46yfw/PMTuhx464Jv9PG09rjRvvbbYy1j7rY5/vQCEANj1kZb7lVl14/W7+2tv6Qgp1G06uLUDxpjLbnt32f3F1Cj4255uOotqdfrR+AOK/H7IQeG3el/a2tyoeQAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAt+0v7sPBmLXDhoAAAAAASUVORK5CYII="
          />
          <image
            width="312"
            height="305"
            transform="translate(5.79 24.81) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATYAAAEvCAYAAADPZe36AAAACXBIWXMAAC4jAAAuIwF4pT92AAADFklEQVR4nO3bwW4cRRSG0c92AnEMKBCJDUgwS7//w3g5D4AIBIidjO0ZFlVDLBSExLRtJZwjXbW6NYtalH7dvjVdAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwCfq6LEXwMfvYr3a76O7+2lXdb5a7x5+RfzfCTYOMkPtqDquTua1alvdzquQ40E9eewF8NE7agTa59Vp9dl8fl1t5vWmur1Yr7bVTsBx33Rs/GezWztuhNpX1dfVl42g21RX1eWst/PZ7SxdHPdGx8ahjhr76LT6pvq2et54Bb2sfq9ez/qj9wH3Vxcn3FiaYGMJd+dpJ9UX1bNGV3bVCLVfql+r36o3jdC7qjbCjaUd//tP4MNmGG0b3ddl9ar6qfp53ledNbq476sfqh+r76qXjc7uaUYiLEzHxqF2jQOCN/P+uvH6+aIxbztrzOBOGnO403lf9W7WzcV65VCBxQg2DnK+Wu/maeem0b1tGrO0V42O7GzW80ag7ffc8Z2CRQk2DnYn3K4bs7Z3jQ7uaSPMnjU6tf3fQba9P0i4aZ6QwlLMNljU375C2P9p90kj5PZVIwSvGiF4e75abx94qXzCBBv35h9C7oNfJpivsSTBxoPwPSkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMCj+xMu64lNmizFHwAAAABJRU5ErkJggg=="
          />
          <image
            width="311"
            height="302"
            transform="translate(6.63 27.27) scale(.24)"
            href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATUAAAEtCAYAAABpmvfyAAAACXBIWXMAAC4jAAAuIwF4pT92AAACq0lEQVR4nO3azWoUQRSG4Xcmxn9UvINZ5v4vJsu5AEFEJXGMk3HR3XQSJGpmTIg8DxRF072oRfFxTlcVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwJ4uHXgCP3+l6Ne2jm/Ov7K7OJ6v17pZv4a8JNfYyBtqiWlZH45ie6/oe241jW/0Y551g45CePPQCePQWDUH2tHpePauOG/bWFHCL5kC7qL5VZ+N80Vy9wd5UatzZWKUtGwLtVfVmHK+rFw0BNwVbDdXZefWp+jDOZ9VWtcahqNTY1xRsx9XL6m31vnrXEG5Px/dTlfalIew2zdXa9t5XzX9r+ftP4Fa76rK5rTxvbiu3aS25Zyo17uxktd6drle75rZy0RBkm+prQ0s6VWp1vf38XH1vCEQ4GKHGvqbTzE3XA+1jQ6AdNbefNw8KNtWl/2kckoMC9nbjntrVqx3L5tPPcqWDeyDUOKg/uIjr8i0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/9hP0JdityxhsZYAAAAASUVORK5CYII="
          />
        </g>
        <image
          width="359"
          height="347"
          transform="translate(47.29 33.75) scale(.24)"
          href="data:image/png;base64,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"
        />
        <path
          d="m47.28,41.18s.32,2.2.24,2.91c0,0,.3.7.96.65,0,0-.14,2.41,1.48,2.27,0,0-.38,2.75,1.35,1.98,0,0-.59,2.96,1.6,2.1,0,0-.04,3.86,2.5.26,0,0,1,4.27,3.06-1.62l.32-.92s-.63-.53-.39-1.41c0,0-.43-.87-.02-1.33,0,0-.59-.82.03-1.41"
          fill="url(#linear-gradient-71)"
          opacity=".8"
          strokeWidth="0"
        />
        <path
          d="m47.34,41.4l.31,2.8s.18.45.83.51c0,0,.05-.89.11-1.27.06-.37-.18-1.01-1.25-2.04Z"
          fill="url(#Fade_to_Black-50)"
          strokeWidth="0"
        />
        <path
          d="m48.56,43.71s-.41,3.28,1.36,3.26l.16-1.34s-.19-1.86-1.46-2.34"
          fill="url(#Fade_to_Black-51)"
          strokeWidth="0"
        />
        <path
          d="m50,46.4s-.42,3.74,1.37,2.48c0,0,.12-.67.22-1.01,0,0,.11-1.27-1.49-2.27l-.1.8Z"
          fill="url(#Fade_to_Black-52)"
          strokeWidth="0"
        />
        <path
          d="m53.2,49.33s.04-.4-1.62-1.39c0,0-.91,3.19.52,3.19l.79-.12s.17-1.5.31-1.69Z"
          fill="url(#Fade_to_Black-53)"
          strokeWidth="0"
        />
        <path
          d="m55.39,49.94c-.03.27-.03,1.28-.03,1.28-.54,1.69-1.45,1.65-1.45,1.65-1.53-.06-.8-3.16-.8-3.16l.09-.39s1.26,1.28,2.19.61"
          fill="url(#linear-gradient-72)"
          strokeWidth="0"
        />
        <path
          d="m55.39,49.94s-.14,2.82,1,2.98c0,0,1.5.26,2.23-3.89,0,0-1.65,2.63-3.23.91Z"
          fill="url(#linear-gradient-73)"
          strokeWidth="0"
        />
        <g clipPath="url(#clippath-2)">
          <image
            width="347"
            height="350"
            transform="translate(11.39 4.99) scale(.24)"
            href="data:image/png;base64,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"
          />
        </g>
        <path
          d="m57.53,52.03c-.45.57-1.97,2.16-2.16-2.14,0,0-.1.55-.08,1.2-.19.53-.71,1.71-1.51,1.65,0,0-1.23.05-.56-3.38,0,0-.27.74-.38,1.57-.43.19-2.18.75-1.25-3.04,0,0-.14.4-.25.94-.15.13-1.64,1.33-1.35-2.51,0,0-.04.23-.07.57-.24.05-1.58.18-1.35-3.24,0,0-.08.4-.12.93-.15,0-.8-.06-.85-1.2,0,0-.14-1.87-.31-2.16,0,0,.14,1.62.08,2.27-.05.63.08,1.28,1.06,1.43-.01,1.03.22,2.28,1.46,2.24-.08,1.12,0,2.88,1.38,2.02-.2,1.19-.16,2.68,1.53,2.05-.07.86.07,1.73.89,1.9,0,0,1.15.1,1.64-1.47.1.69.39,1.34,1.08,1.46,0,0,.51,0,.89-.46.85-.9,1.18-3,1.18-3-.3,1.17-.64,1.91-.96,2.38Z"
          fill="#231f20"
          strokeWidth="0"
        />
        <g clipPath="url(#clippath-3)">
          <g>
            <g>
              <g>
                <use
                  transform="translate(48.61 15.5) scale(.24)"
                  href="#image-8"
                />
              </g>
              <g>
                <use
                  transform="translate(82.55 -15.14) scale(.24)"
                  href="#image-7"
                />
              </g>
            </g>
            <g opacity=".8">
              <use
                transform="translate(26.65 21.66) scale(.24)"
                href="#image-4"
              />
            </g>
            <g opacity=".5">
              <use
                transform="translate(26.65 21.66) scale(.24)"
                href="#image-4"
              />
            </g>
            <g>
              <image
                width="373"
                height="335"
                transform="translate(26.74 23.96) scale(.24)"
                href="data:image/png;base64,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"
              />
            </g>
            <g>
              <image
                width="373"
                height="335"
                transform="translate(26.68 23.89) scale(.24)"
                href="data:image/png;base64,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"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </>
);
